( () => {
    var e = {
        344: e => {
            var t, s, i;
            t = window,
            s = 0,
            i = function e(t, i) {
                var n = this
                  , a = this
                  , r = !1;
                if (Array.isArray(t))
                    return !!t.length && t.map((function(t) {
                        return new e(t,i)
                    }
                    ));
                var o = {
                    init: function() {
                        this.options = Object.assign({
                            duration: 600,
                            ariaEnabled: !0,
                            collapse: !0,
                            showMultiple: !1,
                            onlyChildNodes: !0,
                            openOnInit: [],
                            elementClass: "ac",
                            triggerClass: "ac-trigger",
                            panelClass: "ac-panel",
                            activeClass: "is-active",
                            beforeOpen: function() {},
                            onOpen: function() {},
                            beforeClose: function() {},
                            onClose: function() {}
                        }, i);
                        var e = "string" == typeof t;
                        this.container = e ? document.querySelector(t) : t,
                        this.createDefinitions(),
                        a.attachEvents()
                    },
                    createDefinitions: function() {
                        var e = this
                          , t = this.options
                          , i = t.elementClass
                          , n = t.openOnInit
                          , a = t.onlyChildNodes ? this.container.childNodes : this.container.querySelectorAll(d(i));
                        this.elements = Array.from(a).filter((function(e) {
                            return e.classList && e.classList.contains(i)
                        }
                        )),
                        this.firstElement = this.elements[0],
                        this.lastElement = this.elements[this.elements.length - 1],
                        this.elements.filter((function(e) {
                            return !e.classList.contains("js-enabled")
                        }
                        )).forEach((function(t) {
                            t.classList.add("js-enabled"),
                            e.generateIDs(t),
                            e.setARIA(t),
                            e.setTransition(t);
                            var i = e.elements.indexOf(t);
                            s++,
                            n.includes(i) ? e.showElement(t, !1) : e.closeElement(t, !1)
                        }
                        ))
                    },
                    setTransition: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                          , s = this.options
                          , i = s.duration
                          , n = s.panelClass
                          , a = e.querySelector(d(n))
                          , r = l("transitionDuration");
                        a.style[r] = t ? null : "".concat(i, "ms")
                    },
                    generateIDs: function(e) {
                        var t = this.options
                          , i = t.triggerClass
                          , n = t.panelClass
                          , a = e.querySelector(d(i))
                          , r = e.querySelector(d(n));
                        e.setAttribute("id", e.id || "ac-".concat(s)),
                        a.setAttribute("id", a.id || "ac-trigger-".concat(s)),
                        r.setAttribute("id", r.id || "ac-panel-".concat(s))
                    },
                    removeIDs: function(e) {
                        var t = this.options
                          , s = t.triggerClass
                          , i = t.panelClass
                          , n = e.querySelector(d(s))
                          , a = e.querySelector(d(i));
                        e.id.startsWith("ac-") && e.removeAttribute("id"),
                        n.id.startsWith("ac-") && n.removeAttribute("id"),
                        a.id.startsWith("ac-") && a.removeAttribute("id")
                    },
                    setARIA: function(e) {
                        var t = this.options
                          , s = t.ariaEnabled
                          , i = t.triggerClass
                          , n = t.panelClass;
                        if (s) {
                            var a = e.querySelector(d(i))
                              , r = e.querySelector(d(n));
                            a.setAttribute("role", "button"),
                            a.setAttribute("aria-controls", r.id),
                            a.setAttribute("aria-disabled", !1),
                            a.setAttribute("aria-expanded", !1),
                            r.setAttribute("role", "region"),
                            r.setAttribute("aria-labelledby", a.id)
                        }
                    },
                    updateARIA: function(e, t) {
                        var s = t.ariaExpanded
                          , i = t.ariaDisabled
                          , n = this.options
                          , a = n.ariaEnabled
                          , r = n.triggerClass;
                        if (a) {
                            var o = e.querySelector(d(r));
                            o.setAttribute("aria-expanded", s),
                            o.setAttribute("aria-disabled", i)
                        }
                    },
                    removeARIA: function(e) {
                        var t = this.options
                          , s = t.ariaEnabled
                          , i = t.triggerClass
                          , n = t.panelClass;
                        if (s) {
                            var a = e.querySelector(d(i))
                              , r = e.querySelector(d(n));
                            a.removeAttribute("role"),
                            a.removeAttribute("aria-controls"),
                            a.removeAttribute("aria-disabled"),
                            a.removeAttribute("aria-expanded"),
                            r.removeAttribute("role"),
                            r.removeAttribute("aria-labelledby")
                        }
                    },
                    focus: function(e, t) {
                        e.preventDefault();
                        var s = this.options.triggerClass;
                        t.querySelector(d(s)).focus()
                    },
                    focusFirstElement: function(e) {
                        this.focus(e, this.firstElement),
                        this.currFocusedIdx = 0
                    },
                    focusLastElement: function(e) {
                        this.focus(e, this.lastElement),
                        this.currFocusedIdx = this.elements.length - 1
                    },
                    focusNextElement: function(e) {
                        var t = this.currFocusedIdx + 1;
                        if (t > this.elements.length - 1)
                            return this.focusFirstElement(e);
                        this.focus(e, this.elements[t]),
                        this.currFocusedIdx = t
                    },
                    focusPrevElement: function(e) {
                        var t = this.currFocusedIdx - 1;
                        if (t < 0)
                            return this.focusLastElement(e);
                        this.focus(e, this.elements[t]),
                        this.currFocusedIdx = t
                    },
                    showElement: function(e) {
                        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]
                          , s = this.options
                          , i = s.panelClass
                          , n = s.activeClass
                          , a = s.collapse
                          , r = s.beforeOpen;
                        t && r(e);
                        var o = e.querySelector(d(i))
                          , l = o.scrollHeight;
                        e.classList.add(n),
                        requestAnimationFrame((function() {
                            requestAnimationFrame((function() {
                                o.style.height = t ? "".concat(l, "px") : "auto"
                            }
                            ))
                        }
                        )),
                        this.updateARIA(e, {
                            ariaExpanded: !0,
                            ariaDisabled: !a
                        })
                    },
                    closeElement: function(e) {
                        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]
                          , s = this.options
                          , i = s.panelClass
                          , n = s.activeClass
                          , a = s.beforeClose
                          , r = e.querySelector(d(i))
                          , o = r.scrollHeight;
                        e.classList.remove(n),
                        t ? (a(e),
                        requestAnimationFrame((function() {
                            r.style.height = "".concat(o, "px"),
                            requestAnimationFrame((function() {
                                r.style.height = 0
                            }
                            ))
                        }
                        ))) : r.style.height = 0,
                        this.updateARIA(e, {
                            ariaExpanded: !1,
                            ariaDisabled: !1
                        })
                    },
                    toggleElement: function(e) {
                        var t = this.options
                          , s = t.activeClass
                          , i = t.collapse
                          , n = e.classList.contains(s);
                        if (!n || i)
                            return n ? this.closeElement(e) : this.showElement(e)
                    },
                    closeElements: function() {
                        var e = this
                          , t = this.options
                          , s = t.activeClass;
                        t.showMultiple || this.elements.forEach((function(t, i) {
                            t.classList.contains(s) && i !== e.currFocusedIdx && e.closeElement(t)
                        }
                        ))
                    },
                    handleClick: function(e) {
                        var t = this
                          , s = e.currentTarget;
                        this.elements.forEach((function(i, n) {
                            i.contains(s) && "A" !== e.target.nodeName && (t.currFocusedIdx = n,
                            t.closeElements(),
                            t.focus(e, i),
                            t.toggleElement(i))
                        }
                        ))
                    },
                    handleKeydown: function(e) {
                        switch (e.key) {
                        case "ArrowUp":
                            return this.focusPrevElement(e);
                        case "ArrowDown":
                            return this.focusNextElement(e);
                        case "Home":
                            return this.focusFirstElement(e);
                        case "End":
                            return this.focusLastElement(e);
                        default:
                            return null
                        }
                    },
                    handleFocus: function(e) {
                        var t = e.currentTarget
                          , s = this.elements.find((function(e) {
                            return e.contains(t)
                        }
                        ));
                        this.currFocusedIdx = this.elements.indexOf(s)
                    },
                    handleTransitionEnd: function(e) {
                        if (e.stopPropagation(),
                        "height" === e.propertyName) {
                            var t = this.options
                              , s = t.onOpen
                              , i = t.onClose
                              , n = e.currentTarget
                              , a = parseInt(n.style.height)
                              , r = this.elements.find((function(e) {
                                return e.contains(n)
                            }
                            ));
                            a > 0 ? (n.style.height = "auto",
                            s(r)) : i(r)
                        }
                    }
                };
                this.attachEvents = function() {
                    if (!r) {
                        var e = o.options
                          , t = e.triggerClass
                          , s = e.panelClass;
                        o.handleClick = o.handleClick.bind(o),
                        o.handleKeydown = o.handleKeydown.bind(o),
                        o.handleFocus = o.handleFocus.bind(o),
                        o.handleTransitionEnd = o.handleTransitionEnd.bind(o),
                        o.elements.forEach((function(e) {
                            var i = e.querySelector(d(t))
                              , n = e.querySelector(d(s));
                            i.addEventListener("click", o.handleClick),
                            i.addEventListener("keydown", o.handleKeydown),
                            i.addEventListener("focus", o.handleFocus),
                            n.addEventListener("webkitTransitionEnd", o.handleTransitionEnd),
                            n.addEventListener("transitionend", o.handleTransitionEnd)
                        }
                        )),
                        r = !0
                    }
                }
                ,
                this.detachEvents = function() {
                    if (r) {
                        var e = o.options
                          , t = e.triggerClass
                          , s = e.panelClass;
                        o.elements.forEach((function(e) {
                            var i = e.querySelector(d(t))
                              , n = e.querySelector(d(s));
                            i.removeEventListener("click", o.handleClick),
                            i.removeEventListener("keydown", o.handleKeydown),
                            i.removeEventListener("focus", o.handleFocus),
                            n.removeEventListener("webkitTransitionEnd", o.handleTransitionEnd),
                            n.removeEventListener("transitionend", o.handleTransitionEnd)
                        }
                        )),
                        r = !1
                    }
                }
                ,
                this.toggle = function(e) {
                    var t = o.elements[e];
                    t && o.toggleElement(t)
                }
                ,
                this.open = function(e) {
                    var t = o.elements[e];
                    t && o.showElement(t)
                }
                ,
                this.openAll = function() {
                    var e = o.options
                      , t = e.activeClass
                      , s = e.onOpen;
                    o.elements.forEach((function(e) {
                        e.classList.contains(t) || (o.showElement(e, !1),
                        s(e))
                    }
                    ))
                }
                ,
                this.close = function(e) {
                    var t = o.elements[e];
                    t && o.closeElement(t)
                }
                ,
                this.closeAll = function() {
                    var e = o.options
                      , t = e.activeClass
                      , s = e.onClose;
                    o.elements.forEach((function(e) {
                        e.classList.contains(t) && (o.closeElement(e, !1),
                        s(e))
                    }
                    ))
                }
                ,
                this.destroy = function() {
                    n.detachEvents(),
                    n.openAll(),
                    o.elements.forEach((function(e) {
                        o.removeIDs(e),
                        o.removeARIA(e),
                        o.setTransition(e, !0)
                    }
                    )),
                    r = !0
                }
                ,
                this.update = function() {
                    o.createDefinitions(),
                    n.detachEvents(),
                    n.attachEvents()
                }
                ;
                var l = function(e) {
                    return "string" == typeof document.documentElement.style[e] ? e : (e = c(e),
                    e = "webkit".concat(e))
                }
                  , c = function(e) {
                    return e.charAt(0).toUpperCase() + e.slice(1)
                }
                  , d = function(e) {
                    return ".".concat(CSS.escape(e))
                };
                o.init()
            }
            ,
            void 0 !== e.exports ? e.exports = i : t.Accordion = i
        }
        ,
        232: () => {
            const e = document.querySelector(".footer-brand")
              , t = () => {
                footerBrandHeight = e.clientHeight,
                document.documentElement.style.setProperty("--footer-height", footerBrandHeight + "px"),
                document.documentElement.style.setProperty("--mobile-footer-height", footerBrandHeight + "px")
            }
            ;
            t(),
            window.addEventListener("resize", t, {
                passive: !0
            }),
            window.addEventListener("scroll", t, {
                passive: !0
            })
        }
        ,
        96: () => {
            if (null !== document.querySelector(".link-bg-text")) {
                let e = 0;
                document.querySelectorAll(".link-bg-text").forEach((t => {
                    const s = t.closest(".link-bg-container").querySelector(".link-bg");
                    let i = !1;
                    const n = t.closest(".link-bg-text-container");
                    t.addEventListener("mouseenter", ( () => {
                        i = !0;
                        var n = t.getBoundingClientRect()
                          , a = "translate(" + (n.width / 2 + n.left) + "px," + (t.offsetTop + n.height / 2) + "px)"
                          , r = "scale(" + (n.width + 18) + ", " + (n.height + 6) + ")";
                        0 === e ? s.style.transition = "none" : (s.style.transition = ".3s",
                        s.classList.remove("invisible")),
                        s.style.transform = `${a} ${r}`,
                        e++
                    }
                    )),
                    n.addEventListener("mouseleave", ( () => {
                        setTimeout(( () => {
                            i = !1,
                            e = 0,
                            i || s.classList.add("invisible")
                        }
                        ), 250)
                    }
                    )),
                    n.addEventListener("mousemove", ( () => {
                        i = !0,
                        s.classList.remove("invisible")
                    }
                    ))
                }
                ))
            }
        }
        ,
        30: () => {
            if (null !== document.querySelector(".customers-login")) {
                const s = {
                    recoverPasswordFormTriggers: "[data-recover-toggle]",
                    recoverPasswordForm: "[data-recover-form]",
                    loginForm: "[data-login-form]",
                    formState: "[data-form-state]",
                    resetSuccess: "[data-reset-success]"
                };
                function e(e) {
                    e.preventDefault(),
                    t()
                }
                function t() {
                    console.log("clicked"),
                    document.querySelector(s.recoverPasswordForm).classList.toggle("hidden"),
                    document.querySelector(s.loginForm).classList.toggle("hidden")
                }
                document.querySelector(s.recoverPasswordForm) && ("#recover" === window.location.hash && t(),
                document.querySelector(s.formState) && document.querySelector(s.resetSuccess).classList.remove("hidden"),
                document.querySelectorAll(s.recoverPasswordFormTriggers).forEach((t => {
                    t.addEventListener("click", e)
                }
                )))
            }
        }
        ,
        619: () => {
            null !== document.querySelector(".navigator-share") && document.querySelectorAll(".navigator-share").forEach((e => {
                let t;
                e.addEventListener("click", (async s => {
                    s.preventDefault();
                    const i = {
                        title: e.getAttribute("data-title"),
                        text: e.getAttribute("data-excerpt"),
                        url: e.href
                    };
                    try {
                        await navigator.share(i),
                        console.log("shared successfully")
                    } catch (s) {
                        if (console.log(s),
                        !navigator.clipboard)
                            return;
                        const i = e.href;
                        try {
                            await navigator.clipboard.writeText(i),
                            console.log(`Copied - ${i}`),
                            e.nextElementSibling.classList.remove("invisible"),
                            e.nextElementSibling.classList.remove("translate-y-4"),
                            window.clearTimeout(t),
                            t = window.setTimeout((function() {
                                e.nextElementSibling.classList.add("invisible"),
                                e.nextElementSibling.classList.add("translate-y-4")
                            }
                            ), 1e3)
                        } catch (e) {
                            console.error("Failed to copy!", e)
                        }
                    }
                }
                ))
            }
            ))
        }
        ,
        794: () => {
            if (null !== document.querySelector(".rte")) {
                document.querySelectorAll(".rte").forEach((e => {
                    null !== e.querySelector("p") && e.querySelectorAll("p").forEach((e => {
                        e.textContent.length < 2 && e.classList.add("empty")
                    }
                    ))
                }
                ))
            }
        }
        ,
        66: () => {
            window.subToggle = function(e, t) {
                var s = document.getElementById(e);
                s.classList.add("toggled"),
                s.style.display = "block",
                document.querySelectorAll(".subscription-toggle--active").forEach((e => {
                    e.classList.remove("subscription-toggle--active")
                }
                )),
                t.parentNode.classList.add("subscription-toggle--active")
            }
            ,
            window.subToggleOneTime = function(e, t) {
                document.getElementById(e).style.display = "none",
                document.querySelectorAll(".subscription-toggle--active").forEach((e => {
                    e.classList.remove("subscription-toggle--active")
                }
                )),
                t.parentNode.classList.add("subscription-toggle--active")
            }
            ,
            window.closeModal = function(e) {
                document.getElementById(e).style.display = "none"
            }
            ,
            document.onkeydown = function(e) {
                if ("Escape" === e.key) {
                    let e = document.getElementsByClassName("modal");
                    Array.from(e).forEach((e => {
                        e.style.display = "none"
                    }
                    ))
                }
            }
            ,
            window.frequencyToggle = function(e) {
                document.querySelectorAll(".subscription-frequency-toggle--active").forEach((e => {
                    e.classList.remove("subscription-frequency-toggle--active")
                }
                )),
                e.parentNode.classList.add("subscription-frequency-toggle--active")
            }
        }
        ,
        478: () => {
            window.Element && !Element.prototype.closest && (Element.prototype.closest = function(e) {
                var t, s = (this.document || this.ownerDocument).querySelectorAll(e), i = this;
                do {
                    for (t = s.length; --t >= 0 && s.item(t) !== i; )
                        ;
                } while (t < 0 && (i = i.parentElement));
                return i
            }
            )
        }
        ,
        145: () => {
            window.ClassWatcher = class {
                constructor(e, t, s, i) {
                    this.targetNode = e,
                    this.classToWatch = t,
                    this.classAddedCallback = s,
                    this.classRemovedCallback = i,
                    this.observer = null,
                    this.lastClassState = e.classList.contains(this.classToWatch),
                    this.init()
                }
                init() {
                    this.observer = new MutationObserver(this.mutationCallback),
                    this.observe()
                }
                observe() {
                    this.observer.observe(this.targetNode, {
                        attributes: !0
                    })
                }
                disconnect() {
                    this.observer.disconnect()
                }
                mutationCallback = e => {
                    for (let t of e)
                        if ("attributes" === t.type && "class" === t.attributeName) {
                            let e = t.target.classList.contains(this.classToWatch);
                            this.lastClassState !== e && (this.lastClassState = e,
                            e ? this.classAddedCallback() : this.classRemovedCallback())
                        }
                }
            }
        }
        ,
        841: () => {
            var e = document.links;
            for (let t = 0, s = e.length; t < s; t++)
                e[t].hostname !== window.location.hostname && (e[t].target = "_blank",
                e[t].rel = "noreferrer noopener")
        }
        ,
        855: () => {
            window.isMobile = function() {
                let e = !1;
                var t;
                return t = navigator.userAgent || navigator.vendor || window.opera,
                (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0),
                e
            }
            ,
            navigator.maxTouchPoints > 1 && document.body.classList.add("touchpoints")
        }
        ,
        219: () => {
            if (window.CSS?.supports?.("(font:-apple-system-body) and (-webkit-touch-callout:none) and (-webkit-tap-highlight-color:hotpink)")) {
                const e = document.querySelector('meta[name="viewport"]');
                null !== e && (e.content = `${e.content},user-scalable=no`)
            }
        }
        ,
        76: e => {
            var t = /^(?:submit|button|image|reset|file)$/i
              , s = /^(?:input|select|textarea|keygen)/i
              , i = /(\[[^\[\]]*\])/g;
            function n(e, t, s) {
                if (0 === t.length)
                    return e = s;
                var i = t.shift()
                  , a = i.match(/^\[(.+?)\]$/);
                if ("[]" === i)
                    return e = e || [],
                    Array.isArray(e) ? e.push(n(null, t, s)) : (e._values = e._values || [],
                    e._values.push(n(null, t, s))),
                    e;
                if (a) {
                    var r = a[1]
                      , o = +r;
                    isNaN(o) ? (e = e || {})[r] = n(e[r], t, s) : (e = e || [])[o] = n(e[o], t, s)
                } else
                    e[i] = n(e[i], t, s);
                return e
            }
            function a(e, t, s) {
                if (t.match(i)) {
                    n(e, function(e) {
                        var t = []
                          , s = new RegExp(i)
                          , n = /^([^\[\]]*)/.exec(e);
                        for (n[1] && t.push(n[1]); null !== (n = s.exec(e)); )
                            t.push(n[1]);
                        return t
                    }(t), s)
                } else {
                    var a = e[t];
                    a ? (Array.isArray(a) || (e[t] = [a]),
                    e[t].push(s)) : e[t] = s
                }
                return e
            }
            function r(e, t, s) {
                return s = s.replace(/(\r)?\n/g, "\r\n"),
                s = (s = encodeURIComponent(s)).replace(/%20/g, "+"),
                e + (e ? "&" : "") + encodeURIComponent(t) + "=" + s
            }
            e.exports = function(e, i) {
                "object" != typeof i ? i = {
                    hash: !!i
                } : void 0 === i.hash && (i.hash = !0);
                for (var n = i.hash ? {} : "", o = i.serializer || (i.hash ? a : r), l = e && e.elements ? e.elements : [], c = Object.create(null), d = 0; d < l.length; ++d) {
                    var u = l[d];
                    if ((i.disabled || !u.disabled) && u.name && (s.test(u.nodeName) && !t.test(u.type))) {
                        var p = u.name
                          , h = u.value;
                        if ("checkbox" !== u.type && "radio" !== u.type || u.checked || (h = void 0),
                        i.empty) {
                            if ("checkbox" !== u.type || u.checked || (h = ""),
                            "radio" === u.type && (c[u.name] || u.checked ? u.checked && (c[u.name] = !0) : c[u.name] = !1),
                            null == h && "radio" == u.type)
                                continue
                        } else if (!h)
                            continue;
                        if ("select-multiple" !== u.type)
                            n = o(n, p, h);
                        else {
                            h = [];
                            for (var m = u.options, f = !1, g = 0; g < m.length; ++g) {
                                var v = m[g]
                                  , y = i.empty && !v.value
                                  , b = v.value || y;
                                v.selected && b && (f = !0,
                                n = i.hash && "[]" !== p.slice(p.length - 2) ? o(n, p + "[]", v.value) : o(n, p, v.value))
                            }
                            !f && i.empty && (n = o(n, p, ""))
                        }
                    }
                }
                if (i.empty)
                    for (var p in c)
                        c[p] || (n = o(n, p, ""));
                return n
            }
        }
        ,
        372: function(e) {
            e.exports = function() {
                "use strict";
                function e(s) {
                    var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
                    if (!(this instanceof e))
                        return new (Function.prototype.bind.apply(e, [null].concat(Array.prototype.slice.call(arguments))));
                    this.element = s,
                    this.startOffset = t(i.startOffset, s && s.offsetHeight),
                    this.tolerance = t(i.tolerance, 8),
                    this.showAtBottom = t(i.showAtBottom, !0),
                    this.classNames = i.classNames || {
                        base: "headspace",
                        fixed: "headspace--fixed",
                        hidden: "headspace--hidden"
                    },
                    this._scrollLast = 0,
                    "undefined" != typeof window && this.init()
                }
                function t(e, t) {
                    return void 0 !== e ? e : t
                }
                function s(e) {
                    var t = window.pageYOffset
                      , s = e._scrollLast;
                    t <= 0 ? e.reset() : e.showAtBottom && window.innerHeight + t >= document.body.offsetHeight ? e.fix() : t > e.startOffset && Math.abs(t - s) >= e.tolerance && e[t > s ? "hide" : "fix"](),
                    e._scrollLast = t
                }
                return e.prototype = {
                    init: function() {
                        var e = this;
                        this.addClass(this.classNames.base),
                        window.addEventListener("scroll", (function() {
                            return e.debounce((function() {
                                return s(e)
                            }
                            ))
                        }
                        ))
                    },
                    reset: function() {
                        var e = this.classNames;
                        this.removeClass(e.fixed, e.hidden)
                    },
                    fix: function() {
                        var e = this.classNames;
                        this.addClass(e.fixed),
                        this.removeClass(e.hidden)
                    },
                    hide: function() {
                        this.addClass(this.classNames.hidden)
                    },
                    addClass: function() {
                        var e;
                        (e = this.element.classList).add.apply(e, arguments)
                    },
                    removeClass: function() {
                        var e;
                        (e = this.element.classList).remove.apply(e, arguments)
                    },
                    debounce: function(e) {
                        window.requestAnimationFrame(e)
                    }
                },
                e.isSupported = function() {
                    return !("undefined" == typeof window || !window.requestAnimationFrame || !("classList"in document.documentElement))
                }
                ,
                e
            }()
        },
        139: function(e) {
            e.exports = function() {
                "use strict";
                var e = {
                    required: "This field is required",
                    email: "This field requires a valid e-mail address",
                    number: "This field requires a number",
                    integer: "This field requires an integer value",
                    url: "This field requires a valid website URL",
                    tel: "This field requires a valid telephone number",
                    maxlength: "This fields length must be < ${1}",
                    minlength: "This fields length must be > ${1}",
                    min: "Minimum value for this field is ${1}",
                    max: "Maximum value for this field is ${1}",
                    pattern: "Please match the requested format"
                };
                function t(e, t) {
                    for (; (e = e.parentElement) && !e.classList.contains(t); )
                        ;
                    return e
                }
                function s(e) {
                    var t = arguments;
                    return this.replace(/\${([^{}]*)}/g, (function(e, s) {
                        return t[s]
                    }
                    ))
                }
                function i(e) {
                    return e.pristine.self.form.querySelectorAll('input[name="' + e.getAttribute("name") + '"]:checked').length
                }
                function n(e, t) {
                    for (var s in t)
                        s in e || (e[s] = t[s]);
                    return e
                }
                function a(e) {
                    return !!(e && e.constructor && e.call && e.apply)
                }
                var r = {
                    classTo: "form-group",
                    errorClass: "has-danger",
                    successClass: "has-success",
                    errorTextParent: "form-group",
                    errorTextTag: "div",
                    errorTextClass: "text-help"
                }
                  , o = "pristine-error"
                  , l = "input:not([type^=hidden]):not([type^=submit]), select, textarea"
                  , c = ["required", "min", "max", "minlength", "maxlength", "pattern"]
                  , d = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  , u = {}
                  , p = function(t, s) {
                    s.name = t,
                    s.msg || (s.msg = e[t]),
                    void 0 === s.priority && (s.priority = 1),
                    u[t] = s
                };
                function h(e, i, d) {
                    var p = this;
                    function h(e, t, s) {
                        e.setAttribute("novalidate", "true"),
                        p.form = e,
                        p.config = n(t || {}, r),
                        p.live = !(!1 === s),
                        p.fields = Array.from(e.querySelectorAll(l)).map(function(e) {
                            var t = []
                              , s = {}
                              , i = {};
                            return [].forEach.call(e.attributes, (function(e) {
                                if (/^data-pristine-/.test(e.name)) {
                                    var n = e.name.substr(14);
                                    if (n.endsWith("-message"))
                                        return void (i[n.slice(0, n.length - 8)] = e.value);
                                    "type" === n && (n = e.value),
                                    m(t, s, n, e.value)
                                } else
                                    ~c.indexOf(e.name) ? m(t, s, e.name, e.value) : "type" === e.name && m(t, s, e.value)
                            }
                            )),
                            t.sort((function(e, t) {
                                return t.priority - e.priority
                            }
                            )),
                            p.live && e.addEventListener(~["radio", "checkbox"].indexOf(e.getAttribute("type")) ? "change" : "input", function(e) {
                                p.validate(e.target)
                            }
                            .bind(p)),
                            e.pristine = {
                                input: e,
                                validators: t,
                                params: s,
                                messages: i,
                                self: p
                            }
                        }
                        .bind(p))
                    }
                    function m(e, t, s, i) {
                        var n = u[s];
                        if (n && (e.push(n),
                        i)) {
                            var a = i.split(",");
                            a.unshift(null),
                            t[s] = a
                        }
                    }
                    function f(e) {
                        for (var t = [], i = !0, n = 0; e.validators[n]; n++) {
                            var r = e.validators[n]
                              , o = e.params[r.name] ? e.params[r.name] : [];
                            if (o[0] = e.input.value,
                            !r.fn.apply(e.input, o)) {
                                if (i = !1,
                                a(r.msg))
                                    t.push(r.msg(e.input.value, o));
                                else {
                                    var l = e.messages[r.name] || r.msg;
                                    t.push(s.apply(l, o))
                                }
                                if (!0 === r.halt)
                                    break
                            }
                        }
                        return e.errors = t,
                        i
                    }
                    function g(e) {
                        if (e.errorElements)
                            return e.errorElements;
                        var s = t(e.input, p.config.classTo)
                          , i = null
                          , n = null;
                        return (i = p.config.classTo === p.config.errorTextParent ? s : s.querySelector("." + p.config.errorTextParent)) && ((n = i.querySelector("." + o)) || ((n = document.createElement(p.config.errorTextTag)).className = o + " " + p.config.errorTextClass,
                        i.appendChild(n),
                        n.pristineDisplay = n.style.display)),
                        e.errorElements = [s, n]
                    }
                    function v(e) {
                        var t = g(e)
                          , s = t[0]
                          , i = t[1];
                        s && (s.classList.remove(p.config.successClass),
                        s.classList.add(p.config.errorClass)),
                        i && (i.innerHTML = e.errors.join("<br/>"),
                        i.style.display = i.pristineDisplay || "")
                    }
                    function y(e) {
                        var t = g(e)
                          , s = t[0]
                          , i = t[1];
                        return s && (s.classList.remove(p.config.errorClass),
                        s.classList.remove(p.config.successClass)),
                        i && (i.innerHTML = "",
                        i.style.display = "none"),
                        t
                    }
                    function b(e) {
                        var t = y(e)[0];
                        t && t.classList.add(p.config.successClass)
                    }
                    return h(e, i, d),
                    p.validate = function(e, t) {
                        t = e && !0 === t || !0 === e;
                        var s = p.fields;
                        !0 !== e && !1 !== e && (e instanceof HTMLElement ? s = [e.pristine] : (e instanceof NodeList || e instanceof (window.$ || Array) || e instanceof Array) && (s = Array.from(e).map((function(e) {
                            return e.pristine
                        }
                        ))));
                        for (var i = !0, n = 0; s[n]; n++) {
                            var a = s[n];
                            f(a) ? !t && b(a) : (i = !1,
                            !t && v(a))
                        }
                        return i
                    }
                    ,
                    p.getErrors = function(e) {
                        if (!e) {
                            for (var t = [], s = 0; s < p.fields.length; s++) {
                                var i = p.fields[s];
                                i.errors.length && t.push({
                                    input: i.input,
                                    errors: i.errors
                                })
                            }
                            return t
                        }
                        return e.tagName && "select" === e.tagName.toLowerCase() ? e.pristine.errors : e.length ? e[0].pristine.errors : e.pristine.errors
                    }
                    ,
                    p.addValidator = function(e, t, s, i, n) {
                        e instanceof HTMLElement ? (e.pristine.validators.push({
                            fn: t,
                            msg: s,
                            priority: i,
                            halt: n
                        }),
                        e.pristine.validators.sort((function(e, t) {
                            return t.priority - e.priority
                        }
                        ))) : console.warn("The parameter elem must be a dom element")
                    }
                    ,
                    p.addError = function(e, t) {
                        (e = e.length ? e[0] : e).pristine.errors.push(t),
                        v(e.pristine)
                    }
                    ,
                    p.reset = function() {
                        for (var e = 0; p.fields[e]; e++)
                            p.fields[e].errorElements = null;
                        Array.from(p.form.querySelectorAll("." + o)).map((function(e) {
                            e.parentNode.removeChild(e)
                        }
                        )),
                        Array.from(p.form.querySelectorAll("." + p.config.classTo)).map((function(e) {
                            e.classList.remove(p.config.successClass),
                            e.classList.remove(p.config.errorClass)
                        }
                        ))
                    }
                    ,
                    p.destroy = function() {
                        p.reset(),
                        p.fields.forEach((function(e) {
                            delete e.input.pristine
                        }
                        )),
                        p.fields = []
                    }
                    ,
                    p.setGlobalConfig = function(e) {
                        r = e
                    }
                    ,
                    p
                }
                return p("text", {
                    fn: function(e) {
                        return !0
                    },
                    priority: 0
                }),
                p("required", {
                    fn: function(e) {
                        return "radio" === this.type || "checkbox" === this.type ? i(this) : void 0 !== e && "" !== e
                    },
                    priority: 99,
                    halt: !0
                }),
                p("email", {
                    fn: function(e) {
                        return !e || d.test(e)
                    }
                }),
                p("number", {
                    fn: function(e) {
                        return !e || !isNaN(parseFloat(e))
                    },
                    priority: 2
                }),
                p("integer", {
                    fn: function(e) {
                        return !e || /^\d+$/.test(e)
                    }
                }),
                p("minlength", {
                    fn: function(e, t) {
                        return !e || e.length >= parseInt(t)
                    }
                }),
                p("maxlength", {
                    fn: function(e, t) {
                        return !e || e.length <= parseInt(t)
                    }
                }),
                p("min", {
                    fn: function(e, t) {
                        return !e || ("checkbox" === this.type ? i(this) >= parseInt(t) : parseFloat(e) >= parseFloat(t))
                    }
                }),
                p("max", {
                    fn: function(e, t) {
                        return !e || ("checkbox" === this.type ? i(this) <= parseInt(t) : parseFloat(e) <= parseFloat(t))
                    }
                }),
                p("pattern", {
                    fn: function(e, t) {
                        var s = t.match(new RegExp("^/(.*?)/([gimy]*)$"));
                        return !e || new RegExp(s[1],s[2]).test(e)
                    }
                }),
                h.addValidator = function(e, t, s, i, n) {
                    p(e, {
                        fn: t,
                        msg: s,
                        priority: i,
                        halt: n
                    })
                }
                ,
                h
            }()
        },
        130: function(e) {
            var t;
            t = function() {
                return function(e) {
                    var t = {};
                    function s(i) {
                        if (t[i])
                            return t[i].exports;
                        var n = t[i] = {
                            i,
                            l: !1,
                            exports: {}
                        };
                        return e[i].call(n.exports, n, n.exports, s),
                        n.l = !0,
                        n.exports
                    }
                    return s.m = e,
                    s.c = t,
                    s.d = function(e, t, i) {
                        s.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: i
                        })
                    }
                    ,
                    s.r = function(e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }),
                        Object.defineProperty(e, "__esModule", {
                            value: !0
                        })
                    }
                    ,
                    s.t = function(e, t) {
                        if (1 & t && (e = s(e)),
                        8 & t)
                            return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule)
                            return e;
                        var i = Object.create(null);
                        if (s.r(i),
                        Object.defineProperty(i, "default", {
                            enumerable: !0,
                            value: e
                        }),
                        2 & t && "string" != typeof e)
                            for (var n in e)
                                s.d(i, n, function(t) {
                                    return e[t]
                                }
                                .bind(null, n));
                        return i
                    }
                    ,
                    s.n = function(e) {
                        var t = e && e.__esModule ? function() {
                            return e.default
                        }
                        : function() {
                            return e
                        }
                        ;
                        return s.d(t, "a", t),
                        t
                    }
                    ,
                    s.o = function(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t)
                    }
                    ,
                    s.p = "",
                    s(s.s = 0)
                }([function(e, t, s) {
                    "use strict";
                    s.r(t);
                    var i = function(e) {
                        return Array.isArray(e) ? e : [e]
                    }
                      , n = function(e) {
                        return e instanceof Node
                    }
                      , a = function(e, t) {
                        if (e && t) {
                            e = function(e) {
                                return e instanceof NodeList
                            }(e) ? e : [e];
                            for (var s = 0; s < e.length && !0 !== t(e[s], s, e.length); s++)
                                ;
                        }
                    }
                      , r = function(e) {
                        return console.error("[scroll-lock] ".concat(e))
                    }
                      , o = function(e) {
                        if (Array.isArray(e))
                            return e.join(", ")
                    }
                      , l = function(e) {
                        var t = [];
                        return a(e, (function(e) {
                            return t.push(e)
                        }
                        )),
                        t
                    }
                      , c = function(e, t) {
                        var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : document;
                        if ((!(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]) && -1 !== l(s.querySelectorAll(t)).indexOf(e))
                            return e;
                        for (; (e = e.parentElement) && -1 === l(s.querySelectorAll(t)).indexOf(e); )
                            ;
                        return e
                    }
                      , d = function(e, t) {
                        var s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : document;
                        return -1 !== l(s.querySelectorAll(t)).indexOf(e)
                    }
                      , u = function(e) {
                        if (e)
                            return "hidden" === getComputedStyle(e).overflow
                    }
                      , p = function(e) {
                        if (e)
                            return !!u(e) || e.scrollTop <= 0
                    }
                      , h = function(e) {
                        if (e) {
                            if (u(e))
                                return !0;
                            var t = e.scrollTop
                              , s = e.scrollHeight;
                            return t + e.offsetHeight >= s
                        }
                    }
                      , m = function(e) {
                        if (e)
                            return !!u(e) || e.scrollLeft <= 0
                    }
                      , f = function(e) {
                        if (e) {
                            if (u(e))
                                return !0;
                            var t = e.scrollLeft
                              , s = e.scrollWidth;
                            return t + e.offsetWidth >= s
                        }
                    };
                    function g(e, t, s) {
                        return t in e ? Object.defineProperty(e, t, {
                            value: s,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = s,
                        e
                    }
                    s.d(t, "disablePageScroll", (function() {
                        return b
                    }
                    )),
                    s.d(t, "enablePageScroll", (function() {
                        return w
                    }
                    )),
                    s.d(t, "getScrollState", (function() {
                        return S
                    }
                    )),
                    s.d(t, "clearQueueScrollLocks", (function() {
                        return E
                    }
                    )),
                    s.d(t, "getTargetScrollBarWidth", (function() {
                        return x
                    }
                    )),
                    s.d(t, "getCurrentTargetScrollBarWidth", (function() {
                        return T
                    }
                    )),
                    s.d(t, "getPageScrollBarWidth", (function() {
                        return L
                    }
                    )),
                    s.d(t, "getCurrentPageScrollBarWidth", (function() {
                        return A
                    }
                    )),
                    s.d(t, "addScrollableTarget", (function() {
                        return C
                    }
                    )),
                    s.d(t, "removeScrollableTarget", (function() {
                        return k
                    }
                    )),
                    s.d(t, "addScrollableSelector", (function() {
                        return q
                    }
                    )),
                    s.d(t, "removeScrollableSelector", (function() {
                        return M
                    }
                    )),
                    s.d(t, "addLockableTarget", (function() {
                        return O
                    }
                    )),
                    s.d(t, "addLockableSelector", (function() {
                        return _
                    }
                    )),
                    s.d(t, "setFillGapMethod", (function() {
                        return P
                    }
                    )),
                    s.d(t, "addFillGapTarget", (function() {
                        return I
                    }
                    )),
                    s.d(t, "removeFillGapTarget", (function() {
                        return $
                    }
                    )),
                    s.d(t, "addFillGapSelector", (function() {
                        return B
                    }
                    )),
                    s.d(t, "removeFillGapSelector", (function() {
                        return D
                    }
                    )),
                    s.d(t, "refillGaps", (function() {
                        return N
                    }
                    ));
                    var v = ["padding", "margin", "width", "max-width", "none"]
                      , y = {
                        scroll: !0,
                        queue: 0,
                        scrollableSelectors: ["[data-scroll-lock-scrollable]"],
                        lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
                        fillGapSelectors: ["body", "[data-scroll-lock-fill-gap]", "[data-scroll-lock-lockable]"],
                        fillGapMethod: v[0],
                        startTouchY: 0,
                        startTouchX: 0
                    }
                      , b = function(e) {
                        y.queue <= 0 && (y.scroll = !1,
                        z(),
                        V()),
                        C(e),
                        y.queue++
                    }
                      , w = function(e) {
                        y.queue > 0 && y.queue--,
                        y.queue <= 0 && (y.scroll = !0,
                        F(),
                        W()),
                        k(e)
                    }
                      , S = function() {
                        return y.scroll
                    }
                      , E = function() {
                        y.queue = 0
                    }
                      , x = function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        if (n(e)) {
                            var s = e.style.overflowY;
                            t ? S() || (e.style.overflowY = e.getAttribute("data-scroll-lock-saved-overflow-y-property")) : e.style.overflowY = "scroll";
                            var i = T(e);
                            return e.style.overflowY = s,
                            i
                        }
                        return 0
                    }
                      , T = function(e) {
                        if (n(e)) {
                            if (e === document.body) {
                                var t = document.documentElement.clientWidth;
                                return window.innerWidth - t
                            }
                            var s = e.style.borderLeftWidth
                              , i = e.style.borderRightWidth;
                            e.style.borderLeftWidth = "0px",
                            e.style.borderRightWidth = "0px";
                            var a = e.offsetWidth - e.clientWidth;
                            return e.style.borderLeftWidth = s,
                            e.style.borderRightWidth = i,
                            a
                        }
                        return 0
                    }
                      , L = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        return x(document.body, e)
                    }
                      , A = function() {
                        return T(document.body)
                    }
                      , C = function(e) {
                        e && i(e).map((function(e) {
                            a(e, (function(e) {
                                n(e) ? e.setAttribute("data-scroll-lock-scrollable", "") : r('"'.concat(e, '" is not a Element.'))
                            }
                            ))
                        }
                        ))
                    }
                      , k = function(e) {
                        e && i(e).map((function(e) {
                            a(e, (function(e) {
                                n(e) ? e.removeAttribute("data-scroll-lock-scrollable") : r('"'.concat(e, '" is not a Element.'))
                            }
                            ))
                        }
                        ))
                    }
                      , q = function(e) {
                        e && i(e).map((function(e) {
                            y.scrollableSelectors.push(e)
                        }
                        ))
                    }
                      , M = function(e) {
                        e && i(e).map((function(e) {
                            y.scrollableSelectors = y.scrollableSelectors.filter((function(t) {
                                return t !== e
                            }
                            ))
                        }
                        ))
                    }
                      , O = function(e) {
                        e && (i(e).map((function(e) {
                            a(e, (function(e) {
                                n(e) ? e.setAttribute("data-scroll-lock-lockable", "") : r('"'.concat(e, '" is not a Element.'))
                            }
                            ))
                        }
                        )),
                        S() || z())
                    }
                      , _ = function(e) {
                        e && (i(e).map((function(e) {
                            y.lockableSelectors.push(e)
                        }
                        )),
                        S() || z(),
                        B(e))
                    }
                      , P = function(e) {
                        if (e)
                            if (-1 !== v.indexOf(e))
                                y.fillGapMethod = e,
                                N();
                            else {
                                var t = v.join(", ");
                                r('"'.concat(e, '" method is not available!\nAvailable fill gap methods: ').concat(t, "."))
                            }
                    }
                      , I = function(e) {
                        e && i(e).map((function(e) {
                            a(e, (function(e) {
                                n(e) ? (e.setAttribute("data-scroll-lock-fill-gap", ""),
                                y.scroll || X(e)) : r('"'.concat(e, '" is not a Element.'))
                            }
                            ))
                        }
                        ))
                    }
                      , $ = function(e) {
                        e && i(e).map((function(e) {
                            a(e, (function(e) {
                                n(e) ? (e.removeAttribute("data-scroll-lock-fill-gap"),
                                y.scroll || K(e)) : r('"'.concat(e, '" is not a Element.'))
                            }
                            ))
                        }
                        ))
                    }
                      , B = function(e) {
                        e && i(e).map((function(e) {
                            -1 === y.fillGapSelectors.indexOf(e) && (y.fillGapSelectors.push(e),
                            y.scroll || Y(e))
                        }
                        ))
                    }
                      , D = function(e) {
                        e && i(e).map((function(e) {
                            y.fillGapSelectors = y.fillGapSelectors.filter((function(t) {
                                return t !== e
                            }
                            )),
                            y.scroll || U(e)
                        }
                        ))
                    }
                      , N = function() {
                        y.scroll || V()
                    }
                      , z = function() {
                        var e = o(y.lockableSelectors);
                        H(e)
                    }
                      , F = function() {
                        var e = o(y.lockableSelectors);
                        R(e)
                    }
                      , H = function(e) {
                        var t = document.querySelectorAll(e);
                        a(t, (function(e) {
                            G(e)
                        }
                        ))
                    }
                      , R = function(e) {
                        var t = document.querySelectorAll(e);
                        a(t, (function(e) {
                            j(e)
                        }
                        ))
                    }
                      , G = function(e) {
                        if (n(e) && "true" !== e.getAttribute("data-scroll-lock-locked")) {
                            var t = window.getComputedStyle(e);
                            e.setAttribute("data-scroll-lock-saved-overflow-y-property", t.overflowY),
                            e.setAttribute("data-scroll-lock-saved-inline-overflow-property", e.style.overflow),
                            e.setAttribute("data-scroll-lock-saved-inline-overflow-y-property", e.style.overflowY),
                            e.style.overflow = "hidden",
                            e.setAttribute("data-scroll-lock-locked", "true")
                        }
                    }
                      , j = function(e) {
                        n(e) && "true" === e.getAttribute("data-scroll-lock-locked") && (e.style.overflow = e.getAttribute("data-scroll-lock-saved-inline-overflow-property"),
                        e.style.overflowY = e.getAttribute("data-scroll-lock-saved-inline-overflow-y-property"),
                        e.removeAttribute("data-scroll-lock-saved-overflow-property"),
                        e.removeAttribute("data-scroll-lock-saved-inline-overflow-property"),
                        e.removeAttribute("data-scroll-lock-saved-inline-overflow-y-property"),
                        e.removeAttribute("data-scroll-lock-locked"))
                    }
                      , V = function() {
                        y.fillGapSelectors.map((function(e) {
                            Y(e)
                        }
                        ))
                    }
                      , W = function() {
                        y.fillGapSelectors.map((function(e) {
                            U(e)
                        }
                        ))
                    }
                      , Y = function(e) {
                        var t = document.querySelectorAll(e)
                          , s = -1 !== y.lockableSelectors.indexOf(e);
                        a(t, (function(e) {
                            X(e, s)
                        }
                        ))
                    }
                      , X = function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        if (n(e)) {
                            var s;
                            if ("" === e.getAttribute("data-scroll-lock-lockable") || t)
                                s = x(e, !0);
                            else {
                                var i = c(e, o(y.lockableSelectors));
                                s = x(i, !0)
                            }
                            "true" === e.getAttribute("data-scroll-lock-filled-gap") && K(e);
                            var a = window.getComputedStyle(e);
                            if (e.setAttribute("data-scroll-lock-filled-gap", "true"),
                            e.setAttribute("data-scroll-lock-current-fill-gap-method", y.fillGapMethod),
                            "margin" === y.fillGapMethod) {
                                var r = parseFloat(a.marginRight);
                                e.style.marginRight = "".concat(r + s, "px")
                            } else if ("width" === y.fillGapMethod)
                                e.style.width = "calc(100% - ".concat(s, "px)");
                            else if ("max-width" === y.fillGapMethod)
                                e.style.maxWidth = "calc(100% - ".concat(s, "px)");
                            else if ("padding" === y.fillGapMethod) {
                                var l = parseFloat(a.paddingRight);
                                e.style.paddingRight = "".concat(l + s, "px")
                            }
                        }
                    }
                      , U = function(e) {
                        var t = document.querySelectorAll(e);
                        a(t, (function(e) {
                            K(e)
                        }
                        ))
                    }
                      , K = function(e) {
                        if (n(e) && "true" === e.getAttribute("data-scroll-lock-filled-gap")) {
                            var t = e.getAttribute("data-scroll-lock-current-fill-gap-method");
                            e.removeAttribute("data-scroll-lock-filled-gap"),
                            e.removeAttribute("data-scroll-lock-current-fill-gap-method"),
                            "margin" === t ? e.style.marginRight = "" : "width" === t ? e.style.width = "" : "max-width" === t ? e.style.maxWidth = "" : "padding" === t && (e.style.paddingRight = "")
                        }
                    };
                    "undefined" != typeof window && window.addEventListener("resize", (function(e) {
                        N()
                    }
                    )),
                    "undefined" != typeof document && (document.addEventListener("touchstart", (function(e) {
                        y.scroll || (y.startTouchY = e.touches[0].clientY,
                        y.startTouchX = e.touches[0].clientX)
                    }
                    )),
                    document.addEventListener("touchmove", (function(e) {
                        if (!y.scroll) {
                            var t = y.startTouchY
                              , s = y.startTouchX
                              , i = e.touches[0].clientY
                              , n = e.touches[0].clientX;
                            if (e.touches.length < 2) {
                                var a = o(y.scrollableSelectors)
                                  , r = {
                                    up: t < i,
                                    down: t > i,
                                    left: s < n,
                                    right: s > n
                                }
                                  , l = {
                                    up: t + 3 < i,
                                    down: t - 3 > i,
                                    left: s + 3 < n,
                                    right: s - 3 > n
                                };
                                !function t(s) {
                                    var i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                    if (s) {
                                        var n = c(s, a, !1);
                                        if (function(e) {
                                            return d(e, 'input[type="range"]')
                                        }(s))
                                            return !1;
                                        if (i || function(e) {
                                            return d(e, 'textarea, [contenteditable="true"]')
                                        }(s) && c(s, a) || d(s, a)) {
                                            var o = !1;
                                            m(s) && f(s) ? (r.up && p(s) || r.down && h(s)) && (o = !0) : p(s) && h(s) ? (r.left && m(s) || r.right && f(s)) && (o = !0) : (l.up && p(s) || l.down && h(s) || l.left && m(s) || l.right && f(s)) && (o = !0),
                                            o && (n ? t(n, !0) : e.cancelable && e.preventDefault())
                                        } else
                                            t(n)
                                    } else
                                        e.cancelable && e.preventDefault()
                                }(e.target)
                            }
                        }
                    }
                    ), {
                        passive: !1
                    }),
                    document.addEventListener("touchend", (function(e) {
                        y.scroll || (y.startTouchY = 0,
                        y.startTouchX = 0)
                    }
                    )));
                    var J = {
                        hide: function(e) {
                            r('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'),
                            b(e)
                        },
                        show: function(e) {
                            r('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'),
                            w(e)
                        },
                        toggle: function(e) {
                            r('"toggle" is deprecated! Do not use it.'),
                            S() ? b() : w(e)
                        },
                        getState: function() {
                            return r('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'),
                            S()
                        },
                        getWidth: function() {
                            return r('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'),
                            L()
                        },
                        getCurrentWidth: function() {
                            return r('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'),
                            A()
                        },
                        setScrollableTargets: function(e) {
                            r('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'),
                            C(e)
                        },
                        setFillGapSelectors: function(e) {
                            r('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'),
                            B(e)
                        },
                        setFillGapTargets: function(e) {
                            r('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'),
                            I(e)
                        },
                        clearQueue: function() {
                            r('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'),
                            E()
                        }
                    }
                      , Q = function(e) {
                        for (var t = 1; t < arguments.length; t++) {
                            var s = null != arguments[t] ? arguments[t] : {}
                              , i = Object.keys(s);
                            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(s).filter((function(e) {
                                return Object.getOwnPropertyDescriptor(s, e).enumerable
                            }
                            )))),
                            i.forEach((function(t) {
                                g(e, t, s[t])
                            }
                            ))
                        }
                        return e
                    }({
                        disablePageScroll: b,
                        enablePageScroll: w,
                        getScrollState: S,
                        clearQueueScrollLocks: E,
                        getTargetScrollBarWidth: x,
                        getCurrentTargetScrollBarWidth: T,
                        getPageScrollBarWidth: L,
                        getCurrentPageScrollBarWidth: A,
                        addScrollableSelector: q,
                        removeScrollableSelector: M,
                        addScrollableTarget: C,
                        removeScrollableTarget: k,
                        addLockableSelector: _,
                        addLockableTarget: O,
                        addFillGapSelector: B,
                        removeFillGapSelector: D,
                        addFillGapTarget: I,
                        removeFillGapTarget: $,
                        setFillGapMethod: P,
                        refillGaps: N,
                        _state: y
                    }, J);
                    t.default = Q
                }
                ]).default
            }
            ,
            e.exports = t()
        },
        311: function(e) {
            e.exports = function() {
                "use strict";
                function e() {
                    return Math.random().toString(36).substring(2, 10)
                }
                function t(e, t) {
                    function s(e, s) {
                        return s && e && e.classList && e.classList.contains(s) || s && e && e.dataset && e.dataset.id && e.dataset.id === t ? e : null
                    }
                    function i(e, t) {
                        return e && e !== document ? s(e, t) ? e : i(e.parentNode, t) : null
                    }
                    return s(e, t) || i(e, t)
                }
                function s(e, t=50, s=!1) {
                    let i;
                    return function(...n) {
                        const a = self
                          , r = () => {
                            i = null,
                            s || e.apply(a, n)
                        }
                          , o = s && !i;
                        clearTimeout(i),
                        i = setTimeout(r, t),
                        o && e.apply(a, n)
                    }
                }
                function i(e, t) {
                    return JSON.stringify(e) === JSON.stringify(t)
                }
                function n(e) {
                    const t = e.replace(/[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g, (e => "-" + e.toLowerCase()));
                    return e[0] === e[0].toUpperCase() ? t.substring(1) : t
                }
                class a {
                    constructor(t) {
                        if (this.id = t.id && "" !== t.id ? t.id : e(),
                        this.label = t.label || "",
                        this.selectAll = void 0 !== t.selectAll && t.selectAll,
                        this.selectAllText = t.selectAllText || "Select All",
                        this.closable = t.closable || "off",
                        this.options = [],
                        t.options)
                            for (const e of t.options)
                                this.options.push(new r(e))
                    }
                }
                class r {
                    constructor(t) {
                        this.id = t.id && "" !== t.id ? t.id : e(),
                        this.value = void 0 === t.value ? t.text : t.value,
                        this.text = t.text || "",
                        this.html = t.html || "",
                        this.selected = void 0 !== t.selected && t.selected,
                        this.display = void 0 === t.display || t.display,
                        this.disabled = void 0 !== t.disabled && t.disabled,
                        this.mandatory = void 0 !== t.mandatory && t.mandatory,
                        this.placeholder = void 0 !== t.placeholder && t.placeholder,
                        this.class = t.class || "",
                        this.style = t.style || "",
                        this.data = t.data || {}
                    }
                }
                class o {
                    constructor(e, t) {
                        this.selectType = "single",
                        this.data = [],
                        this.selectType = e,
                        this.setData(t)
                    }
                    validateDataArray(e) {
                        if (!Array.isArray(e))
                            return new Error("Data must be an array");
                        for (let t of e) {
                            if (!(t instanceof a || "label"in t))
                                return t instanceof r || "text"in t ? this.validateOption(t) : new Error("Data object must be a valid optgroup or option");
                            if (!("label"in t))
                                return new Error("Optgroup must have a label");
                            if ("options"in t && t.options)
                                for (let e of t.options)
                                    return this.validateOption(e)
                        }
                        return null
                    }
                    validateOption(e) {
                        return "text"in e ? null : new Error("Option must have a text")
                    }
                    partialToFullData(e) {
                        let t = [];
                        return e.forEach((e => {
                            if (e instanceof a || "label"in e) {
                                let s = [];
                                "options"in e && e.options && e.options.forEach((e => {
                                    s.push(new r(e))
                                }
                                )),
                                s.length > 0 && t.push(new a(e))
                            }
                            (e instanceof r || "text"in e) && t.push(new r(e))
                        }
                        )),
                        t
                    }
                    setData(e) {
                        this.data = this.partialToFullData(e),
                        "single" === this.selectType && this.setSelectedBy("value", this.getSelected())
                    }
                    getData() {
                        return this.filter(null, !0)
                    }
                    getDataOptions() {
                        return this.filter(null, !1)
                    }
                    addOption(e) {
                        this.setData(this.getData().concat(new r(e)))
                    }
                    setSelectedBy(e, t) {
                        let s = null
                          , i = !1;
                        for (let n of this.data) {
                            if (n instanceof a)
                                for (let a of n.options)
                                    s || (s = a),
                                    a.selected = !i && t.includes(a[e]),
                                    a.selected && "single" === this.selectType && (i = !0);
                            n instanceof r && (s || (s = n),
                            n.selected = !i && t.includes(n[e]),
                            n.selected && "single" === this.selectType && (i = !0))
                        }
                        "single" === this.selectType && s && !i && (s.selected = !0)
                    }
                    getSelected() {
                        let e = this.getSelectedOptions()
                          , t = [];
                        return e.forEach((e => {
                            t.push(e.value)
                        }
                        )),
                        t
                    }
                    getSelectedOptions() {
                        return this.filter((e => e.selected), !1)
                    }
                    getSelectedIDs() {
                        let e = this.getSelectedOptions()
                          , t = [];
                        return e.forEach((e => {
                            t.push(e.id)
                        }
                        )),
                        t
                    }
                    getOptgroupByID(e) {
                        for (let t of this.data)
                            if (t instanceof a && t.id === e)
                                return t;
                        return null
                    }
                    getOptionByID(e) {
                        let t = this.filter((t => t.id === e), !1);
                        return t.length ? t[0] : null
                    }
                    getSelectType() {
                        return this.selectType
                    }
                    getFirstOption() {
                        let e = null;
                        for (let t of this.data)
                            if (t instanceof a ? e = t.options[0] : t instanceof r && (e = t),
                            e)
                                break;
                        return e
                    }
                    search(e, t) {
                        return "" === (e = e.trim()) ? this.getData() : this.filter((s => t(s, e)), !0)
                    }
                    filter(e, t) {
                        const s = [];
                        return this.data.forEach((i => {
                            if (i instanceof a) {
                                let n = [];
                                if (i.options.forEach((i => {
                                    e && !e(i) || (t ? n.push(new r(i)) : s.push(new r(i)))
                                }
                                )),
                                n.length > 0) {
                                    let e = new a(i);
                                    e.options = n,
                                    s.push(e)
                                }
                            }
                            i instanceof r && (e && !e(i) || s.push(new r(i)))
                        }
                        )),
                        s
                    }
                }
                class l {
                    constructor(e, t, s) {
                        this.classes = {
                            main: "ss-main",
                            placeholder: "ss-placeholder",
                            values: "ss-values",
                            single: "ss-single",
                            max: "ss-max",
                            value: "ss-value",
                            valueText: "ss-value-text",
                            valueDelete: "ss-value-delete",
                            valueOut: "ss-value-out",
                            deselect: "ss-deselect",
                            deselectPath: "M10,10 L90,90 M10,90 L90,10",
                            arrow: "ss-arrow",
                            arrowClose: "M10,30 L50,70 L90,30",
                            arrowOpen: "M10,70 L50,30 L90,70",
                            content: "ss-content",
                            openAbove: "ss-open-above",
                            openBelow: "ss-open-below",
                            search: "ss-search",
                            searchHighlighter: "ss-search-highlight",
                            searching: "ss-searching",
                            addable: "ss-addable",
                            addablePath: "M50,10 L50,90 M10,50 L90,50",
                            list: "ss-list",
                            optgroup: "ss-optgroup",
                            optgroupLabel: "ss-optgroup-label",
                            optgroupLabelText: "ss-optgroup-label-text",
                            optgroupActions: "ss-optgroup-actions",
                            optgroupSelectAll: "ss-selectall",
                            optgroupSelectAllBox: "M60,10 L10,10 L10,90 L90,90 L90,50",
                            optgroupSelectAllCheck: "M30,45 L50,70 L90,10",
                            optgroupClosable: "ss-closable",
                            option: "ss-option",
                            optionDelete: "M10,10 L90,90 M10,90 L90,10",
                            highlighted: "ss-highlighted",
                            open: "ss-open",
                            close: "ss-close",
                            selected: "ss-selected",
                            error: "ss-error",
                            disabled: "ss-disabled",
                            hide: "ss-hide"
                        },
                        this.store = t,
                        this.settings = e,
                        this.callbacks = s,
                        this.main = this.mainDiv(),
                        this.content = this.contentDiv(),
                        this.updateClassStyles(),
                        this.updateAriaAttributes(),
                        this.settings.contentLocation.appendChild(this.content.main)
                    }
                    enable() {
                        this.main.main.classList.remove(this.classes.disabled),
                        this.content.search.input.disabled = !1
                    }
                    disable() {
                        this.main.main.classList.add(this.classes.disabled),
                        this.content.search.input.disabled = !0
                    }
                    open() {
                        this.main.arrow.path.setAttribute("d", this.classes.arrowOpen),
                        this.main.main.classList.add("up" === this.settings.openPosition ? this.classes.openAbove : this.classes.openBelow),
                        this.main.main.setAttribute("aria-expanded", "true"),
                        this.moveContent();
                        const e = this.store.getSelectedOptions();
                        if (e.length) {
                            const t = e[e.length - 1].id
                              , s = this.content.list.querySelector('[data-id="' + t + '"]');
                            s && this.ensureElementInView(this.content.list, s)
                        }
                    }
                    close() {
                        this.main.main.classList.remove(this.classes.openAbove),
                        this.main.main.classList.remove(this.classes.openBelow),
                        this.main.main.setAttribute("aria-expanded", "false"),
                        this.content.main.classList.remove(this.classes.openAbove),
                        this.content.main.classList.remove(this.classes.openBelow),
                        this.main.arrow.path.setAttribute("d", this.classes.arrowClose)
                    }
                    updateClassStyles() {
                        if (this.main.main.className = "",
                        this.main.main.removeAttribute("style"),
                        this.content.main.className = "",
                        this.content.main.removeAttribute("style"),
                        this.main.main.classList.add(this.classes.main),
                        this.content.main.classList.add(this.classes.content),
                        "" !== this.settings.style && (this.main.main.style.cssText = this.settings.style,
                        this.content.main.style.cssText = this.settings.style),
                        this.settings.class.length)
                            for (const e of this.settings.class)
                                "" !== e.trim() && (this.main.main.classList.add(e.trim()),
                                this.content.main.classList.add(e.trim()));
                        "relative" === this.settings.contentPosition && this.content.main.classList.add("ss-" + this.settings.contentPosition)
                    }
                    updateAriaAttributes() {
                        this.main.main.role = "combobox",
                        this.main.main.setAttribute("aria-haspopup", "listbox"),
                        this.main.main.setAttribute("aria-controls", this.content.main.id),
                        this.main.main.setAttribute("aria-expanded", "false"),
                        this.content.main.setAttribute("role", "listbox")
                    }
                    mainDiv() {
                        var e;
                        const t = document.createElement("div");
                        t.dataset.id = this.settings.id,
                        t.setAttribute("aria-label", this.settings.ariaLabel),
                        t.tabIndex = 0,
                        t.onkeydown = e => {
                            switch (e.key) {
                            case "ArrowUp":
                            case "ArrowDown":
                                return this.callbacks.open(),
                                "ArrowDown" === e.key ? this.highlight("down") : this.highlight("up"),
                                !1;
                            case "Tab":
                                return this.callbacks.close(),
                                !0;
                            case "Enter":
                            case " ":
                                this.callbacks.open();
                                const t = this.content.list.querySelector("." + this.classes.highlighted);
                                return t && t.click(),
                                !1;
                            case "Escape":
                                return this.callbacks.close(),
                                !1
                            }
                            return !1
                        }
                        ,
                        t.onclick = e => {
                            this.settings.disabled || (this.settings.isOpen ? this.callbacks.close() : this.callbacks.open())
                        }
                        ;
                        const s = document.createElement("div");
                        s.classList.add(this.classes.values),
                        t.appendChild(s);
                        const i = document.createElement("div");
                        i.classList.add(this.classes.deselect);
                        const n = null === (e = this.store) || void 0 === e ? void 0 : e.getSelectedOptions();
                        !this.settings.allowDeselect || this.settings.isMultiple && n && n.length <= 0 ? i.classList.add(this.classes.hide) : i.classList.remove(this.classes.hide),
                        i.onclick = e => {
                            if (e.stopPropagation(),
                            this.settings.disabled)
                                return;
                            let t = !0;
                            const s = this.store.getSelectedOptions()
                              , i = [];
                            if (this.callbacks.beforeChange && (t = !0 === this.callbacks.beforeChange(i, s)),
                            t) {
                                if (this.settings.isMultiple)
                                    this.callbacks.setSelected([], !1),
                                    this.updateDeselectAll();
                                else {
                                    const e = this.store.getFirstOption()
                                      , t = e ? e.value : "";
                                    this.callbacks.setSelected(t, !1)
                                }
                                this.settings.closeOnSelect && this.callbacks.close(),
                                this.callbacks.afterChange && this.callbacks.afterChange(this.store.getSelectedOptions())
                            }
                        }
                        ;
                        const a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        a.setAttribute("viewBox", "0 0 100 100");
                        const r = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        r.setAttribute("d", this.classes.deselectPath),
                        a.appendChild(r),
                        i.appendChild(a),
                        t.appendChild(i);
                        const o = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        o.classList.add(this.classes.arrow),
                        o.setAttribute("viewBox", "0 0 100 100");
                        const l = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        return l.setAttribute("d", this.classes.arrowClose),
                        this.settings.alwaysOpen && o.classList.add(this.classes.hide),
                        o.appendChild(l),
                        t.appendChild(o),
                        {
                            main: t,
                            values: s,
                            deselect: {
                                main: i,
                                svg: a,
                                path: r
                            },
                            arrow: {
                                main: o,
                                path: l
                            }
                        }
                    }
                    mainFocus(e) {
                        "click" !== e && this.main.main.focus({
                            preventScroll: !0
                        })
                    }
                    placeholder() {
                        const e = this.store.filter((e => e.placeholder), !1);
                        let t = this.settings.placeholderText;
                        e.length && ("" !== e[0].html ? t = e[0].html : "" !== e[0].text && (t = e[0].text));
                        const s = document.createElement("div");
                        return s.classList.add(this.classes.placeholder),
                        s.innerHTML = t,
                        s
                    }
                    renderValues() {
                        this.settings.isMultiple ? (this.renderMultipleValues(),
                        this.updateDeselectAll()) : this.renderSingleValue()
                    }
                    renderSingleValue() {
                        const e = this.store.filter((e => e.selected && !e.placeholder), !1)
                          , t = e.length > 0 ? e[0] : null;
                        if (t) {
                            const e = document.createElement("div");
                            e.classList.add(this.classes.single),
                            t.html ? e.innerHTML = t.html : e.innerText = t.text,
                            this.main.values.innerHTML = e.outerHTML
                        } else
                            this.main.values.innerHTML = this.placeholder().outerHTML;
                        this.settings.allowDeselect && e.length ? this.main.deselect.main.classList.remove(this.classes.hide) : this.main.deselect.main.classList.add(this.classes.hide)
                    }
                    renderMultipleValues() {
                        let e = this.main.values.childNodes
                          , t = this.store.filter((e => e.selected && e.display), !1);
                        if (0 === t.length)
                            return void (this.main.values.innerHTML = this.placeholder().outerHTML);
                        {
                            const e = this.main.values.querySelector("." + this.classes.placeholder);
                            e && e.remove()
                        }
                        if (t.length > this.settings.maxValuesShown) {
                            const e = document.createElement("div");
                            return e.classList.add(this.classes.max),
                            e.textContent = this.settings.maxValuesMessage.replace("{number}", t.length.toString()),
                            void (this.main.values.innerHTML = e.outerHTML)
                        }
                        {
                            const e = this.main.values.querySelector("." + this.classes.max);
                            e && e.remove()
                        }
                        let s = [];
                        for (let i = 0; i < e.length; i++) {
                            const n = e[i]
                              , a = n.getAttribute("data-id");
                            a && (t.filter((e => e.id === a), !1).length || s.push(n))
                        }
                        for (const e of s)
                            e.classList.add(this.classes.valueOut),
                            setTimeout(( () => {
                                this.main.values.hasChildNodes() && this.main.values.contains(e) && this.main.values.removeChild(e)
                            }
                            ), 100);
                        e = this.main.values.childNodes;
                        for (let s = 0; s < t.length; s++) {
                            let i = !0;
                            for (let n = 0; n < e.length; n++)
                                t[s].id === String(e[n].dataset.id) && (i = !1);
                            i && (this.settings.keepOrder || 0 === e.length ? this.main.values.appendChild(this.multipleValue(t[s])) : 0 === s ? this.main.values.insertBefore(this.multipleValue(t[s]), e[s]) : e[s - 1].insertAdjacentElement("afterend", this.multipleValue(t[s])))
                        }
                    }
                    multipleValue(e) {
                        const t = document.createElement("div");
                        t.classList.add(this.classes.value),
                        t.dataset.id = e.id;
                        const s = document.createElement("div");
                        if (s.classList.add(this.classes.valueText),
                        s.innerText = e.text,
                        t.appendChild(s),
                        !e.mandatory) {
                            const s = document.createElement("div");
                            s.classList.add(this.classes.valueDelete),
                            s.onclick = t => {
                                if (t.preventDefault(),
                                t.stopPropagation(),
                                this.settings.disabled)
                                    return;
                                let s = !0;
                                const i = this.store.getSelectedOptions()
                                  , n = i.filter((t => t.selected && t.id !== e.id), !0);
                                if (!(this.settings.minSelected && n.length < this.settings.minSelected) && (this.callbacks.beforeChange && (s = !0 === this.callbacks.beforeChange(n, i)),
                                s)) {
                                    let e = [];
                                    for (const t of n) {
                                        if (t instanceof a)
                                            for (const s of t.options)
                                                e.push(s.value);
                                        t instanceof r && e.push(t.value)
                                    }
                                    this.callbacks.setSelected(e, !1),
                                    this.settings.closeOnSelect && this.callbacks.close(),
                                    this.callbacks.afterChange && this.callbacks.afterChange(n),
                                    this.updateDeselectAll()
                                }
                            }
                            ;
                            const i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                            i.setAttribute("viewBox", "0 0 100 100");
                            const n = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            n.setAttribute("d", this.classes.optionDelete),
                            i.appendChild(n),
                            s.appendChild(i),
                            t.appendChild(s)
                        }
                        return t
                    }
                    contentDiv() {
                        const e = document.createElement("div");
                        e.dataset.id = this.settings.id;
                        const t = this.searchDiv();
                        e.appendChild(t.main);
                        const s = this.listDiv();
                        return e.appendChild(s),
                        {
                            main: e,
                            search: t,
                            list: s
                        }
                    }
                    moveContent() {
                        "relative" !== this.settings.contentPosition && "down" !== this.settings.openPosition ? "up" !== this.settings.openPosition ? "up" === this.putContent() ? this.moveContentAbove() : this.moveContentBelow() : this.moveContentAbove() : this.moveContentBelow()
                    }
                    searchDiv() {
                        const e = document.createElement("div")
                          , t = document.createElement("input")
                          , i = document.createElement("div");
                        e.classList.add(this.classes.search);
                        const n = {
                            main: e,
                            input: t
                        };
                        if (this.settings.showSearch || (e.classList.add(this.classes.hide),
                        t.readOnly = !0),
                        t.type = "search",
                        t.placeholder = this.settings.searchPlaceholder,
                        t.tabIndex = -1,
                        t.setAttribute("aria-label", this.settings.searchPlaceholder),
                        t.setAttribute("autocapitalize", "off"),
                        t.setAttribute("autocomplete", "off"),
                        t.setAttribute("autocorrect", "off"),
                        t.oninput = s((e => {
                            this.callbacks.search(e.target.value)
                        }
                        ), 100),
                        t.onkeydown = e => {
                            switch (e.key) {
                            case "ArrowUp":
                            case "ArrowDown":
                                return "ArrowDown" === e.key ? this.highlight("down") : this.highlight("up"),
                                !1;
                            case "Tab":
                                return this.callbacks.close(),
                                !0;
                            case "Escape":
                                return this.callbacks.close(),
                                !1;
                            case "Enter":
                            case " ":
                                if (this.callbacks.addable && e.ctrlKey)
                                    return i.click(),
                                    !1;
                                {
                                    const e = this.content.list.querySelector("." + this.classes.highlighted);
                                    if (e)
                                        return e.click(),
                                        !1
                                }
                                return !0
                            }
                            return !0
                        }
                        ,
                        e.appendChild(t),
                        this.callbacks.addable) {
                            i.classList.add(this.classes.addable);
                            const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                            t.setAttribute("viewBox", "0 0 100 100");
                            const s = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            s.setAttribute("d", this.classes.addablePath),
                            t.appendChild(s),
                            i.appendChild(t),
                            i.onclick = e => {
                                if (e.preventDefault(),
                                e.stopPropagation(),
                                !this.callbacks.addable)
                                    return;
                                const t = this.content.search.input.value.trim();
                                if ("" === t)
                                    return void this.content.search.input.focus();
                                const s = e => {
                                    let t = new r(e);
                                    if (this.callbacks.addOption(t),
                                    this.settings.isMultiple) {
                                        let e = this.store.getSelected();
                                        e.push(t.value),
                                        this.callbacks.setSelected(e, !0)
                                    } else
                                        this.callbacks.setSelected([t.value], !0);
                                    this.callbacks.search(""),
                                    this.settings.closeOnSelect && setTimeout(( () => {
                                        this.callbacks.close()
                                    }
                                    ), 100)
                                }
                                  , i = this.callbacks.addable(t);
                                !1 !== i && null != i && (i instanceof Promise ? i.then((e => {
                                    s("string" == typeof e ? {
                                        text: e,
                                        value: e
                                    } : e)
                                }
                                )) : s("string" == typeof i ? {
                                    text: i,
                                    value: i
                                } : i))
                            }
                            ,
                            e.appendChild(i),
                            n.addable = {
                                main: i,
                                svg: t,
                                path: s
                            }
                        }
                        return n
                    }
                    searchFocus() {
                        this.content.search.input.focus()
                    }
                    getOptions(e=!1, t=!1, s=!1) {
                        let i = "." + this.classes.option;
                        return e && (i += ":not(." + this.classes.placeholder + ")"),
                        t && (i += ":not(." + this.classes.disabled + ")"),
                        s && (i += ":not(." + this.classes.hide + ")"),
                        Array.from(this.content.list.querySelectorAll(i))
                    }
                    highlight(e) {
                        const t = this.getOptions(!0, !0, !0);
                        if (0 === t.length)
                            return;
                        if (1 === t.length && !t[0].classList.contains(this.classes.highlighted))
                            return void t[0].classList.add(this.classes.highlighted);
                        let s = !1;
                        for (const e of t)
                            e.classList.contains(this.classes.highlighted) && (s = !0);
                        if (!s)
                            for (const e of t)
                                if (e.classList.contains(this.classes.selected)) {
                                    e.classList.add(this.classes.highlighted);
                                    break
                                }
                        for (let s = 0; s < t.length; s++)
                            if (t[s].classList.contains(this.classes.highlighted)) {
                                const i = t[s];
                                i.classList.remove(this.classes.highlighted);
                                const n = i.parentElement;
                                if (n && n.classList.contains(this.classes.open)) {
                                    const e = n.querySelector("." + this.classes.optgroupLabel);
                                    e && e.click()
                                }
                                let a = t["down" === e ? s + 1 < t.length ? s + 1 : 0 : s - 1 >= 0 ? s - 1 : t.length - 1];
                                a.classList.add(this.classes.highlighted),
                                this.ensureElementInView(this.content.list, a);
                                const r = a.parentElement;
                                if (r && r.classList.contains(this.classes.close)) {
                                    const e = r.querySelector("." + this.classes.optgroupLabel);
                                    e && e.click()
                                }
                                return
                            }
                        t["down" === e ? 0 : t.length - 1].classList.add(this.classes.highlighted),
                        this.ensureElementInView(this.content.list, t["down" === e ? 0 : t.length - 1])
                    }
                    listDiv() {
                        const e = document.createElement("div");
                        return e.classList.add(this.classes.list),
                        e
                    }
                    renderError(e) {
                        this.content.list.innerHTML = "";
                        const t = document.createElement("div");
                        t.classList.add(this.classes.error),
                        t.textContent = e,
                        this.content.list.appendChild(t)
                    }
                    renderSearching() {
                        this.content.list.innerHTML = "";
                        const e = document.createElement("div");
                        e.classList.add(this.classes.searching),
                        e.textContent = this.settings.searchingText,
                        this.content.list.appendChild(e)
                    }
                    renderOptions(e) {
                        if (this.content.list.innerHTML = "",
                        0 === e.length) {
                            const e = document.createElement("div");
                            return e.classList.add(this.classes.search),
                            e.innerHTML = this.settings.searchText,
                            void this.content.list.appendChild(e)
                        }
                        for (const t of e) {
                            if (t instanceof a) {
                                const e = document.createElement("div");
                                e.classList.add(this.classes.optgroup);
                                const s = document.createElement("div");
                                s.classList.add(this.classes.optgroupLabel),
                                e.appendChild(s);
                                const i = document.createElement("div");
                                i.classList.add(this.classes.optgroupLabelText),
                                i.textContent = t.label,
                                s.appendChild(i);
                                const n = document.createElement("div");
                                if (n.classList.add(this.classes.optgroupActions),
                                s.appendChild(n),
                                this.settings.isMultiple && t.selectAll) {
                                    const e = document.createElement("div");
                                    e.classList.add(this.classes.optgroupSelectAll);
                                    let s = !0;
                                    for (const e of t.options)
                                        if (!e.selected) {
                                            s = !1;
                                            break
                                        }
                                    s && e.classList.add(this.classes.selected);
                                    const i = document.createElement("span");
                                    i.textContent = t.selectAllText,
                                    e.appendChild(i);
                                    const a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                                    a.setAttribute("viewBox", "0 0 100 100"),
                                    e.appendChild(a);
                                    const r = document.createElementNS("http://www.w3.org/2000/svg", "path");
                                    r.setAttribute("d", this.classes.optgroupSelectAllBox),
                                    a.appendChild(r);
                                    const o = document.createElementNS("http://www.w3.org/2000/svg", "path");
                                    o.setAttribute("d", this.classes.optgroupSelectAllCheck),
                                    a.appendChild(o),
                                    e.addEventListener("click", (e => {
                                        e.preventDefault(),
                                        e.stopPropagation();
                                        const i = this.store.getSelected();
                                        if (s) {
                                            const e = i.filter((e => {
                                                for (const s of t.options)
                                                    if (e === s.value)
                                                        return !1;
                                                return !0
                                            }
                                            ));
                                            this.callbacks.setSelected(e, !0)
                                        } else {
                                            const e = i.concat(t.options.map((e => e.value)));
                                            for (const e of t.options)
                                                this.store.getOptionByID(e.id) || this.callbacks.addOption(e);
                                            this.callbacks.setSelected(e, !0)
                                        }
                                    }
                                    )),
                                    n.appendChild(e)
                                }
                                if ("off" !== t.closable) {
                                    const i = document.createElement("div");
                                    i.classList.add(this.classes.optgroupClosable);
                                    const a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                                    a.setAttribute("viewBox", "0 0 100 100"),
                                    a.classList.add(this.classes.arrow),
                                    i.appendChild(a);
                                    const r = document.createElementNS("http://www.w3.org/2000/svg", "path");
                                    a.appendChild(r),
                                    t.options.some((e => e.selected)) || "" !== this.content.search.input.value.trim() ? (i.classList.add(this.classes.open),
                                    r.setAttribute("d", this.classes.arrowOpen)) : "open" === t.closable ? (e.classList.add(this.classes.open),
                                    r.setAttribute("d", this.classes.arrowOpen)) : "close" === t.closable && (e.classList.add(this.classes.close),
                                    r.setAttribute("d", this.classes.arrowClose)),
                                    s.addEventListener("click", (t => {
                                        t.preventDefault(),
                                        t.stopPropagation(),
                                        e.classList.contains(this.classes.close) ? (e.classList.remove(this.classes.close),
                                        e.classList.add(this.classes.open),
                                        r.setAttribute("d", this.classes.arrowOpen)) : (e.classList.remove(this.classes.open),
                                        e.classList.add(this.classes.close),
                                        r.setAttribute("d", this.classes.arrowClose))
                                    }
                                    )),
                                    n.appendChild(i)
                                }
                                e.appendChild(s);
                                for (const s of t.options)
                                    e.appendChild(this.option(s));
                                this.content.list.appendChild(e)
                            }
                            t instanceof r && this.content.list.appendChild(this.option(t))
                        }
                    }
                    option(e) {
                        if (e.placeholder) {
                            const e = document.createElement("div");
                            return e.classList.add(this.classes.option),
                            e.classList.add(this.classes.hide),
                            e
                        }
                        const t = document.createElement("div");
                        return t.dataset.id = e.id,
                        t.id = e.id,
                        t.classList.add(this.classes.option),
                        t.setAttribute("role", "option"),
                        e.class && e.class.split(" ").forEach((e => {
                            t.classList.add(e)
                        }
                        )),
                        e.style && (t.style.cssText = e.style),
                        this.settings.searchHighlight && "" !== this.content.search.input.value.trim() ? t.innerHTML = this.highlightText("" !== e.html ? e.html : e.text, this.content.search.input.value, this.classes.searchHighlighter) : "" !== e.html ? t.innerHTML = e.html : t.textContent = e.text,
                        this.settings.showOptionTooltips && t.textContent && t.setAttribute("title", t.textContent),
                        e.display || t.classList.add(this.classes.hide),
                        e.disabled && t.classList.add(this.classes.disabled),
                        e.selected && this.settings.hideSelected && t.classList.add(this.classes.hide),
                        e.selected ? (t.classList.add(this.classes.selected),
                        t.setAttribute("aria-selected", "true"),
                        this.main.main.setAttribute("aria-activedescendant", t.id)) : (t.classList.remove(this.classes.selected),
                        t.setAttribute("aria-selected", "false")),
                        t.addEventListener("click", (t => {
                            t.preventDefault(),
                            t.stopPropagation();
                            const s = this.store.getSelected()
                              , i = t.currentTarget
                              , n = String(i.dataset.id);
                            if (e.disabled || e.selected && !this.settings.allowDeselect)
                                return;
                            if (this.settings.isMultiple && this.settings.maxSelected <= s.length && !e.selected || this.settings.isMultiple && this.settings.minSelected >= s.length && e.selected)
                                return;
                            let a = !1;
                            const r = this.store.getSelectedOptions();
                            let o = [];
                            this.settings.isMultiple && (o = e.selected ? r.filter((e => e.id !== n)) : r.concat(e)),
                            this.settings.isMultiple || (o = e.selected ? [] : [e]),
                            this.callbacks.beforeChange || (a = !0),
                            this.callbacks.beforeChange && (a = !1 !== this.callbacks.beforeChange(o, r)),
                            a && (this.store.getOptionByID(n) || this.callbacks.addOption(e),
                            this.callbacks.setSelected(o.map((e => e.value)), !1),
                            this.settings.closeOnSelect && this.callbacks.close(),
                            this.callbacks.afterChange && this.callbacks.afterChange(o))
                        }
                        )),
                        t
                    }
                    destroy() {
                        this.main.main.remove(),
                        this.content.main.remove()
                    }
                    highlightText(e, t, s) {
                        let i = e;
                        const n = new RegExp("(" + t.trim() + ")(?![^<]*>[^<>]*</)","i");
                        if (!e.match(n))
                            return e;
                        const a = e.match(n).index
                          , r = a + e.match(n)[0].toString().length
                          , o = e.substring(a, r);
                        return i = i.replace(n, `<mark class="${s}">${o}</mark>`),
                        i
                    }
                    moveContentAbove() {
                        const e = this.main.main.offsetHeight
                          , t = this.content.main.offsetHeight;
                        this.main.main.classList.remove(this.classes.openBelow),
                        this.main.main.classList.add(this.classes.openAbove),
                        this.content.main.classList.remove(this.classes.openBelow),
                        this.content.main.classList.add(this.classes.openAbove);
                        const s = this.main.main.getBoundingClientRect();
                        this.content.main.style.margin = "-" + (e + t - 1) + "px 0px 0px 0px",
                        this.content.main.style.top = s.top + s.height + window.scrollY + "px",
                        this.content.main.style.left = s.left + window.scrollX + "px",
                        this.content.main.style.width = s.width + "px"
                    }
                    moveContentBelow() {
                        this.main.main.classList.remove(this.classes.openAbove),
                        this.main.main.classList.add(this.classes.openBelow),
                        this.content.main.classList.remove(this.classes.openAbove),
                        this.content.main.classList.add(this.classes.openBelow);
                        const e = this.main.main.getBoundingClientRect();
                        this.content.main.style.margin = "-1px 0px 0px 0px",
                        "relative" !== this.settings.contentPosition && (this.content.main.style.top = e.top + e.height + window.scrollY + "px",
                        this.content.main.style.left = e.left + window.scrollX + "px",
                        this.content.main.style.width = e.width + "px")
                    }
                    ensureElementInView(e, t) {
                        const s = e.scrollTop + e.offsetTop
                          , i = s + e.clientHeight
                          , n = t.offsetTop
                          , a = n + t.clientHeight;
                        n < s ? e.scrollTop -= s - n : a > i && (e.scrollTop += a - i)
                    }
                    putContent() {
                        const e = this.main.main.offsetHeight
                          , t = this.main.main.getBoundingClientRect()
                          , s = this.content.main.offsetHeight;
                        return window.innerHeight - (t.top + e) <= s && t.top > s ? "up" : "down"
                    }
                    updateDeselectAll() {
                        if (!this.store || !this.settings)
                            return;
                        const e = this.store.getSelectedOptions()
                          , t = e && e.length > 0
                          , s = this.settings.isMultiple
                          , i = this.settings.allowDeselect
                          , n = this.main.deselect.main
                          , a = this.classes.hide;
                        !i || s && !t ? n.classList.add(a) : n.classList.remove(a)
                    }
                }
                class c {
                    constructor(e) {
                        this.listen = !1,
                        this.observer = null,
                        this.select = e,
                        this.valueChange = this.valueChange.bind(this),
                        this.select.addEventListener("change", this.valueChange, {
                            passive: !0
                        }),
                        this.observer = new MutationObserver(this.observeCall.bind(this)),
                        this.changeListen(!0)
                    }
                    enable() {
                        this.select.disabled = !1
                    }
                    disable() {
                        this.select.disabled = !0
                    }
                    hideUI() {
                        this.select.tabIndex = -1,
                        this.select.style.display = "none",
                        this.select.setAttribute("aria-hidden", "true")
                    }
                    showUI() {
                        this.select.removeAttribute("tabindex"),
                        this.select.style.display = "",
                        this.select.removeAttribute("aria-hidden")
                    }
                    changeListen(e) {
                        this.listen = e,
                        e && this.observer && this.observer.observe(this.select, {
                            subtree: !0,
                            childList: !0,
                            attributes: !0
                        }),
                        e || this.observer && this.observer.disconnect()
                    }
                    valueChange(e) {
                        return this.listen && this.onValueChange && this.onValueChange(this.getSelectedValues()),
                        !0
                    }
                    observeCall(e) {
                        if (!this.listen)
                            return;
                        let t = !1
                          , s = !1
                          , i = !1;
                        for (const n of e)
                            n.target === this.select && ("disabled" === n.attributeName && (s = !0),
                            "class" === n.attributeName && (t = !0)),
                            "OPTGROUP" !== n.target.nodeName && "OPTION" !== n.target.nodeName || (i = !0);
                        t && this.onClassChange && this.onClassChange(this.select.className.split(" ")),
                        s && this.onDisabledChange && (this.changeListen(!1),
                        this.onDisabledChange(this.select.disabled),
                        this.changeListen(!0)),
                        i && this.onOptionsChange && (this.changeListen(!1),
                        this.onOptionsChange(this.getData()),
                        this.changeListen(!0))
                    }
                    getData() {
                        let e = [];
                        const t = this.select.childNodes;
                        for (const s of t)
                            "OPTGROUP" === s.nodeName && e.push(this.getDataFromOptgroup(s)),
                            "OPTION" === s.nodeName && e.push(this.getDataFromOption(s));
                        return e
                    }
                    getDataFromOptgroup(e) {
                        let t = {
                            id: e.id,
                            label: e.label,
                            selectAll: !!e.dataset && "true" === e.dataset.selectall,
                            selectAllText: e.dataset ? e.dataset.selectalltext : "Select all",
                            closable: e.dataset ? e.dataset.closable : "off",
                            options: []
                        };
                        const s = e.childNodes;
                        for (const e of s)
                            "OPTION" === e.nodeName && t.options.push(this.getDataFromOption(e));
                        return t
                    }
                    getDataFromOption(e) {
                        return {
                            id: e.id,
                            value: e.value,
                            text: e.text,
                            html: e.dataset && e.dataset.html ? e.dataset.html : "",
                            selected: e.selected,
                            display: "none" !== e.style.display,
                            disabled: e.disabled,
                            mandatory: !!e.dataset && "true" === e.dataset.mandatory,
                            placeholder: "true" === e.dataset.placeholder,
                            class: e.className,
                            style: e.style.cssText,
                            data: e.dataset
                        }
                    }
                    getSelectedValues() {
                        let e = [];
                        const t = this.select.childNodes;
                        for (const s of t) {
                            if ("OPTGROUP" === s.nodeName) {
                                const t = s.childNodes;
                                for (const s of t)
                                    if ("OPTION" === s.nodeName) {
                                        const t = s;
                                        t.selected && e.push(t.value)
                                    }
                            }
                            if ("OPTION" === s.nodeName) {
                                const t = s;
                                t.selected && e.push(t.value)
                            }
                        }
                        return e
                    }
                    setSelected(e) {
                        this.changeListen(!1);
                        const t = this.select.childNodes;
                        for (const s of t) {
                            if ("OPTGROUP" === s.nodeName) {
                                const t = s.childNodes;
                                for (const s of t)
                                    if ("OPTION" === s.nodeName) {
                                        const t = s;
                                        t.selected = e.includes(t.value)
                                    }
                            }
                            if ("OPTION" === s.nodeName) {
                                const t = s;
                                t.selected = e.includes(t.value)
                            }
                        }
                        this.changeListen(!0)
                    }
                    updateSelect(e, t, s) {
                        this.changeListen(!1),
                        e && (this.select.dataset.id = e),
                        t && (this.select.style.cssText = t),
                        s && (this.select.className = "",
                        s.forEach((e => {
                            "" !== e.trim() && this.select.classList.add(e.trim())
                        }
                        ))),
                        this.changeListen(!0)
                    }
                    updateOptions(e) {
                        this.changeListen(!1),
                        this.select.innerHTML = "";
                        for (const t of e)
                            t instanceof a && this.select.appendChild(this.createOptgroup(t)),
                            t instanceof r && this.select.appendChild(this.createOption(t));
                        this.select.dispatchEvent(new Event("change")),
                        this.changeListen(!0)
                    }
                    createOptgroup(e) {
                        const t = document.createElement("optgroup");
                        if (t.id = e.id,
                        t.label = e.label,
                        e.selectAll && (t.dataset.selectAll = "true"),
                        "off" !== e.closable && (t.dataset.closable = e.closable),
                        e.options)
                            for (const s of e.options)
                                t.appendChild(this.createOption(s));
                        return t
                    }
                    createOption(e) {
                        const t = document.createElement("option");
                        return t.id = e.id,
                        t.value = e.value,
                        t.innerHTML = e.text,
                        "" !== e.html && t.setAttribute("data-html", e.html),
                        e.selected && (t.selected = e.selected),
                        e.disabled && (t.disabled = !0),
                        !1 === e.display && (t.style.display = "none"),
                        e.placeholder && t.setAttribute("data-placeholder", "true"),
                        e.mandatory && t.setAttribute("data-mandatory", "true"),
                        e.class && e.class.split(" ").forEach((e => {
                            t.classList.add(e)
                        }
                        )),
                        e.data && "object" == typeof e.data && Object.keys(e.data).forEach((s => {
                            t.setAttribute("data-" + n(s), e.data[s])
                        }
                        )),
                        t
                    }
                    destroy() {
                        this.changeListen(!1),
                        this.select.removeEventListener("change", this.valueChange),
                        this.observer && (this.observer.disconnect(),
                        this.observer = null),
                        delete this.select.dataset.id,
                        this.showUI()
                    }
                }
                class d {
                    constructor(t) {
                        this.id = "",
                        this.style = "",
                        this.class = [],
                        this.isMultiple = !1,
                        this.isOpen = !1,
                        this.isFullOpen = !1,
                        this.intervalMove = null,
                        t || (t = {}),
                        this.id = "ss-" + e(),
                        this.style = t.style || "",
                        this.class = t.class || [],
                        this.disabled = void 0 !== t.disabled && t.disabled,
                        this.alwaysOpen = void 0 !== t.alwaysOpen && t.alwaysOpen,
                        this.showSearch = void 0 === t.showSearch || t.showSearch,
                        this.ariaLabel = t.ariaLabel || "Combobox",
                        this.searchPlaceholder = t.searchPlaceholder || "Search",
                        this.searchText = t.searchText || "No Results",
                        this.searchingText = t.searchingText || "Searching...",
                        this.searchHighlight = void 0 !== t.searchHighlight && t.searchHighlight,
                        this.closeOnSelect = void 0 === t.closeOnSelect || t.closeOnSelect,
                        this.contentLocation = t.contentLocation || document.body,
                        this.contentPosition = t.contentPosition || "absolute",
                        this.openPosition = t.openPosition || "auto",
                        this.placeholderText = void 0 !== t.placeholderText ? t.placeholderText : "Select Value",
                        this.allowDeselect = void 0 !== t.allowDeselect && t.allowDeselect,
                        this.hideSelected = void 0 !== t.hideSelected && t.hideSelected,
                        this.keepOrder = void 0 !== t.keepOrder && t.keepOrder,
                        this.showOptionTooltips = void 0 !== t.showOptionTooltips && t.showOptionTooltips,
                        this.minSelected = t.minSelected || 0,
                        this.maxSelected = t.maxSelected || 1e3,
                        this.timeoutDelay = t.timeoutDelay || 200,
                        this.maxValuesShown = t.maxValuesShown || 20,
                        this.maxValuesMessage = t.maxValuesMessage || "{number} selected"
                    }
                }
                class u {
                    constructor(e) {
                        var i;
                        if (this.events = {
                            search: void 0,
                            searchFilter: (e, t) => -1 !== e.text.toLowerCase().indexOf(t.toLowerCase()),
                            addable: void 0,
                            beforeChange: void 0,
                            afterChange: void 0,
                            beforeOpen: void 0,
                            afterOpen: void 0,
                            beforeClose: void 0,
                            afterClose: void 0
                        },
                        this.windowResize = s(( () => {
                            (this.settings.isOpen || this.settings.isFullOpen) && this.render.moveContent()
                        }
                        )),
                        this.windowScroll = s(( () => {
                            (this.settings.isOpen || this.settings.isFullOpen) && this.render.moveContent()
                        }
                        )),
                        this.documentClick = e => {
                            this.settings.isOpen && e.target && !t(e.target, this.settings.id) && this.close(e.type)
                        }
                        ,
                        this.windowVisibilityChange = () => {
                            document.hidden && this.close()
                        }
                        ,
                        this.selectEl = "string" == typeof e.select ? document.querySelector(e.select) : e.select,
                        !this.selectEl)
                            return void (e.events && e.events.error && e.events.error(new Error("Could not find select element")));
                        if ("SELECT" !== this.selectEl.tagName)
                            return void (e.events && e.events.error && e.events.error(new Error("Element isnt of type select")));
                        this.selectEl.dataset.ssid && this.destroy(),
                        this.settings = new d(e.settings);
                        const n = ["afterChange", "beforeOpen", "afterOpen", "beforeClose", "afterClose"];
                        for (const t in e.events)
                            e.events.hasOwnProperty(t) && (-1 !== n.indexOf(t) ? this.events[t] = s(e.events[t], 100) : this.events[t] = e.events[t]);
                        this.settings.disabled = (null === (i = e.settings) || void 0 === i ? void 0 : i.disabled) ? e.settings.disabled : this.selectEl.disabled,
                        this.settings.isMultiple = this.selectEl.multiple,
                        this.settings.style = this.selectEl.style.cssText,
                        this.settings.class = this.selectEl.className.split(" "),
                        this.select = new c(this.selectEl),
                        this.select.updateSelect(this.settings.id, this.settings.style, this.settings.class),
                        this.select.hideUI(),
                        this.select.onValueChange = e => {
                            this.setSelected(e)
                        }
                        ,
                        this.select.onClassChange = e => {
                            this.settings.class = e,
                            this.render.updateClassStyles()
                        }
                        ,
                        this.select.onDisabledChange = e => {
                            e ? this.disable() : this.enable()
                        }
                        ,
                        this.select.onOptionsChange = e => {
                            this.setData(e)
                        }
                        ,
                        this.store = new o(this.settings.isMultiple ? "multiple" : "single",e.data ? e.data : this.select.getData()),
                        e.data && this.select.updateOptions(this.store.getData());
                        const a = {
                            open: this.open.bind(this),
                            close: this.close.bind(this),
                            addable: this.events.addable ? this.events.addable : void 0,
                            setSelected: this.setSelected.bind(this),
                            addOption: this.addOption.bind(this),
                            search: this.search.bind(this),
                            beforeChange: this.events.beforeChange,
                            afterChange: this.events.afterChange
                        };
                        this.render = new l(this.settings,this.store,a),
                        this.render.renderValues(),
                        this.render.renderOptions(this.store.getData());
                        const r = this.selectEl.getAttribute("aria-label")
                          , u = this.selectEl.getAttribute("aria-labelledby");
                        r ? this.render.main.main.setAttribute("aria-label", r) : u && this.render.main.main.setAttribute("aria-labelledby", u),
                        this.selectEl.parentNode && this.selectEl.parentNode.insertBefore(this.render.main.main, this.selectEl.nextSibling),
                        window.addEventListener("resize", this.windowResize, !1),
                        "auto" === this.settings.openPosition && window.addEventListener("scroll", this.windowScroll, !1),
                        document.addEventListener("visibilitychange", this.windowVisibilityChange),
                        this.settings.disabled && this.disable(),
                        this.settings.alwaysOpen && this.open(),
                        this.selectEl.slim = this
                    }
                    enable() {
                        this.settings.disabled = !1,
                        this.select.enable(),
                        this.render.enable()
                    }
                    disable() {
                        this.settings.disabled = !0,
                        this.select.disable(),
                        this.render.disable()
                    }
                    getData() {
                        return this.store.getData()
                    }
                    setData(e) {
                        const t = this.store.getSelected()
                          , s = this.store.validateDataArray(e);
                        if (s)
                            return void (this.events.error && this.events.error(s));
                        this.store.setData(e);
                        const n = this.store.getData();
                        this.select.updateOptions(n),
                        this.render.renderValues(),
                        this.render.renderOptions(n),
                        this.events.afterChange && !i(t, this.store.getSelected()) && this.events.afterChange(this.store.getSelectedOptions())
                    }
                    getSelected() {
                        return this.store.getSelected()
                    }
                    setSelected(e, t=!0) {
                        const s = this.store.getSelected();
                        this.store.setSelectedBy("value", Array.isArray(e) ? e : [e]);
                        const n = this.store.getData();
                        this.select.updateOptions(n),
                        this.render.renderValues(),
                        "" !== this.render.content.search.input.value ? this.search(this.render.content.search.input.value) : this.render.renderOptions(n),
                        t && this.events.afterChange && !i(s, this.store.getSelected()) && this.events.afterChange(this.store.getSelectedOptions())
                    }
                    addOption(e) {
                        const t = this.store.getSelected();
                        this.store.getDataOptions().some((t => {
                            var s;
                            return t.value === (null !== (s = e.value) && void 0 !== s ? s : e.text)
                        }
                        )) || this.store.addOption(e);
                        const s = this.store.getData();
                        this.select.updateOptions(s),
                        this.render.renderValues(),
                        this.render.renderOptions(s),
                        this.events.afterChange && !i(t, this.store.getSelected()) && this.events.afterChange(this.store.getSelectedOptions())
                    }
                    open() {
                        this.settings.disabled || this.settings.isOpen || (this.events.beforeOpen && this.events.beforeOpen(),
                        this.render.open(),
                        this.settings.showSearch && this.render.searchFocus(),
                        this.settings.isOpen = !0,
                        setTimeout(( () => {
                            this.events.afterOpen && this.events.afterOpen(),
                            this.settings.isOpen && (this.settings.isFullOpen = !0),
                            document.addEventListener("click", this.documentClick)
                        }
                        ), this.settings.timeoutDelay),
                        "absolute" === this.settings.contentPosition && (this.settings.intervalMove && clearInterval(this.settings.intervalMove),
                        this.settings.intervalMove = setInterval(this.render.moveContent.bind(this.render), 500)))
                    }
                    close(e=null) {
                        this.settings.isOpen && !this.settings.alwaysOpen && (this.events.beforeClose && this.events.beforeClose(),
                        this.render.close(),
                        "" !== this.render.content.search.input.value && this.search(""),
                        this.render.mainFocus(e),
                        this.settings.isOpen = !1,
                        this.settings.isFullOpen = !1,
                        setTimeout(( () => {
                            this.events.afterClose && this.events.afterClose(),
                            document.removeEventListener("click", this.documentClick)
                        }
                        ), this.settings.timeoutDelay),
                        this.settings.intervalMove && clearInterval(this.settings.intervalMove))
                    }
                    search(e) {
                        if (this.render.content.search.input.value !== e && (this.render.content.search.input.value = e),
                        !this.events.search)
                            return void this.render.renderOptions("" === e ? this.store.getData() : this.store.search(e, this.events.searchFilter));
                        this.render.renderSearching();
                        const t = this.events.search(e, this.store.getSelectedOptions());
                        t instanceof Promise ? t.then((e => {
                            this.render.renderOptions(this.store.partialToFullData(e))
                        }
                        )).catch((e => {
                            this.render.renderError("string" == typeof e ? e : e.message)
                        }
                        )) : Array.isArray(t) ? this.render.renderOptions(this.store.partialToFullData(t)) : this.render.renderError("Search event must return a promise or an array of data")
                    }
                    destroy() {
                        document.removeEventListener("click", this.documentClick),
                        window.removeEventListener("resize", this.windowResize, !1),
                        "auto" === this.settings.openPosition && window.removeEventListener("scroll", this.windowScroll, !1),
                        document.removeEventListener("visibilitychange", this.windowVisibilityChange),
                        this.store.setData([]),
                        this.render.destroy(),
                        this.select.destroy()
                    }
                }
                return u
            }()
        }
    }
      , t = {};
    function s(i) {
        var n = t[i];
        if (void 0 !== n)
            return n.exports;
        var a = t[i] = {
            exports: {}
        };
        return e[i].call(a.exports, a, a.exports, s),
        a.exports
    }
    s.n = e => {
        var t = e && e.__esModule ? () => e.default : () => e;
        return s.d(t, {
            a: t
        }),
        t
    }
    ,
    s.d = (e, t) => {
        for (var i in t)
            s.o(t, i) && !s.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: t[i]
            })
    }
    ,
    s.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t),
    ( () => {
        "use strict";
        s(478),
        s(145),
        s(841);
        var e = function(e, t, s) {
            if (s || 2 === arguments.length)
                for (var i, n = 0, a = t.length; n < a; n++)
                    !i && n in t || (i || (i = Array.prototype.slice.call(t, 0, n)),
                    i[n] = t[n]);
            return e.concat(i || Array.prototype.slice.call(t))
        }
          , t = function(e, t, s) {
            this.name = e,
            this.version = t,
            this.os = s,
            this.type = "browser"
        }
          , i = function(e) {
            this.version = e,
            this.type = "node",
            this.name = "node",
            this.os = process.platform
        }
          , n = function(e, t, s, i) {
            this.name = e,
            this.version = t,
            this.os = s,
            this.bot = i,
            this.type = "bot-device"
        }
          , a = function() {
            this.type = "bot",
            this.bot = !0,
            this.name = "bot",
            this.version = null,
            this.os = null
        }
          , r = function() {
            this.type = "react-native",
            this.name = "react-native",
            this.version = null,
            this.os = null
        }
          , o = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/
          , l = 3
          , c = [["aol", /AOLShield\/([0-9\._]+)/], ["edge", /Edge\/([0-9\._]+)/], ["edge-ios", /EdgiOS\/([0-9\._]+)/], ["yandexbrowser", /YaBrowser\/([0-9\._]+)/], ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/], ["samsung", /SamsungBrowser\/([0-9\.]+)/], ["silk", /\bSilk\/([0-9._-]+)\b/], ["miui", /MiuiBrowser\/([0-9\.]+)$/], ["beaker", /BeakerBrowser\/([0-9\.]+)/], ["edge-chromium", /EdgA?\/([0-9\.]+)/], ["chromium-webview", /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/], ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/], ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/], ["fxios", /FxiOS\/([0-9\.]+)/], ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/], ["opera", /Opera\/([0-9\.]+)(?:\s|$)/], ["opera", /OPR\/([0-9\.]+)(:?\s|$)/], ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/], ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/], ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/], ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/], ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ["ie", /MSIE\s(7\.0)/], ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/], ["android", /Android\s([0-9\.]+)/], ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/], ["safari", /Version\/([0-9\._]+).*Safari/], ["facebook", /FB[AS]V\/([0-9\.]+)/], ["instagram", /Instagram\s([0-9\.]+)/], ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/], ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/], ["curl", /^curl\/([0-9\.]+)$/], ["searchbot", /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/]]
          , d = [["iOS", /iP(hone|od|ad)/], ["Android OS", /Android/], ["BlackBerry OS", /BlackBerry|BB10/], ["Windows Mobile", /IEMobile/], ["Amazon OS", /Kindle/], ["Windows 3.11", /Win16/], ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/], ["Windows 98", /(Windows 98)|(Win98)/], ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/], ["Windows XP", /(Windows NT 5.1)|(Windows XP)/], ["Windows Server 2003", /(Windows NT 5.2)/], ["Windows Vista", /(Windows NT 6.0)/], ["Windows 7", /(Windows NT 6.1)/], ["Windows 8", /(Windows NT 6.2)/], ["Windows 8.1", /(Windows NT 6.3)/], ["Windows 10", /(Windows NT 10.0)/], ["Windows ME", /Windows ME/], ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/], ["Open BSD", /OpenBSD/], ["Sun OS", /SunOS/], ["Chrome OS", /CrOS/], ["Linux", /(Linux)|(X11)/], ["Mac OS", /(Mac_PowerPC)|(Macintosh)/], ["QNX", /QNX/], ["BeOS", /BeOS/], ["OS/2", /OS\/2/]];
        function u(e) {
            return "" !== e && c.reduce((function(t, s) {
                var i = s[0]
                  , n = s[1];
                if (t)
                    return t;
                var a = n.exec(e);
                return !!a && [i, a]
            }
            ), !1)
        }
        function p(s) {
            var i = u(s);
            if (!i)
                return null;
            var r = i[0]
              , c = i[1];
            if ("searchbot" === r)
                return new a;
            var p = c[1] && c[1].split(".").join("_").split("_").slice(0, 3);
            p ? p.length < l && (p = e(e([], p, !0), function(e) {
                for (var t = [], s = 0; s < e; s++)
                    t.push("0");
                return t
            }(l - p.length), !0)) : p = [];
            var h = p.join(".")
              , m = function(e) {
                for (var t = 0, s = d.length; t < s; t++) {
                    var i = d[t]
                      , n = i[0];
                    if (i[1].exec(e))
                        return n
                }
                return null
            }(s)
              , f = o.exec(s);
            return f && f[1] ? new n(r,h,m,f[1]) : new t(r,h,m)
        }
        const h = m ? p(m) : "undefined" == typeof document && "undefined" != typeof navigator && "ReactNative" === navigator.product ? new r : "undefined" != typeof navigator ? p(navigator.userAgent) : function() {
            var e = "undefined" != typeof process && process.version;
            return e ? new i(process.version.slice(1)) : null
        }();
        var m;
        h && document.body.classList.add(`is-${h.name}`);
        s(855),
        s(219);
        var f = s(139)
          , g = s.n(f);
        function v(e, t, s) {
            void 0 === s && (s = {});
            var i = Object.assign({}, s, {
                g: e,
                email: t
            })
              , n = Object.keys(i).reduce((function(e, t) {
                return e.append(t, i[t]),
                e
            }
            ), new URLSearchParams);
            return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
                method: "POST",
                headers: {
                    "Access-Control-Allow-Headers": "*",
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
                },
                body: n
            }).then((function(e) {
                return e.json()
            }
            ))
        }
        null !== document.querySelector(".form-validate") && document.querySelectorAll(".form-validate").forEach((e => {
            const t = new (g())(e);
            e.addEventListener("submit", (function(e) {
                e.preventDefault();
                var s = t.validate();
                console.log(s)
            }
            ))
        }
        ));
        var y = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
          , b = /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g;
        function w(e, t, s, i, n) {
            i.querySelector(".klaviyo_messages").innerHTML = "",
            console.log(e),
            null === i.closest("#newsletter-popup-step-1") ? (i.classList.add("submitting"),
            null !== i.querySelector(".button-wrap") && i.querySelector(".button-wrap").classList.add("button-wrap-submitted"),
            i.querySelector("button[type='submit']").textContent = "Submitting...") : i.querySelector("button[type='submit']").textContent = "Continuing...",
            s.length > 1 && s.match(y) && 123456 !== e ? v(e, s, t).then((e => {
                e.success ? (i.querySelector(".klaviyo_messages").style.display = "none",
                n.length ? window.location.replace(n) : null === i.closest("#newsletter-popup-step-1") && (i.querySelector("button[type='submit']").textContent = "Success!"),
                null !== i.closest("#newsletter-popup-step-1") ? setTimeout(( () => {
                    var e, t;
                    i.closest(".newsletter-step").style.display = "none",
                    (e = i.closest(".newsletter-step").nextElementSibling).style.opacity = 0,
                    e.style.display = t || "block",
                    function t() {
                        var s = parseFloat(e.style.opacity);
                        (s += .025) > 1 || (e.style.opacity = s,
                        requestAnimationFrame(t))
                    }(),
                    i.closest(".newsletter-step").nextElementSibling.querySelector("form").setAttribute("data-email", s),
                    i.querySelectorAll(".form__input").forEach((e => {
                        e.value = ""
                    }
                    ))
                }
                ), 300) : (i.querySelectorAll(".form__input").forEach((e => {
                    e.value = ""
                }
                )),
                i.classList.add("success"),
                i.querySelector("[type='email']").value = "Success!")) : e.errors.forEach((function(e) {
                    i.classList.add("error"),
                    navigator.maxTouchPoints < 2 && (i.querySelector("[type='email']").value = ""),
                    setTimeout(( () => {
                        i.querySelector("button[type='submit']").textContent = "Oops please try again!"
                    }
                    ), 350)
                }
                )),
                null === i.closest("#newsletter-popup-step-1") && i.classList.remove("submitting")
            }
            )) : (i.classList.add("error"),
            navigator.maxTouchPoints < 2 && (i.querySelector("[type='email']").value = ""),
            setTimeout(( () => {
                i.querySelector("button[type='submit']").textContent = "Oops please try again!"
            }
            ), 350),
            setTimeout(( () => {
                i.classList.remove("submitting")
            }
            ), 1500))
        }
        null !== document.querySelector(".klaviyo-newsletter") && document.querySelectorAll(".klaviyo-newsletter").forEach((e => {
            const t = e.querySelector(".form__input")
              , s = e.querySelector(".form__loader")
              , i = e.querySelector("button[type='submit']").textContent
              , n = () => {
                const n = t.value;
                "Oops please try again!" === n && (t.value = ""),
                null !== e.querySelector(".button-wrap") && e.querySelector(".button-wrap").classList.remove("button-wrap-submitted"),
                e.classList.remove("success"),
                e.classList.remove("error"),
                e.querySelector("button[type='submit']").textContent = i,
                n.length ? null !== s && s.classList.add("invisible") : null !== s && s.classList.remove("invisible")
            }
            ;
            e.querySelector("button[type='submit']").addEventListener("mouseleave", ( () => {
                e.classList.contains("success") || e.classList.contains("submitting") || null !== e.closest("#newsletter-popup-step-1") || (null !== e.querySelector(".button-wrap") && e.querySelector(".button-wrap").classList.remove("button-wrap-submitted"),
                e.classList.remove("error"),
                "Success!" === t.value && (t.value = ""),
                e.querySelector("button[type='submit']").textContent = i)
            }
            )),
            document.addEventListener("click", (function(s) {
                !e.contains(s.target) && (e.classList.remove("success"),
                e.classList.remove("submitting"),
                null !== e.querySelector(".button-wrap") && e.querySelector(".button-wrap").classList.remove("button-wrap-submitted"),
                e.classList.remove("error"),
                "Success!" === t.value && (t.value = ""),
                e.querySelector("button[type='submit']").textContent = i)
            }
            )),
            t.addEventListener("change", n, !1),
            t.addEventListener("input", n, !1),
            t.addEventListener("focus", n, !1);
            const a = e.querySelector("[type='submit']")
              , r = e.querySelector("[type='email']")
              , o = e.querySelector("[name='g']").value;
            let l = []
              , c = {}
              , d = {};
            e.addEventListener("submit", (function(t) {
                t.preventDefault(),
                console.log("---------Submitting form-----------"),
                l = ["Accepts Marketing"],
                c = {},
                d = {},
                e.querySelectorAll("input").forEach((e => {
                    "submit" !== e.type && "hidden" !== e.type && "email" !== e.type && "$first_name" !== e.name && "$last_name" !== e.name && (l.push(e.name),
                    c[e.name] = e.value)
                }
                )),
                e.querySelectorAll("textarea").forEach((e => {
                    l.push(e.name),
                    c[e.name] = e.value
                }
                )),
                e.querySelectorAll("select").forEach((e => {
                    l.push(e.name),
                    c[e.name] = e.value
                }
                )),
                null !== e.querySelector("[name='$first_name']") && (c.$first_name = e.querySelector("[name='$first_name']").value),
                null !== e.querySelector("[name='$last_name']") && (c.$last_name = e.querySelector("[name='$last_name']").value),
                c["Accepts Marketing"] = !0,
                d = {
                    $fields: l,
                    ...c
                },
                w(o, d, r.value, e, "")
            }
            )),
            a.addEventListener("click", (t => {
                t.preventDefault(),
                console.log("---------Submitting form-----------"),
                l = ["Accepts Marketing"],
                c = {},
                d = {},
                e.querySelectorAll("input").forEach((e => {
                    "submit" !== e.type && "hidden" !== e.type && "email" !== e.type && "$consent" !== e.name && "$first_name" !== e.name && "$last_name" !== e.name && (l.push(e.name),
                    c[e.name] = e.value)
                }
                )),
                e.querySelectorAll("textarea").forEach((e => {
                    l.push(e.name),
                    c[e.name] = e.value
                }
                )),
                e.querySelectorAll("select").forEach((e => {
                    l.push(e.name),
                    c[e.name] = e.value
                }
                )),
                null !== e.querySelector("[name='$first_name']") && (c.$first_name = e.querySelector("[name='$first_name']").value),
                null !== e.querySelector("[name='$last_name']") && (c.$last_name = e.querySelector("[name='$last_name']").value),
                c["Accepts Marketing"] = !0,
                d = {
                    $fields: l,
                    ...c
                },
                w(o, d, r.value, e, "")
            }
            ))
        }
        )),
        null !== document.querySelector(".klaviyo-sms") && document.querySelectorAll(".klaviyo-sms").forEach((e => {
            const t = e.querySelector("[type='submit']")
              , s = e.querySelector(".form__input")
              , i = (e.hasAttribute("data-email") && e.getAttribute("data-email"),
            e.querySelector("button[type='submit']").textContent)
              , n = () => {
                "Oops please try again!" === s.value && (s.value = ""),
                null !== e.querySelector(".button-wrap") && e.querySelector(".button-wrap").classList.remove("button-wrap-submitted"),
                e.classList.remove("success"),
                e.classList.remove("error"),
                e.querySelector("button[type='submit']").textContent = i
            }
            ;
            document.addEventListener("click", (function(t) {
                !e.contains(t.target) && (e.classList.remove("success"),
                e.classList.remove("submitting"),
                null !== e.querySelector(".button-wrap") && e.querySelector(".button-wrap").classList.remove("button-wrap-submitted"),
                e.classList.remove("error"),
                "Success!" === s.value && (s.value = ""),
                e.querySelector("button[type='submit']").textContent = i)
            }
            )),
            s.addEventListener("change", n, !1),
            s.addEventListener("input", n, !1),
            s.addEventListener("focus", n, !1);
            const a = (e, t) => {
                t.classList.add("submitting"),
                null !== t.querySelector(".button-wrap") && t.querySelector(".button-wrap").classList.add("button-wrap-submitted"),
                t.querySelector("button[type='submit']").textContent = "Submitting...",
                e.length > 1 && e.match(b) ? fetch(`https://remedy-skinpedia.netlify.app/.netlify/functions/update-sms-consent?email=${t.getAttribute("data-email")}&phone=${e}`).then((function(e) {
                    console.log(e),
                    t.querySelector("button[type='submit']").textContent = "Success!",
                    t.classList.add("success"),
                    t.querySelector("[type='tel']").value = "Success!",
                    t.classList.remove("submitting"),
                    null !== document.getElementById("newsletter-popup") && document.getElementById("newsletter-popup").classList.contains("active") && setTimeout(( () => {
                        document.getElementById("newsletter-popup").classList.remove("active"),
                        setTimeout((function() {
                            document.querySelector("html").classList.remove("frozen")
                        }
                        ), 300)
                    }
                    ), 600)
                }
                )).catch((function() {
                    t.classList.add("error"),
                    navigator.maxTouchPoints < 2 && (t.querySelector("[type='tel']").value = ""),
                    setTimeout(( () => {
                        t.querySelector("button[type='submit']").textContent = "Oops please try again!"
                    }
                    ), 350),
                    setTimeout(( () => {
                        t.classList.remove("submitting")
                    }
                    ), 1500)
                }
                )) : (t.classList.add("error"),
                navigator.maxTouchPoints < 2 && (t.querySelector("[type='tel']").value = ""),
                setTimeout(( () => {
                    t.querySelector("button[type='submit']").textContent = "Oops please try again!"
                }
                ), 350),
                setTimeout(( () => {
                    t.classList.remove("submitting")
                }
                ), 1500))
            }
            ;
            e.addEventListener("submit", (function(t) {
                t.preventDefault(),
                a(s.value, e)
            }
            )),
            t.addEventListener("click", (t => {
                t.preventDefault(),
                a(s.value, e)
            }
            ))
        }
        ));
        const S = (e, t, s, i) => {
            var n = new Headers;
            n.append("revision", "2023-08-15"),
            n.append("Content-Type", "application/json");
            let a = {
                method: "POST",
                headers: n,
                body: JSON.stringify({
                    data: {
                        type: "back-in-stock-subscription",
                        attributes: {
                            profile: {
                                data: {
                                    type: "profile",
                                    attributes: {
                                        email: `${e}`
                                    }
                                }
                            },
                            channels: ["EMAIL"]
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: "catalog-variant",
                                    id: `$shopify:::$default:::${t}`
                                }
                            }
                        }
                    }
                }),
                redirect: "follow"
            };
            if (null !== document.getElementById("back-in-stock-form")) {
                document.getElementById("back-in-stock-form").querySelector(".klaviyo_messages").innerHTML = ""
            }
            fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${s}`, a).then((e => e.text())).then((t => {
                if (console.log(t),
                null !== document.getElementById("back-in-stock-form")) {
                    const e = document.getElementById("back-in-stock-form").querySelector(".klaviyo_messages");
                    e.style.display = "block",
                    e.innerHTML = "You're in! We'll let you know when it's back."
                }
                i && v(i, e).then((t => {
                    console.log(`${e} SUBSCRIBED TO ${i}`)
                }
                ))
            }
            )).catch((e => console.log("error", e)))
        }
        ;
        if (null !== document.getElementById("back-in-stock-form")) {
            const ii = document.getElementById("back-in-stock-form")
              , ni = ii.querySelector(".form__input")
              , ai = ii.querySelector(".form__loader")
              , ri = ii.querySelector("button[type='submit']").textContent
              , oi = () => {
                const e = ni.value;
                if (null !== document.getElementById("back-in-stock-form")) {
                    const e = document.getElementById("back-in-stock-form").querySelector(".klaviyo_messages");
                    e.innerHTML = "",
                    e.style.display = "none"
                }
                "Oops, please try again!" === e && (ni.value = ""),
                ii.classList.remove("error"),
                ii.querySelector("button[type='submit']").textContent = ri,
                e.length ? (ni.classList.remove("text-transparent"),
                ni.classList.remove("placeholder:text-transparent"),
                null !== ai && ai.classList.add("invisible")) : (ni.classList.add("text-transparent"),
                ni.classList.add("placeholder:text-transparent"),
                null !== ai && ai.classList.remove("invisible"))
            }
            ;
            ni.addEventListener("change", oi, !1),
            ni.addEventListener("input", oi, !1),
            ni.addEventListener("focus", oi, !1);
            const li = (e, t, s, i) => {
                e.length > 1 && e.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ? S(e, t, s, i) : (ii.classList.add("error"),
                navigator.maxTouchPoints < 2 && (ni.value = "Oops!"),
                ni.classList.remove("text-transparent"),
                ni.classList.remove("placeholder:text-transparent"),
                null !== ii.querySelector(".form-group__has-loader") && (ii.querySelector(".form-group").classList.remove("form-group__has-loader"),
                ii.querySelector(".form__loader").classList.add("invisible")),
                ii.querySelector("button[type='submit']").textContent = "Oops, please try again!")
            }
            ;
            ii.addEventListener("submit", (function(e) {
                e.preventDefault(),
                li(ii.querySelector(".form__input").value, ii.querySelector("#back-in-stock-variant").value, "TQRt8a", "WnHpHJ")
            }
            )),
            ii.querySelector("button[type='submit']").addEventListener("click", (function(e) {
                e.preventDefault(),
                li(ii.querySelector(".form__input").value, ii.querySelector("#back-in-stock-variant").value, "TQRt8a", "WnHpHJ")
            }
            ))
        }
        window.klaviyoBIS = S,
        window.openKlaviyoBISPopup = (e, t) => {
            document.getElementById("back-in-stock").classList.add("active"),
            document.getElementById("back-in-stock-variant").value = e,
            document.getElementById("back-in-stock-title").textContent = t
        }
        ;
        var E = s(344)
          , x = s.n(E);
        if (null !== document.querySelector(".toggle-trigger")) {
            document.querySelectorAll(".toggle-trigger").forEach((e => {
                e.addEventListener("click", (function(t) {
                    var s = document.getElementById(this.dataset.container);
                    if (s.classList.contains("active"))
                        s.style.height = "0px",
                        e.classList.remove("active"),
                        s.classList.remove("allow-overflow"),
                        s.addEventListener("transitionend", (function() {
                            s.classList.remove("active")
                        }
                        ), {
                            once: !0
                        });
                    else {
                        e.classList.add("active"),
                        s.classList.add("active"),
                        s.style.height = "auto";
                        var i = s.clientHeight + "px";
                        s.style.height = "0px",
                        setTimeout((function() {
                            s.style.height = i
                        }
                        ), 0),
                        setTimeout(( () => {
                            s.classList.add("allow-overflow")
                        }
                        ), 300)
                    }
                }
                ))
            }
            ))
        }
        null !== document.querySelector(".accordion-container") && document.querySelectorAll(".accordion-container").forEach((e => {
            let t;
            if (e.hasAttribute("data-accordion-multiple") && "true" === e.getAttribute("data-accordion-multiple"))
                t = new (x())(e,{
                    showMultiple: !0
                });
            else {
                t = new (x())(e,{
                    showMultiple: !1,
                    beforeOpen: function(t) {
                        null !== e.closest("[data-ingredient-nav-content]") && (console.log("closing"),
                        console.log(t),
                        e.closest("[data-ingredient-nav-content]").classList.contains("ac--closed") || e.closest("[data-ingredient-nav-content]").querySelectorAll(".ac-panel")[0].classList.add("[.ac.is-active_>_&]:!h-auto"))
                    },
                    onOpen: e => {
                        console.log(e),
                        window.scrollTo(0, e.getBoundingClientRect().top + window.scrollY - 50)
                    }
                })
            }
            t.closeAll(),
            e.classList.contains("accordion-container--open") && t.openAll(),
            e.querySelectorAll(".ac").forEach(( (e, s) => {
                e.classList.contains("ac--open") && t.open(s),
                setTimeout(( () => {
                    e.classList.contains("ac--solo") && t.open(s),
                    e.classList.contains("ac--closed") && (t.close(s),
                    e.querySelectorAll(".ac-panel")[0].style.height = 0,
                    e.classList.remove("is-active"))
                }
                ), 300)
            }
            )),
            e.querySelectorAll(".ac-trigger").forEach(( (t, s) => {
                t.addEventListener("click", (s => {
                    t.classList.contains("ac-trigger--nav-content-toggle") && t.closest("[data-ingredient-nav-content]").querySelectorAll(".ac-panel")[0].classList.remove("[.ac.is-active_>_&]:!h-auto"),
                    e.querySelectorAll(".ac").forEach((e => {
                        e.classList.remove("ac--open"),
                        e.classList.remove("ac--closed"),
                        e.classList.contains("is-active")
                    }
                    ))
                }
                ))
            }))
        }
        ));
        s(794),
        s(96),
        s(619);
        function T(e, t) {
            var s;
            return "string" == typeof e ? t ? (null !== (s = t[e]) && void 0 !== s || (t[e] = document.querySelectorAll(e)),
            e = t[e]) : e = document.querySelectorAll(e) : e instanceof Element && (e = [e]),
            Array.from(e || [])
        }
        const L = e => "function" == typeof e
          , A = {
            any: 0,
            all: 1
        };
        function C(e, t, {root: s, margin: i, amount: n="any"}={}) {
            if ("undefined" == typeof IntersectionObserver)
                return () => {}
                ;
            const a = T(e)
              , r = new WeakMap
              , o = new IntersectionObserver((e => {
                e.forEach((e => {
                    const s = r.get(e.target);
                    if (e.isIntersecting !== Boolean(s))
                        if (e.isIntersecting) {
                            const s = t(e);
                            L(s) ? r.set(e.target, s) : o.unobserve(e.target)
                        } else
                            s && (s(e),
                            r.delete(e.target))
                }
                ))
            }
            ),{
                root: s,
                rootMargin: i,
                threshold: "number" == typeof n ? n : A[n]
            });
            return a.forEach((e => o.observe(e))),
            () => o.disconnect()
        }
        const k = {
            duration: .3,
            delay: 0,
            endDelay: 0,
            repeat: 0,
            easing: "ease"
        }
          , q = {
            ms: e => 1e3 * e,
            s: e => e / 1e3
        }
          , M = () => {}
          , O = e => e;
        function _(e, t=!0) {
            if (e && "finished" !== e.playState)
                try {
                    e.stop ? e.stop() : (t && e.commitStyles(),
                    e.cancel())
                } catch (e) {}
        }
        const P = e => e()
          , I = (e, t, s=k.duration) => new Proxy({
            animations: e.map(P).filter(Boolean),
            duration: s,
            options: t
        },$)
          , $ = {
            get: (e, t) => {
                const s = e.animations[0];
                switch (t) {
                case "duration":
                    return e.duration;
                case "currentTime":
                    return q.s((null == s ? void 0 : s[t]) || 0);
                case "playbackRate":
                case "playState":
                    return null == s ? void 0 : s[t];
                case "finished":
                    return e.finished || (e.finished = Promise.all(e.animations.map(B)).catch(M)),
                    e.finished;
                case "stop":
                    return () => {
                        e.animations.forEach((e => _(e)))
                    }
                    ;
                case "forEachNative":
                    return t => {
                        e.animations.forEach((s => t(s, e)))
                    }
                    ;
                default:
                    return void 0 === (null == s ? void 0 : s[t]) ? void 0 : () => e.animations.forEach((e => e[t]()))
                }
            }
            ,
            set: (e, t, s) => {
                switch (t) {
                case "currentTime":
                    s = q.ms(s);
                case "playbackRate":
                    for (let i = 0; i < e.animations.length; i++)
                        e.animations[i][t] = s;
                    return !0
                }
                return !1
            }
        }
          , B = e => e.finished
          , D = e => "object" == typeof e && Boolean(e.createAnimation)
          , N = e => "number" == typeof e
          , z = e => Array.isArray(e) && !N(e[0])
          , F = (e, t, s) => -s * e + s * t + e
          , H = (e, t, s) => t - e == 0 ? 1 : (s - e) / (t - e);
        function R(e, t) {
            const s = e[e.length - 1];
            for (let i = 1; i <= t; i++) {
                const n = H(0, t, i);
                e.push(F(s, 1, n))
            }
        }
        function G(e) {
            const t = [0];
            return R(t, e - 1),
            t
        }
        const j = (e, t, s) => {
            const i = t - e;
            return ((s - e) % i + i) % i + e
        }
        ;
        const V = (e, t, s) => Math.min(Math.max(s, e), t);
        function W(e, t=G(e.length), s=O) {
            const i = e.length
              , n = i - t.length;
            return n > 0 && R(t, n),
            n => {
                let a = 0;
                for (; a < i - 2 && !(n < t[a + 1]); a++)
                    ;
                let r = V(0, 1, H(t[a], t[a + 1], n));
                const o = function(e, t) {
                    return z(e) ? e[j(0, e.length, t)] : e
                }(s, a);
                return r = o(r),
                F(e[a], e[a + 1], r)
            }
        }
        const Y = (e, t, s) => (((1 - 3 * s + 3 * t) * e + (3 * s - 6 * t)) * e + 3 * t) * e
          , X = 1e-7
          , U = 12;
        function K(e, t, s, i) {
            if (e === t && s === i)
                return O;
            const n = t => function(e, t, s, i, n) {
                let a, r, o = 0;
                do {
                    r = t + (s - t) / 2,
                    a = Y(r, i, n) - e,
                    a > 0 ? s = r : t = r
                } while (Math.abs(a) > X && ++o < U);
                return r
            }(t, 0, 1, e, s);
            return e => 0 === e || 1 === e ? e : Y(n(e), t, i)
        }
        const J = (e, t="end") => s => {
            const i = (s = "end" === t ? Math.min(s, .999) : Math.max(s, .001)) * e
              , n = "end" === t ? Math.floor(i) : Math.ceil(i);
            return V(0, 1, n / e)
        }
          , Q = e => Array.isArray(e) && N(e[0])
          , Z = {
            ease: K(.25, .1, .25, 1),
            "ease-in": K(.42, 0, 1, 1),
            "ease-in-out": K(.42, 0, .58, 1),
            "ease-out": K(0, 0, .58, 1)
        }
          , ee = /\((.*?)\)/;
        function te(e) {
            if (L(e))
                return e;
            if (Q(e))
                return K(...e);
            const t = Z[e];
            if (t)
                return t;
            if (e.startsWith("steps")) {
                const t = ee.exec(e);
                if (t) {
                    const e = t[1].split(",");
                    return J(parseFloat(e[0]), e[1].trim())
                }
            }
            return O
        }
        class se {
            constructor(e, t=[0, 1], {easing: s, duration: i=k.duration, delay: n=k.delay, endDelay: a=k.endDelay, repeat: r=k.repeat, offset: o, direction: l="normal", autoplay: c=!0}={}) {
                if (this.startTime = null,
                this.rate = 1,
                this.t = 0,
                this.cancelTimestamp = null,
                this.easing = O,
                this.duration = 0,
                this.totalDuration = 0,
                this.repeat = 0,
                this.playState = "idle",
                this.finished = new Promise(( (e, t) => {
                    this.resolve = e,
                    this.reject = t
                }
                )),
                s = s || k.easing,
                D(s)) {
                    const e = s.createAnimation(t);
                    s = e.easing,
                    t = e.keyframes || t,
                    i = e.duration || i
                }
                this.repeat = r,
                this.easing = z(s) ? O : te(s),
                this.updateDuration(i);
                const d = W(t, o, z(s) ? s.map(te) : O);
                this.tick = t => {
                    var s;
                    let i = 0;
                    i = void 0 !== this.pauseTime ? this.pauseTime : (t - this.startTime) * this.rate,
                    this.t = i,
                    i /= 1e3,
                    i = Math.max(i - n, 0),
                    "finished" === this.playState && void 0 === this.pauseTime && (i = this.totalDuration);
                    const r = i / this.duration;
                    let o = Math.floor(r)
                      , c = r % 1;
                    !c && r >= 1 && (c = 1),
                    1 === c && o--;
                    const u = o % 2;
                    ("reverse" === l || "alternate" === l && u || "alternate-reverse" === l && !u) && (c = 1 - c);
                    const p = i >= this.totalDuration ? 1 : Math.min(c, 1)
                      , h = d(this.easing(p));
                    e(h);
                    void 0 === this.pauseTime && ("finished" === this.playState || i >= this.totalDuration + a) ? (this.playState = "finished",
                    null === (s = this.resolve) || void 0 === s || s.call(this, h)) : "idle" !== this.playState && (this.frameRequestId = requestAnimationFrame(this.tick))
                }
                ,
                c && this.play()
            }
            play() {
                const e = performance.now();
                this.playState = "running",
                void 0 !== this.pauseTime ? this.startTime = e - this.pauseTime : this.startTime || (this.startTime = e),
                this.cancelTimestamp = this.startTime,
                this.pauseTime = void 0,
                this.frameRequestId = requestAnimationFrame(this.tick)
            }
            pause() {
                this.playState = "paused",
                this.pauseTime = this.t
            }
            finish() {
                this.playState = "finished",
                this.tick(0)
            }
            stop() {
                var e;
                this.playState = "idle",
                void 0 !== this.frameRequestId && cancelAnimationFrame(this.frameRequestId),
                null === (e = this.reject) || void 0 === e || e.call(this, !1)
            }
            cancel() {
                this.stop(),
                this.tick(this.cancelTimestamp)
            }
            reverse() {
                this.rate *= -1
            }
            commitStyles() {}
            updateDuration(e) {
                this.duration = e,
                this.totalDuration = e * (this.repeat + 1)
            }
            get currentTime() {
                return this.t
            }
            set currentTime(e) {
                void 0 !== this.pauseTime || 0 === this.rate ? this.pauseTime = e : this.startTime = performance.now() - e / this.rate
            }
            get playbackRate() {
                return this.rate
            }
            set playbackRate(e) {
                this.rate = e
            }
        }
        class ie {
            setAnimation(e) {
                this.animation = e,
                null == e || e.finished.then(( () => this.clearAnimation())).catch(( () => {}
                ))
            }
            clearAnimation() {
                this.animation = this.generator = void 0
            }
        }
        const ne = new WeakMap;
        function ae(e) {
            return ne.has(e) || ne.set(e, {
                transforms: [],
                values: new Map
            }),
            ne.get(e)
        }
        const re = ["", "X", "Y", "Z"]
          , oe = {
            x: "translateX",
            y: "translateY",
            z: "translateZ"
        }
          , le = {
            syntax: "<angle>",
            initialValue: "0deg",
            toDefaultUnit: e => e + "deg"
        }
          , ce = {
            translate: {
                syntax: "<length-percentage>",
                initialValue: "0px",
                toDefaultUnit: e => e + "px"
            },
            rotate: le,
            scale: {
                syntax: "<number>",
                initialValue: 1,
                toDefaultUnit: O
            },
            skew: le
        }
          , de = new Map
          , ue = e => `--motion-${e}`
          , pe = ["x", "y", "z"];
        ["translate", "scale", "rotate", "skew"].forEach((e => {
            re.forEach((t => {
                pe.push(e + t),
                de.set(ue(e + t), ce[e])
            }
            ))
        }
        ));
        const he = (e, t) => pe.indexOf(e) - pe.indexOf(t)
          , me = new Set(pe)
          , fe = e => me.has(e)
          , ge = (e, t) => {
            oe[t] && (t = oe[t]);
            const {transforms: s} = ae(e);
            var i, n;
            n = t,
            -1 === (i = s).indexOf(n) && i.push(n),
            e.style.transform = ve(s)
        }
          , ve = e => e.sort(he).reduce(ye, "").trim()
          , ye = (e, t) => `${e} ${t}(var(${ue(t)}))`
          , be = e => e.startsWith("--")
          , we = new Set;
        const Se = (e, t) => document.createElement("div").animate(e, t)
          , Ee = {
            cssRegisterProperty: () => "undefined" != typeof CSS && Object.hasOwnProperty.call(CSS, "registerProperty"),
            waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
            partialKeyframes: () => {
                try {
                    Se({
                        opacity: [1]
                    })
                } catch (e) {
                    return !1
                }
                return !0
            }
            ,
            finished: () => Boolean(Se({
                opacity: [0, 1]
            }, {
                duration: .001
            }).finished),
            linearEasing: () => {
                try {
                    Se({
                        opacity: 0
                    }, {
                        easing: "linear(0, 1)"
                    })
                } catch (e) {
                    return !1
                }
                return !0
            }
        }
          , xe = {}
          , Te = {};
        for (const ci in Ee)
            Te[ci] = () => (void 0 === xe[ci] && (xe[ci] = Ee[ci]()),
            xe[ci]);
        const Le = (e, t) => L(e) ? Te.linearEasing() ? `linear(${( (e, t) => {
            lets = "";
            const i = Math.round(t / .015);
            for (lett = 0; t < i; t++)
                s += e(H(0, i - 1, t)) + ", ";
            return s.substring(0, s.length - 2)
        }
        )(e, t)})` : k.easing : Q(e) ? Ae(e) : e
          , Ae = ([e,t,s,i]) => `cubic-bezier(${e}, ${t}, ${s}, ${i})`;
        const Ce = e => Array.isArray(e) ? e : [e];
        function ke(e) {
            return oe[e] && (e = oe[e]),
            fe(e) ? ue(e) : e
        }
        const qe = {
            get: (e, t) => {
                t = ke(t);
                let s = be(t) ? e.style.getPropertyValue(t) : getComputedStyle(e)[t];
                if (!s && 0 !== s) {
                    const e = de.get(t);
                    e && (s = e.initialValue)
                }
                return s
            }
            ,
            set: (e, t, s) => {
                t = ke(t),
                be(t) ? e.style.setProperty(t, s) : e.style[t] = s
            }
        }
          , Me = e => "string" == typeof e;
        function Oe(e, t, s, i={}, n) {
            const a = window.__MOTION_DEV_TOOLS_RECORD
              , r = !1 !== i.record && a;
            let o, {duration: l=k.duration, delay: c=k.delay, endDelay: d=k.endDelay, repeat: u=k.repeat, easing: p=k.easing, persist: h=!1, direction: m, offset: f, allowWebkitAcceleration: g=!1, autoplay: v=!0} = i;
            const y = ae(e)
              , b = fe(t);
            let w = Te.waapi();
            b && ge(e, t);
            const S = ke(t)
              , E = function(e, t) {
                return e.has(t) || e.set(t, new ie),
                e.get(t)
            }(y.values, S)
              , x = de.get(S);
            return _(E.animation, !(D(p) && E.generator) && !1 !== i.record),
            () => {
                const y = () => {
                    var t, s;
                    return null !== (s = null !== (t = qe.get(e, S)) && void 0 !== t ? t : null == x ? void 0 : x.initialValue) && void 0 !== s ? s : 0
                }
                ;
                let T = function(e, t) {
                    for (let s = 0; s < e.length; s++)
                        null === e[s] && (e[s] = s ? e[s - 1] : t());
                    return e
                }(Ce(s), y);
                const A = function(e, t) {
                    var s;
                    let i = (null == t ? void 0 : t.toDefaultUnit) || O;
                    const n = e[e.length - 1];
                    if (Me(n)) {
                        const e = (null === (s = n.match(/(-?[\d.]+)([a-z%]*)/)) || void 0 === s ? void 0 : s[2]) || "";
                        e && (i = t => t + e)
                    }
                    return i
                }(T, x);
                if (D(p)) {
                    const e = p.createAnimation(T, "opacity" !== t, y, S, E);
                    p = e.easing,
                    T = e.keyframes || T,
                    l = e.duration || l
                }
                if (be(S) && (Te.cssRegisterProperty() ? function(e) {
                    if (!we.has(e)) {
                        we.add(e);
                        try {
                            const {syntax: t, initialValue: s} = de.has(e) ? de.get(e) : {};
                            CSS.registerProperty({
                                name: e,
                                inherits: !1,
                                syntax: t,
                                initialValue: s
                            })
                        } catch (e) {}
                    }
                }(S) : w = !1),
                b && !Te.linearEasing() && (L(p) || z(p) && p.some(L)) && (w = !1),
                w) {
                    x && (T = T.map((e => N(e) ? x.toDefaultUnit(e) : e))),
                    1 !== T.length || Te.partialKeyframes() && !r || T.unshift(y());
                    const t = {
                        delay: q.ms(c),
                        duration: q.ms(l),
                        endDelay: q.ms(d),
                        easing: z(p) ? void 0 : Le(p, l),
                        direction: m,
                        iterations: u + 1,
                        fill: "both"
                    };
                    o = e.animate({
                        [S]: T,
                        offset: f,
                        easing: z(p) ? p.map((e => Le(e, l))) : void 0
                    }, t),
                    o.finished || (o.finished = new Promise(( (e, t) => {
                        o.onfinish = e,
                        o.oncancel = t
                    }
                    )));
                    const s = T[T.length - 1];
                    o.finished.then(( () => {
                        h || (qe.set(e, S, s),
                        o.cancel())
                    }
                    )).catch(M),
                    g || (o.playbackRate = 1.000001)
                } else if (n && b)
                    T = T.map((e => "string" == typeof e ? parseFloat(e) : e)),
                    1 === T.length && T.unshift(parseFloat(y())),
                    o = new n((t => {
                        qe.set(e, S, A ? A(t) : t)
                    }
                    ),T,Object.assign(Object.assign({}, i), {
                        duration: l,
                        easing: p
                    }));
                else {
                    const t = T[T.length - 1];
                    qe.set(e, S, x && N(t) ? x.toDefaultUnit(t) : t)
                }
                return r && a(e, t, T, {
                    duration: l,
                    delay: c,
                    easing: p,
                    repeat: u,
                    offset: f
                }, "motion-one"),
                E.setAnimation(o),
                o && !v && o.pause(),
                o
            }
        }
        const _e = (e, t) => e[t] ? Object.assign(Object.assign({}, e), e[t]) : Object.assign({}, e);
        function Pe(e=.1, {start: t=0, from: s=0, easing: i}={}) {
            return (n, a) => {
                const r = N(s) ? s : function(e, t) {
                    if ("first" === e)
                        return 0;
                    {
                        const s = t - 1;
                        return "last" === e ? s : s / 2
                    }
                }(s, a)
                  , o = Math.abs(r - n);
                let l = e * o;
                if (i) {
                    const t = a * e;
                    l = te(i)(l / t) * t
                }
                return t + l
            }
        }
        function Ie(e, t, s) {
            return L(e) ? e(t, s) : e
        }
        const $e = (Be = se,
        function(e, t, s={}) {
            const i = (e = T(e)).length;
            Boolean(i),
            Boolean(t);
            const n = [];
            for (let a = 0; a < i; a++) {
                const r = e[a];
                for (const e in t) {
                    const o = _e(s, e);
                    o.delay = Ie(o.delay, a, i);
                    const l = Oe(r, e, t[e], o, Be);
                    n.push(l)
                }
            }
            return I(n, s, s.duration)
        }
        );
        var Be;
        function De(e, t={}) {
            return I([ () => {
                const s = new se(e,[0, 1],t);
                return s.finished.catch(( () => {}
                )),
                s
            }
            ], t, t.duration)
        }
        function Ne(e, t, s) {
            return (L(e) ? De : $e)(e, t, s)
        }
        function ze(e, t) {
            var s = {};
            for (var i in e)
                Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (s[i] = e[i]);
            if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                var n = 0;
                for (i = Object.getOwnPropertySymbols(e); n < i.length; n++)
                    t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (s[i[n]] = e[i[n]])
            }
            return s
        }
        Object.create;
        Object.create;
        "function" == typeof SuppressedError && SuppressedError;
        const Fe = new WeakMap;
        let He;
        function Re({target: e, contentRect: t, borderBoxSize: s}) {
            var i;
            null === (i = Fe.get(e)) || void 0 === i || i.forEach((i => {
                i({
                    target: e,
                    contentSize: t,
                    get size() {
                        return function(e, t) {
                            if (t) {
                                const {inlineSize: e, blockSize: s} = t[0];
                                return {
                                    width: e,
                                    height: s
                                }
                            }
                            return e instanceof SVGElement && "getBBox"in e ? e.getBBox() : {
                                width: e.offsetWidth,
                                height: e.offsetHeight
                            }
                        }(e, s)
                    }
                })
            }
            ))
        }
        function Ge(e) {
            e.forEach(Re)
        }
        function je(e, t) {
            He || "undefined" != typeof ResizeObserver && (He = new ResizeObserver(Ge));
            const s = T(e);
            return s.forEach((e => {
                let s = Fe.get(e);
                s || (s = new Set,
                Fe.set(e, s)),
                s.add(t),
                null == He || He.observe(e)
            }
            )),
            () => {
                s.forEach((e => {
                    const s = Fe.get(e);
                    null == s || s.delete(t),
                    (null == s ? void 0 : s.size) || null == He || He.unobserve(e)
                }
                ))
            }
        }
        const Ve = new Set;
        let We;
        function Ye(e) {
            return Ve.add(e),
            We || (We = () => {
                const e = {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
                  , t = {
                    target: window,
                    size: e,
                    contentSize: e
                };
                Ve.forEach((e => e(t)))
            }
            ,
            window.addEventListener("resize", We)),
            () => {
                Ve.delete(e),
                !Ve.size && We && (We = void 0)
            }
        }
        const Xe = 50
          , Ue = {
            x: {
                length: "Width",
                position: "Left"
            },
            y: {
                length: "Height",
                position: "Top"
            }
        };
        function Ke(e, t, s, i) {
            const n = s[t]
              , {length: a, position: r} = Ue[t]
              , o = n.current
              , l = s.time;
            n.current = e[`scroll${r}`],
            n.scrollLength = e[`scroll${a}`] - e[`client${a}`],
            n.offset.length = 0,
            n.offset[0] = 0,
            n.offset[1] = n.scrollLength,
            n.progress = H(0, n.scrollLength, n.current);
            const c = i - l;
            var d, u;
            n.velocity = c > Xe ? 0 : (d = n.current - o,
            (u = c) ? d * (1e3 / u) : 0)
        }
        const Je = {
            Enter: [[0, 1], [1, 1]],
            Exit: [[0, 0], [1, 0]],
            Any: [[1, 0], [0, 1]],
            All: [[0, 0], [1, 1]]
        }
          , Qe = {
            start: 0,
            center: .5,
            end: 1
        };
        function Ze(e, t, s=0) {
            let i = 0;
            if (void 0 !== Qe[e] && (e = Qe[e]),
            Me(e)) {
                const t = parseFloat(e);
                e.endsWith("px") ? i = t : e.endsWith("%") ? e = t / 100 : e.endsWith("vw") ? i = t / 100 * document.documentElement.clientWidth : e.endsWith("vh") ? i = t / 100 * document.documentElement.clientHeight : e = t
            }
            return N(e) && (i = t * e),
            s + i
        }
        const et = [0, 0];
        function tt(e, t, s, i) {
            let n = Array.isArray(e) ? e : et
              , a = 0
              , r = 0;
            return N(e) ? n = [e, e] : Me(e) && (n = (e = e.trim()).includes(" ") ? e.split(" ") : [e, Qe[e] ? e : "0"]),
            a = Ze(n[0], s, i),
            r = Ze(n[1], t),
            a - r
        }
        const st = {
            x: 0,
            y: 0
        };
        function it(e, t, s) {
            let {offset: i=Je.All} = s;
            const {target: n=e, axis: a="y"} = s
              , r = "y" === a ? "height" : "width"
              , o = n !== e ? function(e, t) {
                let s = {
                    x: 0,
                    y: 0
                }
                  , i = e;
                for (; i && i !== t; )
                    if (i instanceof HTMLElement)
                        s.x += i.offsetLeft,
                        s.y += i.offsetTop,
                        i = i.offsetParent;
                    else if (i instanceof SVGGraphicsElement && "getBBox"in i) {
                        const {top: e, left: t} = i.getBBox();
                        for (s.x += t,
                        s.y += e; i && "svg" !== i.tagName; )
                            i = i.parentNode
                    }
                return s
            }(n, e) : st
              , l = n === e ? {
                width: e.scrollWidth,
                height: e.scrollHeight
            } : {
                width: n.clientWidth,
                height: n.clientHeight
            }
              , c = {
                width: e.clientWidth,
                height: e.clientHeight
            };
            t[a].offset.length = 0;
            let d = !t[a].interpolate;
            const u = i.length;
            for (let e = 0; e < u; e++) {
                const s = tt(i[e], c[r], l[r], o[a]);
                d || s === t[a].interpolatorOffsets[e] || (d = !0),
                t[a].offset[e] = s
            }
            d && (t[a].interpolate = W(G(u), t[a].offset),
            t[a].interpolatorOffsets = [...t[a].offset]),
            t[a].progress = t[a].interpolate(t[a].current)
        }
        function nt(e, t, s, i={}) {
            const n = i.axis || "y";
            return {
                measure: () => function(e, t=e, s) {
                    if (s.x.targetOffset = 0,
                    s.y.targetOffset = 0,
                    t !== e) {
                        let i = t;
                        for (; i && i != e; )
                            s.x.targetOffset += i.offsetLeft,
                            s.y.targetOffset += i.offsetTop,
                            i = i.offsetParent
                    }
                    s.x.targetLength = t === e ? t.scrollWidth : t.clientWidth,
                    s.y.targetLength = t === e ? t.scrollHeight : t.clientHeight,
                    s.x.containerLength = e.clientWidth,
                    s.y.containerLength = e.clientHeight
                }(e, i.target, s),
                update: t => {
                    !function(e, t, s) {
                        Ke(e, "x", t, s),
                        Ke(e, "y", t, s),
                        t.time = s
                    }(e, s, t),
                    (i.offset || i.target) && it(e, s, i)
                }
                ,
                notify: L(t) ? () => t(s) : at(t, s[n])
            }
        }
        function at(e, t) {
            return e.pause(),
            e.forEachNative(( (e, {easing: t}) => {
                var s, i;
                if (e.updateDuration)
                    t || (e.easing = O),
                    e.updateDuration(1);
                else {
                    const n = {
                        duration: 1e3
                    };
                    t || (n.easing = "linear"),
                    null === (i = null === (s = e.effect) || void 0 === s ? void 0 : s.updateTiming) || void 0 === i || i.call(s, n)
                }
            }
            )),
            () => {
                e.currentTime = t.progress
            }
        }
        const rt = new WeakMap
          , ot = new WeakMap
          , lt = new WeakMap
          , ct = e => e === document.documentElement ? window : e;
        function dt(e, t={}) {
            var {container: s=document.documentElement} = t
              , i = ze(t, ["container"]);
            let n = lt.get(s);
            n || (n = new Set,
            lt.set(s, n));
            const a = nt(s, e, {
                time: 0,
                x: {
                    current: 0,
                    offset: [],
                    progress: 0,
                    scrollLength: 0,
                    targetOffset: 0,
                    targetLength: 0,
                    containerLength: 0,
                    velocity: 0
                },
                y: {
                    current: 0,
                    offset: [],
                    progress: 0,
                    scrollLength: 0,
                    targetOffset: 0,
                    targetLength: 0,
                    containerLength: 0,
                    velocity: 0
                }
            }, i);
            if (n.add(a),
            !rt.has(s)) {
                const e = () => {
                    const e = performance.now();
                    for (const e of n)
                        e.measure();
                    for (const t of n)
                        t.update(e);
                    for (const e of n)
                        e.notify()
                }
                ;
                rt.set(s, e);
                const t = ct(s);
                window.addEventListener("resize", e, {
                    passive: !0
                }),
                s !== document.documentElement && ot.set(s, (o = e,
                L(r = s) ? Ye(r) : je(r, o))),
                t.addEventListener("scroll", e, {
                    passive: !0
                })
            }
            var r, o;
            const l = rt.get(s)
              , c = requestAnimationFrame(l);
            return () => {
                var t;
                "function" != typeof e && e.stop(),
                cancelAnimationFrame(c);
                const i = lt.get(s);
                if (!i)
                    return;
                if (i.delete(a),
                i.size)
                    return;
                const n = rt.get(s);
                rt.delete(s),
                n && (ct(s).removeEventListener("scroll", n),
                null === (t = ot.get(s)) || void 0 === t || t(),
                window.removeEventListener("resize", n))
            }
        }
        if (null !== document.querySelector("[data-viewport]") && document.querySelectorAll("[data-viewport]").forEach((e => {
            let t = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(1e3 * e.getAttribute("data-viewport-delay"))),
            C(e, ( () => {
                setTimeout(( () => {
                    e.classList.add("in-view")
                }
                ), t)
            }
            ))
        }
        )),
        null !== document.querySelector('[data-viewport="typography-shift"]') && document.querySelectorAll('[data-viewport="typography-shift"]').forEach((e => {
            let t = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            C(e, ( ({target: e}) => {
                Ne(e.querySelector("span"), {
                    y: ["100%", "0"],
                    opacity: ["0", "1"]
                }, {
                    duration: .75,
                    delay: t,
                    easing: [.25, 1, .5, 1]
                })
            }
            ))
        }
        )),
        null !== document.querySelector(".shopify-policy__title")) {
            const di = document.querySelector(".shopify-policy__title h1");
            di.innerHTML = `<span>${di.textContent}</span>`,
            setTimeout(( () => {
                di.parentElement.style.opacity = 1
            }
            ), 50),
            C(di, ( ({target: e}) => {
                Ne(e.querySelector("span"), {
                    opacity: ["0", "1"]
                }, {
                    duration: .75,
                    delay: .15,
                    easing: [.25, 1, .5, 1]
                })
            }
            ))
        }
        if (null !== document.querySelector('[data-viewport="shift-up"]') && document.querySelectorAll('[data-viewport="shift-up"]').forEach((e => {
            let t = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            C(e, ( ({target: e}) => {
                Ne(e, {
                    y: ["100%", "0"],
                    opacity: ["0", "1"]
                }, {
                    duration: .75,
                    delay: t,
                    easing: [.25, 1, .5, 1]
                })
            }
            ))
        }
        )),
        null !== document.querySelector('[data-viewport="scale-in"]') && document.querySelectorAll('[data-viewport="scale-in"]').forEach((e => {
            let t = 0
              , s = .75;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            e.getAttribute("data-viewport-duration") && (s = Number(e.getAttribute("data-viewport-duration"))),
            C(e, ( ({target: e}) => {
                Ne(e, {
                    scale: ["1.05", "1"],
                    opacity: ["0", "1"]
                }, {
                    duration: 1.5,
                    delay: t,
                    easing: [.25, 1, .5, 1]
                })
            }
            ))
        }
        )),
        null !== document.querySelector('[data-viewport="fade-in"]') && document.querySelectorAll('[data-viewport="fade-in"]').forEach((e => {
            let t = 0
              , s = "any";
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            e.getAttribute("data-viewport-amount") && (s = Number(e.getAttribute("data-viewport-amount"))),
            C(e, ( ({target: e}) => {
                Ne(e, {
                    opacity: ["0", "1"]
                }, {
                    duration: .75,
                    delay: t,
                    easing: [.25, 1, .5, 1]
                })
            }
            ), {
                amount: s
            })
        }
        )),
        null !== document.querySelector("[data-viewport-color]") && document.querySelectorAll("[data-viewport-color]").forEach((e => {
            let t = 0
              , s = e.getAttribute("data-viewport-color");
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            C(e, ( ({target: e}) => {
                Ne(e, {
                    color: s
                }, {
                    duration: .75,
                    delay: t,
                    easing: [.25, 1, .5, 1]
                })
            }
            ))
        }
        )),
        null !== document.querySelector('[data-viewport="circle"]') && document.querySelectorAll('[data-viewport="circle"]').forEach((e => {
            let t = 300;
            e.getAttribute("data-viewport-delay") && (t = Number(1e3 * e.getAttribute("data-viewport-delay"))),
            C(e, ( () => {
                setTimeout(( () => {
                    e.classList.add("in-view")
                }
                ), t)
            }
            ))
        }
        )),
        null !== document.querySelector('[data-viewport="underline"]') && document.querySelectorAll('[data-viewport="underline"]').forEach((e => {
            let t = 300;
            e.getAttribute("data-viewport-delay") && (t = Number(1e3 * e.getAttribute("data-viewport-delay"))),
            C(e, ( () => {
                setTimeout(( () => {
                    e.classList.add("in-view")
                }
                ), t)
            }
            ))
        }
        )),
        null !== document.querySelector('[data-viewport="scale-on-scroll"]') && document.querySelectorAll('[data-viewport="scale-on-scroll"]').forEach((e => {
            let t = 0
              , s = .75;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            e.getAttribute("data-viewport-duration") && (s = Number(e.getAttribute("data-viewport-duration"))),
            dt(Ne(e, {
                scale: [1, 1.35]
            })),
            C(e, ( ({target: e}) => {
                Ne(e, {
                    scale: ["1.05", "1"],
                    opacity: ["0", "1"]
                }, {
                    duration: .75,
                    delay: t,
                    easing: [.25, 1, .5, 1]
                })
            }
            ))
        }
        )),
        null !== document.querySelector(".page-about .grid-text") && window.matchMedia("(min-width: 992px)").matches) {
            const ui = document.querySelectorAll(".page-about .grid-image");
            setTimeout(( () => {
                ui.forEach(( (e, t) => {
                    dt((e => {
                        const {progress: s} = e.y;
                        s > .3 && document.querySelectorAll(".page-about .grid-text")[t].querySelectorAll("[data-viewport]").forEach((e => {
                            e.classList.add("is-active")
                        }
                        ))
                    }
                    ), {
                        target: e,
                        offset: ["-300px", "200px", "1600px", "2100px"]
                    }),
                    dt(Ne(document.querySelectorAll(".page-about .grid-text")[t], {
                        visibility: ["hidden", "visible", "visible", "hidden"],
                        opacity: [0, 1, 1, 0]
                    }), {
                        target: e,
                        offset: [0 === t ? "-300px" : "0", "200px", "1600px", "2100px"]
                    })
                }
                ))
            }
            ), 500)
        }
        if (null !== document.querySelector(".scroller-section")) {
            const pi = document.querySelectorAll(".scroller-section")
              , hi = document.querySelector(".scroller-cats")
              , mi = document.querySelector(".scroller-cats-overlay")
              , fi = document.querySelector(".scroller-cats-mobile")
              , gi = document.querySelector(".scroller").nextElementSibling ? document.querySelector(".scroller").nextElementSibling : document.getElementById("shopify-section-footer");
            let vi = [];
            if (pi.forEach((e => {
                if (e.hasAttribute("data-cat"))
                    if (vi.some((t => t.name === e.getAttribute("data-cat")))) {
                        let t = vi.findIndex((t => t.name === e.getAttribute("data-cat")));
                        vi[t].height += e.clientHeight
                    } else {
                        let t = {};
                        t.name = e.getAttribute("data-cat"),
                        t.height = e.clientHeight,
                        vi.push(t)
                    }
            }
            )),
            vi.map((e => {
                document.getElementById(`scroller-cat-height-${e.name}`).style.height = e.height + 800 + "px"
            }
            )),
            pi.forEach(( (e, t) => {
                e.getAttribute("data-image");
                let s = e.clientHeight;
                e.getAttribute("data-cat");
                let i;
                i = window.innerWidth < 768 ? t === pi.length - 1 ? ["-800px", (s - t == 0 ? 200 : 600) + "px"] : 0 === t ? ["-800px", "-400px"] : ["-400px", (s - t == 0 ? 200 : 600) + "px"] : t === pi.length - 1 ? ["-800px", s - 150 + "px"] : 0 === t ? ["-400px", s - 300 + "px"] : ["-600px", s - 225 + "px"],
                dt(Ne(e.querySelector(".container"), {
                    visibility: ["hidden", "visible", "visible", t === pi.length - 1 ? "visible" : "hidden"],
                    opacity: [0, 1, 1, t === pi.length - 1 ? 1 : 0]
                }), {
                    target: e,
                    offset: i
                });
                if ([...e.querySelector(".container").children].forEach((t => {
                    if (null !== t.getAttribute("data-keyframe-animations") && null !== t.getAttribute("data-keyframe-offsets")) {
                        let s = t.getAttribute("data-keyframe-animations")
                          , i = t.getAttribute("data-keyframe-offsets");
                        if (s.length && i.length) {
                            let n = s.replace(/\s+/g, "").trim().split(",")
                              , a = s.replace(/\bvisible\b|\bhidden\b/g, (function(e) {
                                return "visible" === e ? 1 : 0
                            }
                            )).trim().split(",").map(Number)
                              , r = i.replace(/\s+/g, "").trim().split(",");
                            dt(Ne(t, {
                                visibility: n,
                                opacity: a
                            }), {
                                target: e,
                                offset: r
                            })
                        }
                    }
                }
                )),
                null !== e.querySelector(".nested-container")) {
                    [...e.querySelector(".nested-container").children].forEach((t => {
                        if (null !== t.getAttribute("data-keyframe-animations") && null !== t.getAttribute("data-keyframe-offsets")) {
                            let s = t.getAttribute("data-keyframe-animations")
                              , i = t.getAttribute("data-keyframe-offsets");
                            if (s.length && i.length) {
                                let n = s.replace(/\s+/g, "").trim().split(",")
                                  , a = s.replace(/\bvisible\b|\bhidden\b/g, (function(e) {
                                    return "visible" === e ? 1 : 0
                                }
                                )).trim().split(",").map(Number)
                                  , r = i.replace(/\s+/g, "").trim().split(",");
                                dt(Ne(t, {
                                    visibility: n,
                                    opacity: a
                                }), {
                                    target: e,
                                    offset: r
                                })
                            }
                        }
                    }
                    ))
                }
            }
            )),
            window.matchMedia("(min-width: 768px)").matches) {
                const yi = () => {
                    document.querySelectorAll(".scroller-image").forEach((e => {
                        e.style.height = "100%",
                        e.querySelector(".scroller-image-media").style.height = "100%"
                    }
                    ))
                }
                ;
                function bi(e, t) {
                    const s = e
                      , i = t;
                    let n = Number(s.getAttribute("data-height"))
                      , a = s.nextElementSibling;
                    for (; a && a !== i; )
                        n += Number(a.getAttribute("data-height")),
                        a = a.nextElementSibling;
                    return null !== i && (n += Number(i.getAttribute("data-height"))),
                    n
                }
                yi(),
                window.addEventListener("resize", yi, {
                    passive: !0
                }),
                document.querySelectorAll(".scroller-section--media-start").forEach(( (e, t) => {
                    let s = e.getAttribute("data-image");
                    e.clientHeight;
                    e.getAttribute("data-cat");
                    let i, n;
                    t === document.querySelectorAll(".scroller-section--media-start").length - 1 ? console.log(bi(e, e)) : console.log(bi(e, document.querySelectorAll(".scroller-section--media-start")[t + 1])),
                    i = t === document.querySelectorAll(".scroller-section--media-start").length - 1 ? bi(e, e) : bi(e, document.querySelectorAll(".scroller-section--media-start")[t + 1]),
                    n = window.innerWidth < 768 ? 0 === t ? ["0%", "0px", i + "px", i + 800 + "px"] : ["-400px", "0px", i + "px", i + 400 + "px"] : 0 === t ? ["-50%", "0px", i + "px", i + 800 + "px"] : ["-800px", "0px", i + "px", i + 800 + "px"],
                    dt(Ne(document.getElementById(s).querySelector(".scroller-image-media"), {
                        visibility: ["hidden", "visible", "visible", t === document.querySelectorAll(".scroller-section--media-start").length - 1 ? "visible" : "hidden"],
                        opacity: [0, 1, 1, t === document.querySelectorAll(".scroller-section--media-start").length - 1 ? 1 : 0]
                    }), {
                        target: e,
                        offset: n
                    })
                }
                ))
            }
            if (window.matchMedia("(max-width: 767px)").matches) {
                let wi, Si;
                wi = null !== document.querySelector(".scroller-image.scroller-image--mobile[data-index='0']") ? document.querySelector(".scroller-image.scroller-image--mobile[data-index='0']") : document.querySelectorAll(".scroller-image[data-index='0']")[0],
                dt(Ne(wi.querySelector(".scroller-image-media"), {
                    visibility: ["visible", "visible", "hidden"],
                    opacity: [1, 1, 0]
                }), {
                    target: document.querySelector(".scroller-section-hero"),
                    offset: ["0%", "40%", "60%"]
                }),
                dt(Ne(document.querySelector(".scroller-section-hero"), {
                    opacity: [1, 1, 0]
                }), {
                    target: document.querySelector(".scroller-section-hero"),
                    offset: ["0%", "40%", "60%"]
                }),
                Si = null !== document.querySelector(".scroller-image.scroller-image--mobile[data-index='1']") ? document.querySelector(".scroller-image.scroller-image--mobile[data-index='1']") : document.querySelectorAll(".scroller-image[data-index='1']")[0],
                dt(Ne(Si.querySelector(".scroller-image-media"), {
                    visibility: ["hidden", "hidden", "visible"],
                    opacity: [0, 0, 1]
                }), {
                    target: document.querySelector(".scroller-section-hero"),
                    offset: ["0%", "40%", "60%"]
                }),
                dt(Ne(document.querySelector(".scroller"), {
                    opacity: [1, 0]
                }), {
                    target: document.getElementById("shopify-section-footer"),
                    offset: ["start end", "end end"]
                }),
                dt(Ne(document.getElementById("swiper-cats"), {
                    opacity: [1, 0]
                }), {
                    target: gi,
                    offset: ["-200px", "-150px"]
                })
            }
            document.querySelectorAll(".scroller-section[data-cat]").forEach(( (e, t) => {
                C(e, ( () => {
                    setTimeout(( () => {
                        hi.classList.remove("opacity-0"),
                        hi.classList.add("opacity-30"),
                        mi.classList.remove("opacity-0"),
                        fi.classList.remove("opacity-0")
                    }
                    ), 300)
                }
                ))
            }
            )),
            document.querySelectorAll(".scroller-section:not([data-cat])").forEach(( (e, t) => {
                C(e, ( () => (Ne(document.querySelector(".scroller-cats"), {
                    opacity: 0
                }),
                Ne(document.querySelector(".scroller-cats-overlay"), {
                    opacity: 0
                }),
                Ne(document.querySelector(".scroller-cats-mobile"), {
                    opacity: 0
                }),
                e => {
                    Ne(document.querySelector(".scroller-cats"), {
                        opacity: .3
                    }),
                    Ne(document.querySelector(".scroller-cats-overlay"), {
                        opacity: 1
                    }),
                    Ne(document.querySelector(".scroller-cats-mobile"), {
                        opacity: 1
                    })
                }
                )))
            }
            )),
            document.querySelectorAll(".scroller-cats__item-height").forEach(( (e, t) => {
                e.style.top = document.querySelectorAll(".scroller-section--new")[t].offsetTop + "px";
                let s = e.getAttribute("data-category");
                dt(( ({y: e}) => {
                    let i = 100 * e.progress.toFixed(2)
                      , n = 16;
                    document.getElementById(`scroller-cat-dot-${s}`).style.top = 100 * e.progress.toFixed(2) + "%",
                    0 === t && (n = 0),
                    document.getElementById(`scroller-cat-dot-${s}`).style.opacity = i > n && i < 100 ? 1 : 0,
                    document.getElementById(`scroller-cat-line-${s}`).style.transform = 0 === i ? "scaleY(0)" : i > 99 ? "scaleY(1)" : i > 10 && i < 99 ? `scaleY(.${100 * e.progress.toFixed(2)})` : `scaleY(.${10 * e.progress.toFixed(2)})`,
                    i < n ? (document.getElementById(`scroller-cat-line-${s}`).style.opacity = 0,
                    document.getElementById(`scroller-cat-pill-${s}`).style.opacity = 0) : (document.getElementById(`scroller-cat-line-${s}`).style.opacity = 1,
                    document.getElementById(`scroller-cat-pill-${s}`).style.opacity = 1)
                }
                ), {
                    target: document.getElementById(`scroller-cat-height-${s}`),
                    offset: [0 === t ? "0%" : "start end", "end end"]
                })
            }
            ));
            dt(( ({y: e}) => {
                document.getElementById("scroller-cat-dot-mobile").style.left = 99 * e.progress.toFixed(2) + "%"
            }
            ), {
                target: document.querySelector(".scroller-section-list"),
                offset: ["start end", "end end"]
            }),
            C(gi, (e => {
                const t = pi[pi.length - 1];
                if (window.matchMedia("(min-width: 768px)").matches)
                    return t.classList.add("!items-end"),
                    t.querySelector(".container").classList.add("!absolute"),
                    t.querySelector(".container").classList.add("!top-auto"),
                    t.querySelector(".container").classList.add("!h-screen"),
                    hi.classList.add("!absolute"),
                    hi.classList.add("!transform-none"),
                    hi.classList.add("!top-auto"),
                    hi.style.bottom = "0px",
                    mi.classList.add("!absolute"),
                    mi.classList.add("!transform-none"),
                    mi.classList.add("!top-auto"),
                    mi.style.bottom = "0px",
                    fi.classList.add("!absolute"),
                    document.querySelectorAll(".scroller-image").forEach((e => {
                        e.classList.remove("md:fixed"),
                        e.classList.add("md:!bottom-0"),
                        e.classList.remove("md:!top-auto")
                    }
                    )),
                    document.querySelectorAll(".scroller-section").forEach((e => {
                        e.style.pointerEvents = "none"
                    }
                    )),
                    e => {
                        t.classList.remove("!items-end"),
                        t.querySelector(".container").classList.remove("!absolute"),
                        t.querySelector(".container").classList.remove("!top-auto"),
                        t.querySelector(".container").classList.remove("!h-screen"),
                        hi.classList.remove("!absolute"),
                        hi.classList.remove("!transform-none"),
                        hi.classList.remove("!top-auto"),
                        mi.classList.remove("!absolute"),
                        mi.classList.remove("!transform-none"),
                        mi.classList.remove("!top-auto"),
                        hi.style.bottom = "auto",
                        mi.style.bottom = "auto",
                        fi.classList.remove("!absolute"),
                        document.querySelectorAll(".scroller-image").forEach((e => {
                            e.classList.add("md:fixed"),
                            e.classList.remove("md:!bottom-0"),
                            e.classList.remove("md:!top-auto")
                        }
                        )),
                        document.querySelectorAll(".scroller-section").forEach((e => {
                            e.style.pointerEvents = "auto"
                        }
                        ))
                    }
            }
            )),
            C(document.getElementById("shopify-section-footer"), (e => {
                if (null !== document.querySelector(".scroller").nextElementSibling && window.matchMedia("(min-width: 768px)").matches)
                    return document.body.classList.add("footer-entered"),
                    e => {
                        document.body.classList.remove("footer-entered")
                    }
            }
            ))
        }
        if (null !== document.querySelector(".formulations-device")) {
            const Ei = document.querySelector(".formulations-device").clientHeight
              , xi = [...document.getElementById("device-images").children];
            dt(( ({y: e}) => {
                let t = 100 / document.getElementById("device-images").children.length
                  , s = 100 * e.progress + t
                  , i = Math.floor(s);
                xi.forEach((e => {
                    e.style.opacity = 0
                }
                )),
                null !== document.getElementById(`device-image-${i}`) && (document.getElementById(`device-image-${i}`).style.opacity = 1),
                i > xi.length && (document.getElementById(`device-image-${xi.length}`).style.opacity = 1)
            }
            ), {
                target: document.querySelector(".formulations-device"),
                offset: ["-1400px", `${Ei + 900}px`]
            })
        }
        s(30);
        function ut(e) {
            return null !== e && "object" == typeof e && "constructor"in e && e.constructor === Object
        }
        function pt(e, t) {
            void 0 === e && (e = {}),
            void 0 === t && (t = {}),
            Object.keys(t).forEach((s => {
                void 0 === e[s] ? e[s] = t[s] : ut(t[s]) && ut(e[s]) && Object.keys(t[s]).length > 0 && pt(e[s], t[s])
            }
            ))
        }
        const ht = {
            body: {},
            addEventListener() {},
            removeEventListener() {},
            activeElement: {
                blur() {},
                nodeName: ""
            },
            querySelector: () => null,
            querySelectorAll: () => [],
            getElementById: () => null,
            createEvent: () => ({
                initEvent() {}
            }),
            createElement: () => ({
                children: [],
                childNodes: [],
                style: {},
                setAttribute() {},
                getElementsByTagName: () => []
            }),
            createElementNS: () => ({}),
            importNode: () => null,
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: ""
            }
        };
        function mt() {
            const e = "undefined" != typeof document ? document : {};
            return pt(e, ht),
            e
        }
        const ft = {
            document: ht,
            navigator: {
                userAgent: ""
            },
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: ""
            },
            history: {
                replaceState() {},
                pushState() {},
                go() {},
                back() {}
            },
            CustomEvent: function() {
                return this
            },
            addEventListener() {},
            removeEventListener() {},
            getComputedStyle: () => ({
                getPropertyValue: () => ""
            }),
            Image() {},
            Date() {},
            screen: {},
            setTimeout() {},
            clearTimeout() {},
            matchMedia: () => ({}),
            requestAnimationFrame: e => "undefined" == typeof setTimeout ? (e(),
            null) : setTimeout(e, 0),
            cancelAnimationFrame(e) {
                "undefined" != typeof setTimeout && clearTimeout(e)
            }
        };
        function gt() {
            const e = "undefined" != typeof window ? window : {};
            return pt(e, ft),
            e
        }
        function vt(e, t) {
            return void 0 === t && (t = 0),
            setTimeout(e, t)
        }
        function yt() {
            return Date.now()
        }
        function bt(e, t) {
            void 0 === t && (t = "x");
            const s = gt();
            let i, n, a;
            const r = function(e) {
                const t = gt();
                let s;
                return t.getComputedStyle && (s = t.getComputedStyle(e, null)),
                !s && e.currentStyle && (s = e.currentStyle),
                s || (s = e.style),
                s
            }(e);
            return s.WebKitCSSMatrix ? (n = r.transform || r.webkitTransform,
            n.split(",").length > 6 && (n = n.split(", ").map((e => e.replace(",", "."))).join(", ")),
            a = new s.WebKitCSSMatrix("none" === n ? "" : n)) : (a = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"),
            i = a.toString().split(",")),
            "x" === t && (n = s.WebKitCSSMatrix ? a.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
            "y" === t && (n = s.WebKitCSSMatrix ? a.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
            n || 0
        }
        function wt(e) {
            return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
        }
        function St() {
            const e = Object(arguments.length <= 0 ? void 0 : arguments[0])
              , t = ["__proto__", "constructor", "prototype"];
            for (let i = 1; i < arguments.length; i += 1) {
                const n = i < 0 || arguments.length <= i ? void 0 : arguments[i];
                if (null != n && (s = n,
                !("undefined" != typeof window && void 0 !== window.HTMLElement ? s instanceof HTMLElement : s && (1 === s.nodeType || 11 === s.nodeType)))) {
                    const s = Object.keys(Object(n)).filter((e => t.indexOf(e) < 0));
                    for (let t = 0, i = s.length; t < i; t += 1) {
                        const i = s[t]
                          , a = Object.getOwnPropertyDescriptor(n, i);
                        void 0 !== a && a.enumerable && (wt(e[i]) && wt(n[i]) ? n[i].__swiper__ ? e[i] = n[i] : St(e[i], n[i]) : !wt(e[i]) && wt(n[i]) ? (e[i] = {},
                        n[i].__swiper__ ? e[i] = n[i] : St(e[i], n[i])) : e[i] = n[i])
                    }
                }
            }
            var s;
            return e
        }
        function Et(e, t, s) {
            e.style.setProperty(t, s)
        }
        function xt(e) {
            let {swiper: t, targetPosition: s, side: i} = e;
            const n = gt()
              , a = -t.translate;
            let r, o = null;
            const l = t.params.speed;
            t.wrapperEl.style.scrollSnapType = "none",
            n.cancelAnimationFrame(t.cssModeFrameID);
            const c = s > a ? "next" : "prev"
              , d = (e, t) => "next" === c && e >= t || "prev" === c && e <= t
              , u = () => {
                r = (new Date).getTime(),
                null === o && (o = r);
                const e = Math.max(Math.min((r - o) / l, 1), 0)
                  , c = .5 - Math.cos(e * Math.PI) / 2;
                let p = a + c * (s - a);
                if (d(p, s) && (p = s),
                t.wrapperEl.scrollTo({
                    [i]: p
                }),
                d(p, s))
                    return t.wrapperEl.style.overflow = "hidden",
                    t.wrapperEl.style.scrollSnapType = "",
                    setTimeout(( () => {
                        t.wrapperEl.style.overflow = "",
                        t.wrapperEl.scrollTo({
                            [i]: p
                        })
                    }
                    )),
                    void n.cancelAnimationFrame(t.cssModeFrameID);
                t.cssModeFrameID = n.requestAnimationFrame(u)
            }
            ;
            u()
        }
        function Tt(e) {
            return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e
        }
        function Lt(e, t) {
            return void 0 === t && (t = ""),
            [...e.children].filter((e => e.matches(t)))
        }
        function At(e, t) {
            void 0 === t && (t = []);
            const s = document.createElement(e);
            return s.classList.add(...Array.isArray(t) ? t : [t]),
            s
        }
        function Ct(e, t) {
            return gt().getComputedStyle(e, null).getPropertyValue(t)
        }
        function kt(e) {
            let t, s = e;
            if (s) {
                for (t = 0; null !== (s = s.previousSibling); )
                    1 === s.nodeType && (t += 1);
                return t
            }
        }
        function qt(e, t) {
            const s = [];
            let i = e.parentElement;
            for (; i; )
                t ? i.matches(t) && s.push(i) : s.push(i),
                i = i.parentElement;
            return s
        }
        function Mt(e, t) {
            t && e.addEventListener("transitionend", (function s(i) {
                i.target === e && (t.call(e, i),
                e.removeEventListener("transitionend", s))
            }
            ))
        }
        function Ot(e, t, s) {
            const i = gt();
            return s ? e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(i.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(i.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom")) : e.offsetWidth
        }
        let _t, Pt, It;
        function $t() {
            return _t || (_t = function() {
                const e = gt()
                  , t = mt();
                return {
                    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior"in t.documentElement.style,
                    touch: !!("ontouchstart"in e || e.DocumentTouch && t instanceof e.DocumentTouch)
                }
            }()),
            _t
        }
        function Bt(e) {
            return void 0 === e && (e = {}),
            Pt || (Pt = function(e) {
                let {userAgent: t} = void 0 === e ? {} : e;
                const s = $t()
                  , i = gt()
                  , n = i.navigator.platform
                  , a = t || i.navigator.userAgent
                  , r = {
                    ios: !1,
                    android: !1
                }
                  , o = i.screen.width
                  , l = i.screen.height
                  , c = a.match(/(Android);?[\s\/]+([\d.]+)?/);
                let d = a.match(/(iPad).*OS\s([\d_]+)/);
                const u = a.match(/(iPod)(.*OS\s([\d_]+))?/)
                  , p = !d && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/)
                  , h = "Win32" === n;
                let m = "MacIntel" === n;
                return !d && m && s.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${o}x${l}`) >= 0 && (d = a.match(/(Version)\/([\d.]+)/),
                d || (d = [0, 1, "13_0_0"]),
                m = !1),
                c && !h && (r.os = "android",
                r.android = !0),
                (d || p || u) && (r.os = "ios",
                r.ios = !0),
                r
            }(e)),
            Pt
        }
        function Dt() {
            return It || (It = function() {
                const e = gt();
                let t = !1;
                function s() {
                    const t = e.navigator.userAgent.toLowerCase();
                    return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0
                }
                if (s()) {
                    const s = String(e.navigator.userAgent);
                    if (s.includes("Version/")) {
                        const [e,i] = s.split("Version/")[1].split(" ")[0].split(".").map((e => Number(e)));
                        t = e < 16 || 16 === e && i < 2
                    }
                }
                return {
                    isSafari: t || s(),
                    needPerspectiveFix: t,
                    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
                }
            }()),
            It
        }
        var Nt = {
            on(e, t, s) {
                const i = this;
                if (!i.eventsListeners || i.destroyed)
                    return i;
                if ("function" != typeof t)
                    return i;
                const n = s ? "unshift" : "push";
                return e.split(" ").forEach((e => {
                    i.eventsListeners[e] || (i.eventsListeners[e] = []),
                    i.eventsListeners[e][n](t)
                }
                )),
                i
            },
            once(e, t, s) {
                const i = this;
                if (!i.eventsListeners || i.destroyed)
                    return i;
                if ("function" != typeof t)
                    return i;
                function n() {
                    i.off(e, n),
                    n.__emitterProxy && delete n.__emitterProxy;
                    for (var s = arguments.length, a = new Array(s), r = 0; r < s; r++)
                        a[r] = arguments[r];
                    t.apply(i, a)
                }
                return n.__emitterProxy = t,
                i.on(e, n, s)
            },
            onAny(e, t) {
                const s = this;
                if (!s.eventsListeners || s.destroyed)
                    return s;
                if ("function" != typeof e)
                    return s;
                const i = t ? "unshift" : "push";
                return s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e),
                s
            },
            offAny(e) {
                const t = this;
                if (!t.eventsListeners || t.destroyed)
                    return t;
                if (!t.eventsAnyListeners)
                    return t;
                const s = t.eventsAnyListeners.indexOf(e);
                return s >= 0 && t.eventsAnyListeners.splice(s, 1),
                t
            },
            off(e, t) {
                const s = this;
                return !s.eventsListeners || s.destroyed ? s : s.eventsListeners ? (e.split(" ").forEach((e => {
                    void 0 === t ? s.eventsListeners[e] = [] : s.eventsListeners[e] && s.eventsListeners[e].forEach(( (i, n) => {
                        (i === t || i.__emitterProxy && i.__emitterProxy === t) && s.eventsListeners[e].splice(n, 1)
                    }
                    ))
                }
                )),
                s) : s
            },
            emit() {
                const e = this;
                if (!e.eventsListeners || e.destroyed)
                    return e;
                if (!e.eventsListeners)
                    return e;
                let t, s, i;
                for (var n = arguments.length, a = new Array(n), r = 0; r < n; r++)
                    a[r] = arguments[r];
                "string" == typeof a[0] || Array.isArray(a[0]) ? (t = a[0],
                s = a.slice(1, a.length),
                i = e) : (t = a[0].events,
                s = a[0].data,
                i = a[0].context || e),
                s.unshift(i);
                return (Array.isArray(t) ? t : t.split(" ")).forEach((t => {
                    e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((e => {
                        e.apply(i, [t, ...s])
                    }
                    )),
                    e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach((e => {
                        e.apply(i, s)
                    }
                    ))
                }
                )),
                e
            }
        };
        const zt = (e, t) => {
            if (!e || e.destroyed || !e.params)
                return;
            const s = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
            if (s) {
                let t = s.querySelector(`.${e.params.lazyPreloaderClass}`);
                !t && e.isElement && (s.shadowRoot ? t = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(( () => {
                    s.shadowRoot && (t = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`),
                    t && t.remove())
                }
                ))),
                t && t.remove()
            }
        }
          , Ft = (e, t) => {
            if (!e.slides[t])
                return;
            const s = e.slides[t].querySelector('[loading="lazy"]');
            s && s.removeAttribute("loading")
        }
          , Ht = e => {
            if (!e || e.destroyed || !e.params)
                return;
            let t = e.params.lazyPreloadPrevNext;
            const s = e.slides.length;
            if (!s || !t || t < 0)
                return;
            t = Math.min(t, s);
            const i = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView)
              , n = e.activeIndex;
            if (e.params.grid && e.params.grid.rows > 1) {
                const s = n
                  , a = [s - t];
                return a.push(...Array.from({
                    length: t
                }).map(( (e, t) => s + i + t))),
                void e.slides.forEach(( (t, s) => {
                    a.includes(t.column) && Ft(e, s)
                }
                ))
            }
            const a = n + i - 1;
            if (e.params.rewind || e.params.loop)
                for (let i = n - t; i <= a + t; i += 1) {
                    const t = (i % s + s) % s;
                    (t < n || t > a) && Ft(e, t)
                }
            else
                for (let i = Math.max(n - t, 0); i <= Math.min(a + t, s - 1); i += 1)
                    i !== n && (i > a || i < n) && Ft(e, i)
        }
        ;
        var Rt = {
            updateSize: function() {
                const e = this;
                let t, s;
                const i = e.el;
                t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : i.clientWidth,
                s = void 0 !== e.params.height && null !== e.params.height ? e.params.height : i.clientHeight,
                0 === t && e.isHorizontal() || 0 === s && e.isVertical() || (t = t - parseInt(Ct(i, "padding-left") || 0, 10) - parseInt(Ct(i, "padding-right") || 0, 10),
                s = s - parseInt(Ct(i, "padding-top") || 0, 10) - parseInt(Ct(i, "padding-bottom") || 0, 10),
                Number.isNaN(t) && (t = 0),
                Number.isNaN(s) && (s = 0),
                Object.assign(e, {
                    width: t,
                    height: s,
                    size: e.isHorizontal() ? t : s
                }))
            },
            updateSlides: function() {
                const e = this;
                function t(t) {
                    return e.isHorizontal() ? t : {
                        width: "height",
                        "margin-top": "margin-left",
                        "margin-bottom ": "margin-right",
                        "margin-left": "margin-top",
                        "margin-right": "margin-bottom",
                        "padding-left": "padding-top",
                        "padding-right": "padding-bottom",
                        marginRight: "marginBottom"
                    }[t]
                }
                function s(e, s) {
                    return parseFloat(e.getPropertyValue(t(s)) || 0)
                }
                const i = e.params
                  , {wrapperEl: n, slidesEl: a, size: r, rtlTranslate: o, wrongRTL: l} = e
                  , c = e.virtual && i.virtual.enabled
                  , d = c ? e.virtual.slides.length : e.slides.length
                  , u = Lt(a, `.${e.params.slideClass}, swiper-slide`)
                  , p = c ? e.virtual.slides.length : u.length;
                let h = [];
                const m = []
                  , f = [];
                let g = i.slidesOffsetBefore;
                "function" == typeof g && (g = i.slidesOffsetBefore.call(e));
                let v = i.slidesOffsetAfter;
                "function" == typeof v && (v = i.slidesOffsetAfter.call(e));
                const y = e.snapGrid.length
                  , b = e.slidesGrid.length;
                let w = i.spaceBetween
                  , S = -g
                  , E = 0
                  , x = 0;
                if (void 0 === r)
                    return;
                "string" == typeof w && w.indexOf("%") >= 0 ? w = parseFloat(w.replace("%", "")) / 100 * r : "string" == typeof w && (w = parseFloat(w)),
                e.virtualSize = -w,
                u.forEach((e => {
                    o ? e.style.marginLeft = "" : e.style.marginRight = "",
                    e.style.marginBottom = "",
                    e.style.marginTop = ""
                }
                )),
                i.centeredSlides && i.cssMode && (Et(n, "--swiper-centered-offset-before", ""),
                Et(n, "--swiper-centered-offset-after", ""));
                const T = i.grid && i.grid.rows > 1 && e.grid;
                let L;
                T && e.grid.initSlides(p);
                const A = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter((e => void 0 !== i.breakpoints[e].slidesPerView)).length > 0;
                for (let n = 0; n < p; n += 1) {
                    let a;
                    if (L = 0,
                    u[n] && (a = u[n]),
                    T && e.grid.updateSlide(n, a, p, t),
                    !u[n] || "none" !== Ct(a, "display")) {
                        if ("auto" === i.slidesPerView) {
                            A && (u[n].style[t("width")] = "");
                            const r = getComputedStyle(a)
                              , o = a.style.transform
                              , l = a.style.webkitTransform;
                            if (o && (a.style.transform = "none"),
                            l && (a.style.webkitTransform = "none"),
                            i.roundLengths)
                                L = e.isHorizontal() ? Ot(a, "width", !0) : Ot(a, "height", !0);
                            else {
                                const e = s(r, "width")
                                  , t = s(r, "padding-left")
                                  , i = s(r, "padding-right")
                                  , n = s(r, "margin-left")
                                  , o = s(r, "margin-right")
                                  , l = r.getPropertyValue("box-sizing");
                                if (l && "border-box" === l)
                                    L = e + n + o;
                                else {
                                    const {clientWidth: s, offsetWidth: r} = a;
                                    L = e + t + i + n + o + (r - s)
                                }
                            }
                            o && (a.style.transform = o),
                            l && (a.style.webkitTransform = l),
                            i.roundLengths && (L = Math.floor(L))
                        } else
                            L = (r - (i.slidesPerView - 1) * w) / i.slidesPerView,
                            i.roundLengths && (L = Math.floor(L)),
                            u[n] && (u[n].style[t("width")] = `${L}px`);
                        u[n] && (u[n].swiperSlideSize = L),
                        f.push(L),
                        i.centeredSlides ? (S = S + L / 2 + E / 2 + w,
                        0 === E && 0 !== n && (S = S - r / 2 - w),
                        0 === n && (S = S - r / 2 - w),
                        Math.abs(S) < .001 && (S = 0),
                        i.roundLengths && (S = Math.floor(S)),
                        x % i.slidesPerGroup == 0 && h.push(S),
                        m.push(S)) : (i.roundLengths && (S = Math.floor(S)),
                        (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && h.push(S),
                        m.push(S),
                        S = S + L + w),
                        e.virtualSize += L + w,
                        E = L,
                        x += 1
                    }
                }
                if (e.virtualSize = Math.max(e.virtualSize, r) + v,
                o && l && ("slide" === i.effect || "coverflow" === i.effect) && (n.style.width = `${e.virtualSize + w}px`),
                i.setWrapperSize && (n.style[t("width")] = `${e.virtualSize + w}px`),
                T && e.grid.updateWrapperSize(L, h, t),
                !i.centeredSlides) {
                    const t = [];
                    for (let s = 0; s < h.length; s += 1) {
                        let n = h[s];
                        i.roundLengths && (n = Math.floor(n)),
                        h[s] <= e.virtualSize - r && t.push(n)
                    }
                    h = t,
                    Math.floor(e.virtualSize - r) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - r)
                }
                if (c && i.loop) {
                    const t = f[0] + w;
                    if (i.slidesPerGroup > 1) {
                        const s = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup)
                          , n = t * i.slidesPerGroup;
                        for (let e = 0; e < s; e += 1)
                            h.push(h[h.length - 1] + n)
                    }
                    for (let s = 0; s < e.virtual.slidesBefore + e.virtual.slidesAfter; s += 1)
                        1 === i.slidesPerGroup && h.push(h[h.length - 1] + t),
                        m.push(m[m.length - 1] + t),
                        e.virtualSize += t
                }
                if (0 === h.length && (h = [0]),
                0 !== w) {
                    const s = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
                    u.filter(( (e, t) => !(i.cssMode && !i.loop) || t !== u.length - 1)).forEach((e => {
                        e.style[s] = `${w}px`
                    }
                    ))
                }
                if (i.centeredSlides && i.centeredSlidesBounds) {
                    let e = 0;
                    f.forEach((t => {
                        e += t + (w || 0)
                    }
                    )),
                    e -= w;
                    const t = e - r;
                    h = h.map((e => e <= 0 ? -g : e > t ? t + v : e))
                }
                if (i.centerInsufficientSlides) {
                    let e = 0;
                    if (f.forEach((t => {
                        e += t + (w || 0)
                    }
                    )),
                    e -= w,
                    e < r) {
                        const t = (r - e) / 2;
                        h.forEach(( (e, s) => {
                            h[s] = e - t
                        }
                        )),
                        m.forEach(( (e, s) => {
                            m[s] = e + t
                        }
                        ))
                    }
                }
                if (Object.assign(e, {
                    slides: u,
                    snapGrid: h,
                    slidesGrid: m,
                    slidesSizesGrid: f
                }),
                i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
                    Et(n, "--swiper-centered-offset-before", -h[0] + "px"),
                    Et(n, "--swiper-centered-offset-after", e.size / 2 - f[f.length - 1] / 2 + "px");
                    const t = -e.snapGrid[0]
                      , s = -e.slidesGrid[0];
                    e.snapGrid = e.snapGrid.map((e => e + t)),
                    e.slidesGrid = e.slidesGrid.map((e => e + s))
                }
                if (p !== d && e.emit("slidesLengthChange"),
                h.length !== y && (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
                m.length !== b && e.emit("slidesGridLengthChange"),
                i.watchSlidesProgress && e.updateSlidesOffset(),
                !(c || i.cssMode || "slide" !== i.effect && "fade" !== i.effect)) {
                    const t = `${i.containerModifierClass}backface-hidden`
                      , s = e.el.classList.contains(t);
                    p <= i.maxBackfaceHiddenSlides ? s || e.el.classList.add(t) : s && e.el.classList.remove(t)
                }
            },
            updateAutoHeight: function(e) {
                const t = this
                  , s = []
                  , i = t.virtual && t.params.virtual.enabled;
                let n, a = 0;
                "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                const r = e => i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
                if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                    if (t.params.centeredSlides)
                        (t.visibleSlides || []).forEach((e => {
                            s.push(e)
                        }
                        ));
                    else
                        for (n = 0; n < Math.ceil(t.params.slidesPerView); n += 1) {
                            const e = t.activeIndex + n;
                            if (e > t.slides.length && !i)
                                break;
                            s.push(r(e))
                        }
                else
                    s.push(r(t.activeIndex));
                for (n = 0; n < s.length; n += 1)
                    if (void 0 !== s[n]) {
                        const e = s[n].offsetHeight;
                        a = e > a ? e : a
                    }
                (a || 0 === a) && (t.wrapperEl.style.height = `${a}px`)
            },
            updateSlidesOffset: function() {
                const e = this
                  , t = e.slides
                  , s = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
                for (let i = 0; i < t.length; i += 1)
                    t[i].swiperSlideOffset = (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) - s - e.cssOverflowAdjustment()
            },
            updateSlidesProgress: function(e) {
                void 0 === e && (e = this && this.translate || 0);
                const t = this
                  , s = t.params
                  , {slides: i, rtlTranslate: n, snapGrid: a} = t;
                if (0 === i.length)
                    return;
                void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                let r = -e;
                n && (r = e),
                i.forEach((e => {
                    e.classList.remove(s.slideVisibleClass)
                }
                )),
                t.visibleSlidesIndexes = [],
                t.visibleSlides = [];
                let o = s.spaceBetween;
                "string" == typeof o && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : "string" == typeof o && (o = parseFloat(o));
                for (let e = 0; e < i.length; e += 1) {
                    const l = i[e];
                    let c = l.swiperSlideOffset;
                    s.cssMode && s.centeredSlides && (c -= i[0].swiperSlideOffset);
                    const d = (r + (s.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + o)
                      , u = (r - a[0] + (s.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + o)
                      , p = -(r - c)
                      , h = p + t.slidesSizesGrid[e];
                    (p >= 0 && p < t.size - 1 || h > 1 && h <= t.size || p <= 0 && h >= t.size) && (t.visibleSlides.push(l),
                    t.visibleSlidesIndexes.push(e),
                    i[e].classList.add(s.slideVisibleClass)),
                    l.progress = n ? -d : d,
                    l.originalProgress = n ? -u : u
                }
            },
            updateProgress: function(e) {
                const t = this;
                if (void 0 === e) {
                    const s = t.rtlTranslate ? -1 : 1;
                    e = t && t.translate && t.translate * s || 0
                }
                const s = t.params
                  , i = t.maxTranslate() - t.minTranslate();
                let {progress: n, isBeginning: a, isEnd: r, progressLoop: o} = t;
                const l = a
                  , c = r;
                if (0 === i)
                    n = 0,
                    a = !0,
                    r = !0;
                else {
                    n = (e - t.minTranslate()) / i;
                    const s = Math.abs(e - t.minTranslate()) < 1
                      , o = Math.abs(e - t.maxTranslate()) < 1;
                    a = s || n <= 0,
                    r = o || n >= 1,
                    s && (n = 0),
                    o && (n = 1)
                }
                if (s.loop) {
                    const s = t.getSlideIndexByData(0)
                      , i = t.getSlideIndexByData(t.slides.length - 1)
                      , n = t.slidesGrid[s]
                      , a = t.slidesGrid[i]
                      , r = t.slidesGrid[t.slidesGrid.length - 1]
                      , l = Math.abs(e);
                    o = l >= n ? (l - n) / r : (l + r - a) / r,
                    o > 1 && (o -= 1)
                }
                Object.assign(t, {
                    progress: n,
                    progressLoop: o,
                    isBeginning: a,
                    isEnd: r
                }),
                (s.watchSlidesProgress || s.centeredSlides && s.autoHeight) && t.updateSlidesProgress(e),
                a && !l && t.emit("reachBeginning toEdge"),
                r && !c && t.emit("reachEnd toEdge"),
                (l && !a || c && !r) && t.emit("fromEdge"),
                t.emit("progress", n)
            },
            updateSlidesClasses: function() {
                const e = this
                  , {slides: t, params: s, slidesEl: i, activeIndex: n} = e
                  , a = e.virtual && s.virtual.enabled
                  , r = e => Lt(i, `.${s.slideClass}${e}, swiper-slide${e}`)[0];
                let o;
                if (t.forEach((e => {
                    e.classList.remove(s.slideActiveClass, s.slideNextClass, s.slidePrevClass)
                }
                )),
                a)
                    if (s.loop) {
                        let t = n - e.virtual.slidesBefore;
                        t < 0 && (t = e.virtual.slides.length + t),
                        t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
                        o = r(`[data-swiper-slide-index="${t}"]`)
                    } else
                        o = r(`[data-swiper-slide-index="${n}"]`);
                else
                    o = t[n];
                if (o) {
                    o.classList.add(s.slideActiveClass);
                    let e = function(e, t) {
                        const s = [];
                        for (; e.nextElementSibling; ) {
                            const i = e.nextElementSibling;
                            t ? i.matches(t) && s.push(i) : s.push(i),
                            e = i
                        }
                        return s
                    }(o, `.${s.slideClass}, swiper-slide`)[0];
                    s.loop && !e && (e = t[0]),
                    e && e.classList.add(s.slideNextClass);
                    let i = function(e, t) {
                        const s = [];
                        for (; e.previousElementSibling; ) {
                            const i = e.previousElementSibling;
                            t ? i.matches(t) && s.push(i) : s.push(i),
                            e = i
                        }
                        return s
                    }(o, `.${s.slideClass}, swiper-slide`)[0];
                    s.loop && 0 === !i && (i = t[t.length - 1]),
                    i && i.classList.add(s.slidePrevClass)
                }
                e.emitSlidesClasses()
            },
            updateActiveIndex: function(e) {
                const t = this
                  , s = t.rtlTranslate ? t.translate : -t.translate
                  , {snapGrid: i, params: n, activeIndex: a, realIndex: r, snapIndex: o} = t;
                let l, c = e;
                const d = e => {
                    let s = e - t.virtual.slidesBefore;
                    return s < 0 && (s = t.virtual.slides.length + s),
                    s >= t.virtual.slides.length && (s -= t.virtual.slides.length),
                    s
                }
                ;
                if (void 0 === c && (c = function(e) {
                    const {slidesGrid: t, params: s} = e
                      , i = e.rtlTranslate ? e.translate : -e.translate;
                    let n;
                    for (let e = 0; e < t.length; e += 1)
                        void 0 !== t[e + 1] ? i >= t[e] && i < t[e + 1] - (t[e + 1] - t[e]) / 2 ? n = e : i >= t[e] && i < t[e + 1] && (n = e + 1) : i >= t[e] && (n = e);
                    return s.normalizeSlideIndex && (n < 0 || void 0 === n) && (n = 0),
                    n
                }(t)),
                i.indexOf(s) >= 0)
                    l = i.indexOf(s);
                else {
                    const e = Math.min(n.slidesPerGroupSkip, c);
                    l = e + Math.floor((c - e) / n.slidesPerGroup)
                }
                if (l >= i.length && (l = i.length - 1),
                c === a)
                    return l !== o && (t.snapIndex = l,
                    t.emit("snapIndexChange")),
                    void (t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = d(c)));
                let u;
                u = t.virtual && n.virtual.enabled && n.loop ? d(c) : t.slides[c] ? parseInt(t.slides[c].getAttribute("data-swiper-slide-index") || c, 10) : c,
                Object.assign(t, {
                    previousSnapIndex: o,
                    snapIndex: l,
                    previousRealIndex: r,
                    realIndex: u,
                    previousIndex: a,
                    activeIndex: c
                }),
                t.initialized && Ht(t),
                t.emit("activeIndexChange"),
                t.emit("snapIndexChange"),
                (t.initialized || t.params.runCallbacksOnInit) && (r !== u && t.emit("realIndexChange"),
                t.emit("slideChange"))
            },
            updateClickedSlide: function(e, t) {
                const s = this
                  , i = s.params;
                let n = e.closest(`.${i.slideClass}, swiper-slide`);
                !n && s.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e => {
                    !n && e.matches && e.matches(`.${i.slideClass}, swiper-slide`) && (n = e)
                }
                ));
                let a, r = !1;
                if (n)
                    for (let e = 0; e < s.slides.length; e += 1)
                        if (s.slides[e] === n) {
                            r = !0,
                            a = e;
                            break
                        }
                if (!n || !r)
                    return s.clickedSlide = void 0,
                    void (s.clickedIndex = void 0);
                s.clickedSlide = n,
                s.virtual && s.params.virtual.enabled ? s.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : s.clickedIndex = a,
                i.slideToClickedSlide && void 0 !== s.clickedIndex && s.clickedIndex !== s.activeIndex && s.slideToClickedSlide()
            }
        };
        var Gt = {
            getTranslate: function(e) {
                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                const {params: t, rtlTranslate: s, translate: i, wrapperEl: n} = this;
                if (t.virtualTranslate)
                    return s ? -i : i;
                if (t.cssMode)
                    return i;
                let a = bt(n, e);
                return a += this.cssOverflowAdjustment(),
                s && (a = -a),
                a || 0
            },
            setTranslate: function(e, t) {
                const s = this
                  , {rtlTranslate: i, params: n, wrapperEl: a, progress: r} = s;
                let o, l = 0, c = 0;
                s.isHorizontal() ? l = i ? -e : e : c = e,
                n.roundLengths && (l = Math.floor(l),
                c = Math.floor(c)),
                s.previousTranslate = s.translate,
                s.translate = s.isHorizontal() ? l : c,
                n.cssMode ? a[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -l : -c : n.virtualTranslate || (s.isHorizontal() ? l -= s.cssOverflowAdjustment() : c -= s.cssOverflowAdjustment(),
                a.style.transform = `translate3d(${l}px, ${c}px, 0px)`);
                const d = s.maxTranslate() - s.minTranslate();
                o = 0 === d ? 0 : (e - s.minTranslate()) / d,
                o !== r && s.updateProgress(e),
                s.emit("setTranslate", s.translate, t)
            },
            minTranslate: function() {
                return -this.snapGrid[0]
            },
            maxTranslate: function() {
                return -this.snapGrid[this.snapGrid.length - 1]
            },
            translateTo: function(e, t, s, i, n) {
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === s && (s = !0),
                void 0 === i && (i = !0);
                const a = this
                  , {params: r, wrapperEl: o} = a;
                if (a.animating && r.preventInteractionOnTransition)
                    return !1;
                const l = a.minTranslate()
                  , c = a.maxTranslate();
                let d;
                if (d = i && e > l ? l : i && e < c ? c : e,
                a.updateProgress(d),
                r.cssMode) {
                    const e = a.isHorizontal();
                    if (0 === t)
                        o[e ? "scrollLeft" : "scrollTop"] = -d;
                    else {
                        if (!a.support.smoothScroll)
                            return xt({
                                swiper: a,
                                targetPosition: -d,
                                side: e ? "left" : "top"
                            }),
                            !0;
                        o.scrollTo({
                            [e ? "left" : "top"]: -d,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                return 0 === t ? (a.setTransition(0),
                a.setTranslate(d),
                s && (a.emit("beforeTransitionStart", t, n),
                a.emit("transitionEnd"))) : (a.setTransition(t),
                a.setTranslate(d),
                s && (a.emit("beforeTransitionStart", t, n),
                a.emit("transitionStart")),
                a.animating || (a.animating = !0,
                a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function(e) {
                    a && !a.destroyed && e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd),
                    a.onTranslateToWrapperTransitionEnd = null,
                    delete a.onTranslateToWrapperTransitionEnd,
                    s && a.emit("transitionEnd"))
                }
                ),
                a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))),
                !0
            }
        };
        function jt(e) {
            let {swiper: t, runCallbacks: s, direction: i, step: n} = e;
            const {activeIndex: a, previousIndex: r} = t;
            let o = i;
            if (o || (o = a > r ? "next" : a < r ? "prev" : "reset"),
            t.emit(`transition${n}`),
            s && a !== r) {
                if ("reset" === o)
                    return void t.emit(`slideResetTransition${n}`);
                t.emit(`slideChangeTransition${n}`),
                "next" === o ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`)
            }
        }
        var Vt = {
            slideTo: function(e, t, s, i, n) {
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === s && (s = !0),
                "string" == typeof e && (e = parseInt(e, 10));
                const a = this;
                let r = e;
                r < 0 && (r = 0);
                const {params: o, snapGrid: l, slidesGrid: c, previousIndex: d, activeIndex: u, rtlTranslate: p, wrapperEl: h, enabled: m} = a;
                if (a.animating && o.preventInteractionOnTransition || !m && !i && !n)
                    return !1;
                const f = Math.min(a.params.slidesPerGroupSkip, r);
                let g = f + Math.floor((r - f) / a.params.slidesPerGroup);
                g >= l.length && (g = l.length - 1);
                const v = -l[g];
                if (o.normalizeSlideIndex)
                    for (let e = 0; e < c.length; e += 1) {
                        const t = -Math.floor(100 * v)
                          , s = Math.floor(100 * c[e])
                          , i = Math.floor(100 * c[e + 1]);
                        void 0 !== c[e + 1] ? t >= s && t < i - (i - s) / 2 ? r = e : t >= s && t < i && (r = e + 1) : t >= s && (r = e)
                    }
                if (a.initialized && r !== u) {
                    if (!a.allowSlideNext && (p ? v > a.translate && v > a.minTranslate() : v < a.translate && v < a.minTranslate()))
                        return !1;
                    if (!a.allowSlidePrev && v > a.translate && v > a.maxTranslate() && (u || 0) !== r)
                        return !1
                }
                let y;
                if (r !== (d || 0) && s && a.emit("beforeSlideChangeStart"),
                a.updateProgress(v),
                y = r > u ? "next" : r < u ? "prev" : "reset",
                p && -v === a.translate || !p && v === a.translate)
                    return a.updateActiveIndex(r),
                    o.autoHeight && a.updateAutoHeight(),
                    a.updateSlidesClasses(),
                    "slide" !== o.effect && a.setTranslate(v),
                    "reset" !== y && (a.transitionStart(s, y),
                    a.transitionEnd(s, y)),
                    !1;
                if (o.cssMode) {
                    const e = a.isHorizontal()
                      , s = p ? v : -v;
                    if (0 === t) {
                        const t = a.virtual && a.params.virtual.enabled;
                        t && (a.wrapperEl.style.scrollSnapType = "none",
                        a._immediateVirtual = !0),
                        t && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0,
                        requestAnimationFrame(( () => {
                            h[e ? "scrollLeft" : "scrollTop"] = s
                        }
                        ))) : h[e ? "scrollLeft" : "scrollTop"] = s,
                        t && requestAnimationFrame(( () => {
                            a.wrapperEl.style.scrollSnapType = "",
                            a._immediateVirtual = !1
                        }
                        ))
                    } else {
                        if (!a.support.smoothScroll)
                            return xt({
                                swiper: a,
                                targetPosition: s,
                                side: e ? "left" : "top"
                            }),
                            !0;
                        h.scrollTo({
                            [e ? "left" : "top"]: s,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                return a.setTransition(t),
                a.setTranslate(v),
                a.updateActiveIndex(r),
                a.updateSlidesClasses(),
                a.emit("beforeTransitionStart", t, i),
                a.transitionStart(s, y),
                0 === t ? a.transitionEnd(s, y) : a.animating || (a.animating = !0,
                a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function(e) {
                    a && !a.destroyed && e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd),
                    a.onSlideToWrapperTransitionEnd = null,
                    delete a.onSlideToWrapperTransitionEnd,
                    a.transitionEnd(s, y))
                }
                ),
                a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)),
                !0
            },
            slideToLoop: function(e, t, s, i) {
                if (void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === s && (s = !0),
                "string" == typeof e) {
                    e = parseInt(e, 10)
                }
                const n = this;
                let a = e;
                return n.params.loop && (n.virtual && n.params.virtual.enabled ? a += n.virtual.slidesBefore : a = n.getSlideIndexByData(a)),
                n.slideTo(a, t, s, i)
            },
            slideNext: function(e, t, s) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0);
                const i = this
                  , {enabled: n, params: a, animating: r} = i;
                if (!n)
                    return i;
                let o = a.slidesPerGroup;
                "auto" === a.slidesPerView && 1 === a.slidesPerGroup && a.slidesPerGroupAuto && (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
                const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : o
                  , c = i.virtual && a.virtual.enabled;
                if (a.loop) {
                    if (r && !c && a.loopPreventsSliding)
                        return !1;
                    if (i.loopFix({
                        direction: "next"
                    }),
                    i._clientLeft = i.wrapperEl.clientLeft,
                    i.activeIndex === i.slides.length - 1 && a.cssMode)
                        return requestAnimationFrame(( () => {
                            i.slideTo(i.activeIndex + l, e, t, s)
                        }
                        )),
                        !0
                }
                return a.rewind && i.isEnd ? i.slideTo(0, e, t, s) : i.slideTo(i.activeIndex + l, e, t, s)
            },
            slidePrev: function(e, t, s) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0);
                const i = this
                  , {params: n, snapGrid: a, slidesGrid: r, rtlTranslate: o, enabled: l, animating: c} = i;
                if (!l)
                    return i;
                const d = i.virtual && n.virtual.enabled;
                if (n.loop) {
                    if (c && !d && n.loopPreventsSliding)
                        return !1;
                    i.loopFix({
                        direction: "prev"
                    }),
                    i._clientLeft = i.wrapperEl.clientLeft
                }
                function u(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                }
                const p = u(o ? i.translate : -i.translate)
                  , h = a.map((e => u(e)));
                let m = a[h.indexOf(p) - 1];
                if (void 0 === m && n.cssMode) {
                    let e;
                    a.forEach(( (t, s) => {
                        p >= t && (e = s)
                    }
                    )),
                    void 0 !== e && (m = a[e > 0 ? e - 1 : e])
                }
                let f = 0;
                if (void 0 !== m && (f = r.indexOf(m),
                f < 0 && (f = i.activeIndex - 1),
                "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (f = f - i.slidesPerViewDynamic("previous", !0) + 1,
                f = Math.max(f, 0))),
                n.rewind && i.isBeginning) {
                    const n = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
                    return i.slideTo(n, e, t, s)
                }
                return n.loop && 0 === i.activeIndex && n.cssMode ? (requestAnimationFrame(( () => {
                    i.slideTo(f, e, t, s)
                }
                )),
                !0) : i.slideTo(f, e, t, s)
            },
            slideReset: function(e, t, s) {
                return void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                this.slideTo(this.activeIndex, e, t, s)
            },
            slideToClosest: function(e, t, s, i) {
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                void 0 === i && (i = .5);
                const n = this;
                let a = n.activeIndex;
                const r = Math.min(n.params.slidesPerGroupSkip, a)
                  , o = r + Math.floor((a - r) / n.params.slidesPerGroup)
                  , l = n.rtlTranslate ? n.translate : -n.translate;
                if (l >= n.snapGrid[o]) {
                    const e = n.snapGrid[o];
                    l - e > (n.snapGrid[o + 1] - e) * i && (a += n.params.slidesPerGroup)
                } else {
                    const e = n.snapGrid[o - 1];
                    l - e <= (n.snapGrid[o] - e) * i && (a -= n.params.slidesPerGroup)
                }
                return a = Math.max(a, 0),
                a = Math.min(a, n.slidesGrid.length - 1),
                n.slideTo(a, e, t, s)
            },
            slideToClickedSlide: function() {
                const e = this
                  , {params: t, slidesEl: s} = e
                  , i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                let n, a = e.clickedIndex;
                const r = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
                if (t.loop) {
                    if (e.animating)
                        return;
                    n = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10),
                    t.centeredSlides ? a < e.loopedSlides - i / 2 || a > e.slides.length - e.loopedSlides + i / 2 ? (e.loopFix(),
                    a = e.getSlideIndex(Lt(s, `${r}[data-swiper-slide-index="${n}"]`)[0]),
                    vt(( () => {
                        e.slideTo(a)
                    }
                    ))) : e.slideTo(a) : a > e.slides.length - i ? (e.loopFix(),
                    a = e.getSlideIndex(Lt(s, `${r}[data-swiper-slide-index="${n}"]`)[0]),
                    vt(( () => {
                        e.slideTo(a)
                    }
                    ))) : e.slideTo(a)
                } else
                    e.slideTo(a)
            }
        };
        var Wt = {
            loopCreate: function(e) {
                const t = this
                  , {params: s, slidesEl: i} = t;
                if (!s.loop || t.virtual && t.params.virtual.enabled)
                    return;
                Lt(i, `.${s.slideClass}, swiper-slide`).forEach(( (e, t) => {
                    e.setAttribute("data-swiper-slide-index", t)
                }
                )),
                t.loopFix({
                    slideRealIndex: e,
                    direction: s.centeredSlides ? void 0 : "next"
                })
            },
            loopFix: function(e) {
                let {slideRealIndex: t, slideTo: s=!0, direction: i, setTranslate: n, activeSlideIndex: a, byController: r, byMousewheel: o} = void 0 === e ? {} : e;
                const l = this;
                if (!l.params.loop)
                    return;
                l.emit("beforeLoopFix");
                const {slides: c, allowSlidePrev: d, allowSlideNext: u, slidesEl: p, params: h} = l;
                if (l.allowSlidePrev = !0,
                l.allowSlideNext = !0,
                l.virtual && h.virtual.enabled)
                    return s && (h.centeredSlides || 0 !== l.snapIndex ? h.centeredSlides && l.snapIndex < h.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0) : l.slideTo(l.virtual.slides.length, 0, !1, !0)),
                    l.allowSlidePrev = d,
                    l.allowSlideNext = u,
                    void l.emit("loopFix");
                const m = "auto" === h.slidesPerView ? l.slidesPerViewDynamic() : Math.ceil(parseFloat(h.slidesPerView, 10));
                let f = h.loopedSlides || m;
                f % h.slidesPerGroup != 0 && (f += h.slidesPerGroup - f % h.slidesPerGroup),
                l.loopedSlides = f;
                const g = []
                  , v = [];
                let y = l.activeIndex;
                void 0 === a ? a = l.getSlideIndex(l.slides.filter((e => e.classList.contains(h.slideActiveClass)))[0]) : y = a;
                const b = "next" === i || !i
                  , w = "prev" === i || !i;
                let S = 0
                  , E = 0;
                if (a < f) {
                    S = Math.max(f - a, h.slidesPerGroup);
                    for (let e = 0; e < f - a; e += 1) {
                        const t = e - Math.floor(e / c.length) * c.length;
                        g.push(c.length - t - 1)
                    }
                } else if (a > l.slides.length - 2 * f) {
                    E = Math.max(a - (l.slides.length - 2 * f), h.slidesPerGroup);
                    for (let e = 0; e < E; e += 1) {
                        const t = e - Math.floor(e / c.length) * c.length;
                        v.push(t)
                    }
                }
                if (w && g.forEach((e => {
                    l.slides[e].swiperLoopMoveDOM = !0,
                    p.prepend(l.slides[e]),
                    l.slides[e].swiperLoopMoveDOM = !1
                }
                )),
                b && v.forEach((e => {
                    l.slides[e].swiperLoopMoveDOM = !0,
                    p.append(l.slides[e]),
                    l.slides[e].swiperLoopMoveDOM = !1
                }
                )),
                l.recalcSlides(),
                "auto" === h.slidesPerView && l.updateSlides(),
                h.watchSlidesProgress && l.updateSlidesOffset(),
                s)
                    if (g.length > 0 && w)
                        if (void 0 === t) {
                            const e = l.slidesGrid[y]
                              , t = l.slidesGrid[y + S] - e;
                            o ? l.setTranslate(l.translate - t) : (l.slideTo(y + S, 0, !1, !0),
                            n && (l.touches[l.isHorizontal() ? "startX" : "startY"] += t,
                            l.touchEventsData.currentTranslate = l.translate))
                        } else
                            n && (l.slideToLoop(t, 0, !1, !0),
                            l.touchEventsData.currentTranslate = l.translate);
                    else if (v.length > 0 && b)
                        if (void 0 === t) {
                            const e = l.slidesGrid[y]
                              , t = l.slidesGrid[y - E] - e;
                            o ? l.setTranslate(l.translate - t) : (l.slideTo(y - E, 0, !1, !0),
                            n && (l.touches[l.isHorizontal() ? "startX" : "startY"] += t,
                            l.touchEventsData.currentTranslate = l.translate))
                        } else
                            l.slideToLoop(t, 0, !1, !0);
                if (l.allowSlidePrev = d,
                l.allowSlideNext = u,
                l.controller && l.controller.control && !r) {
                    const e = {
                        slideRealIndex: t,
                        direction: i,
                        setTranslate: n,
                        activeSlideIndex: a,
                        byController: !0
                    };
                    Array.isArray(l.controller.control) ? l.controller.control.forEach((t => {
                        !t.destroyed && t.params.loop && t.loopFix({
                            ...e,
                            slideTo: t.params.slidesPerView === h.slidesPerView && s
                        })
                    }
                    )) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
                        ...e,
                        slideTo: l.controller.control.params.slidesPerView === h.slidesPerView && s
                    })
                }
                l.emit("loopFix")
            },
            loopDestroy: function() {
                const e = this
                  , {params: t, slidesEl: s} = e;
                if (!t.loop || e.virtual && e.params.virtual.enabled)
                    return;
                e.recalcSlides();
                const i = [];
                e.slides.forEach((e => {
                    const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                    i[t] = e
                }
                )),
                e.slides.forEach((e => {
                    e.removeAttribute("data-swiper-slide-index")
                }
                )),
                i.forEach((e => {
                    s.append(e)
                }
                )),
                e.recalcSlides(),
                e.slideTo(e.realIndex, 0)
            }
        };
        function Yt(e) {
            const t = this
              , s = mt()
              , i = gt()
              , n = t.touchEventsData;
            n.evCache.push(e);
            const {params: a, touches: r, enabled: o} = t;
            if (!o)
                return;
            if (!a.simulateTouch && "mouse" === e.pointerType)
                return;
            if (t.animating && a.preventInteractionOnTransition)
                return;
            !t.animating && a.cssMode && a.loop && t.loopFix();
            let l = e;
            l.originalEvent && (l = l.originalEvent);
            let c = l.target;
            if ("wrapper" === a.touchEventsTarget && !t.wrapperEl.contains(c))
                return;
            if ("which"in l && 3 === l.which)
                return;
            if ("button"in l && l.button > 0)
                return;
            if (n.isTouched && n.isMoved)
                return;
            const d = !!a.noSwipingClass && "" !== a.noSwipingClass
              , u = e.composedPath ? e.composedPath() : e.path;
            d && l.target && l.target.shadowRoot && u && (c = u[0]);
            const p = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`
              , h = !(!l.target || !l.target.shadowRoot);
            if (a.noSwiping && (h ? function(e, t) {
                return void 0 === t && (t = this),
                function t(s) {
                    if (!s || s === mt() || s === gt())
                        return null;
                    s.assignedSlot && (s = s.assignedSlot);
                    const i = s.closest(e);
                    return i || s.getRootNode ? i || t(s.getRootNode().host) : null
                }(t)
            }(p, c) : c.closest(p)))
                return void (t.allowClick = !0);
            if (a.swipeHandler && !c.closest(a.swipeHandler))
                return;
            r.currentX = l.pageX,
            r.currentY = l.pageY;
            const m = r.currentX
              , f = r.currentY
              , g = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection
              , v = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
            if (g && (m <= v || m >= i.innerWidth - v)) {
                if ("prevent" !== g)
                    return;
                e.preventDefault()
            }
            Object.assign(n, {
                isTouched: !0,
                isMoved: !1,
                allowTouchCallbacks: !0,
                isScrolling: void 0,
                startMoving: void 0
            }),
            r.startX = m,
            r.startY = f,
            n.touchStartTime = yt(),
            t.allowClick = !0,
            t.updateSize(),
            t.swipeDirection = void 0,
            a.threshold > 0 && (n.allowThresholdMove = !1);
            let y = !0;
            c.matches(n.focusableElements) && (y = !1,
            "SELECT" === c.nodeName && (n.isTouched = !1)),
            s.activeElement && s.activeElement.matches(n.focusableElements) && s.activeElement !== c && s.activeElement.blur();
            const b = y && t.allowTouchMove && a.touchStartPreventDefault;
            !a.touchStartForcePreventDefault && !b || c.isContentEditable || l.preventDefault(),
            a.freeMode && a.freeMode.enabled && t.freeMode && t.animating && !a.cssMode && t.freeMode.onTouchStart(),
            t.emit("touchStart", l)
        }
        function Xt(e) {
            const t = mt()
              , s = this
              , i = s.touchEventsData
              , {params: n, touches: a, rtlTranslate: r, enabled: o} = s;
            if (!o)
                return;
            if (!n.simulateTouch && "mouse" === e.pointerType)
                return;
            let l = e;
            if (l.originalEvent && (l = l.originalEvent),
            !i.isTouched)
                return void (i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", l));
            const c = i.evCache.findIndex((e => e.pointerId === l.pointerId));
            c >= 0 && (i.evCache[c] = l);
            const d = i.evCache.length > 1 ? i.evCache[0] : l
              , u = d.pageX
              , p = d.pageY;
            if (l.preventedByNestedSwiper)
                return a.startX = u,
                void (a.startY = p);
            if (!s.allowTouchMove)
                return l.target.matches(i.focusableElements) || (s.allowClick = !1),
                void (i.isTouched && (Object.assign(a, {
                    startX: u,
                    startY: p,
                    prevX: s.touches.currentX,
                    prevY: s.touches.currentY,
                    currentX: u,
                    currentY: p
                }),
                i.touchStartTime = yt()));
            if (n.touchReleaseOnEdges && !n.loop)
                if (s.isVertical()) {
                    if (p < a.startY && s.translate <= s.maxTranslate() || p > a.startY && s.translate >= s.minTranslate())
                        return i.isTouched = !1,
                        void (i.isMoved = !1)
                } else if (u < a.startX && s.translate <= s.maxTranslate() || u > a.startX && s.translate >= s.minTranslate())
                    return;
            if (t.activeElement && l.target === t.activeElement && l.target.matches(i.focusableElements))
                return i.isMoved = !0,
                void (s.allowClick = !1);
            if (i.allowTouchCallbacks && s.emit("touchMove", l),
            l.targetTouches && l.targetTouches.length > 1)
                return;
            a.currentX = u,
            a.currentY = p;
            const h = a.currentX - a.startX
              , m = a.currentY - a.startY;
            if (s.params.threshold && Math.sqrt(h ** 2 + m ** 2) < s.params.threshold)
                return;
            if (void 0 === i.isScrolling) {
                let e;
                s.isHorizontal() && a.currentY === a.startY || s.isVertical() && a.currentX === a.startX ? i.isScrolling = !1 : h * h + m * m >= 25 && (e = 180 * Math.atan2(Math.abs(m), Math.abs(h)) / Math.PI,
                i.isScrolling = s.isHorizontal() ? e > n.touchAngle : 90 - e > n.touchAngle)
            }
            if (i.isScrolling && s.emit("touchMoveOpposite", l),
            void 0 === i.startMoving && (a.currentX === a.startX && a.currentY === a.startY || (i.startMoving = !0)),
            i.isScrolling || s.zoom && s.params.zoom && s.params.zoom.enabled && i.evCache.length > 1)
                return void (i.isTouched = !1);
            if (!i.startMoving)
                return;
            s.allowClick = !1,
            !n.cssMode && l.cancelable && l.preventDefault(),
            n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
            let f = s.isHorizontal() ? h : m
              , g = s.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
            n.oneWayMovement && (f = Math.abs(f) * (r ? 1 : -1),
            g = Math.abs(g) * (r ? 1 : -1)),
            a.diff = f,
            f *= n.touchRatio,
            r && (f = -f,
            g = -g);
            const v = s.touchesDirection;
            s.swipeDirection = f > 0 ? "prev" : "next",
            s.touchesDirection = g > 0 ? "prev" : "next";
            const y = s.params.loop && !n.cssMode
              , b = "next" === s.swipeDirection && s.allowSlideNext || "prev" === s.swipeDirection && s.allowSlidePrev;
            if (!i.isMoved) {
                if (y && b && s.loopFix({
                    direction: s.swipeDirection
                }),
                i.startTranslate = s.getTranslate(),
                s.setTransition(0),
                s.animating) {
                    const e = new window.CustomEvent("transitionend",{
                        bubbles: !0,
                        cancelable: !0
                    });
                    s.wrapperEl.dispatchEvent(e)
                }
                i.allowMomentumBounce = !1,
                !n.grabCursor || !0 !== s.allowSlideNext && !0 !== s.allowSlidePrev || s.setGrabCursor(!0),
                s.emit("sliderFirstMove", l)
            }
            let w;
            i.isMoved && v !== s.touchesDirection && y && b && Math.abs(f) >= 1 && (s.loopFix({
                direction: s.swipeDirection,
                setTranslate: !0
            }),
            w = !0),
            s.emit("sliderMove", l),
            i.isMoved = !0,
            i.currentTranslate = f + i.startTranslate;
            let S = !0
              , E = n.resistanceRatio;
            if (n.touchReleaseOnEdges && (E = 0),
            f > 0 ? (y && b && !w && i.currentTranslate > (n.centeredSlides ? s.minTranslate() - s.size / 2 : s.minTranslate()) && s.loopFix({
                direction: "prev",
                setTranslate: !0,
                activeSlideIndex: 0
            }),
            i.currentTranslate > s.minTranslate() && (S = !1,
            n.resistance && (i.currentTranslate = s.minTranslate() - 1 + (-s.minTranslate() + i.startTranslate + f) ** E))) : f < 0 && (y && b && !w && i.currentTranslate < (n.centeredSlides ? s.maxTranslate() + s.size / 2 : s.maxTranslate()) && s.loopFix({
                direction: "next",
                setTranslate: !0,
                activeSlideIndex: s.slides.length - ("auto" === n.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
            }),
            i.currentTranslate < s.maxTranslate() && (S = !1,
            n.resistance && (i.currentTranslate = s.maxTranslate() + 1 - (s.maxTranslate() - i.startTranslate - f) ** E))),
            S && (l.preventedByNestedSwiper = !0),
            !s.allowSlideNext && "next" === s.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate),
            !s.allowSlidePrev && "prev" === s.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate),
            s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate),
            n.threshold > 0) {
                if (!(Math.abs(f) > n.threshold || i.allowThresholdMove))
                    return void (i.currentTranslate = i.startTranslate);
                if (!i.allowThresholdMove)
                    return i.allowThresholdMove = !0,
                    a.startX = a.currentX,
                    a.startY = a.currentY,
                    i.currentTranslate = i.startTranslate,
                    void (a.diff = s.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY)
            }
            n.followFinger && !n.cssMode && ((n.freeMode && n.freeMode.enabled && s.freeMode || n.watchSlidesProgress) && (s.updateActiveIndex(),
            s.updateSlidesClasses()),
            n.freeMode && n.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(),
            s.updateProgress(i.currentTranslate),
            s.setTranslate(i.currentTranslate))
        }
        function Ut(e) {
            const t = this
              , s = t.touchEventsData
              , i = s.evCache.findIndex((t => t.pointerId === e.pointerId));
            if (i >= 0 && s.evCache.splice(i, 1),
            ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type)) {
                if (!(["pointercancel", "contextmenu"].includes(e.type) && (t.browser.isSafari || t.browser.isWebView)))
                    return
            }
            const {params: n, touches: a, rtlTranslate: r, slidesGrid: o, enabled: l} = t;
            if (!l)
                return;
            if (!n.simulateTouch && "mouse" === e.pointerType)
                return;
            let c = e;
            if (c.originalEvent && (c = c.originalEvent),
            s.allowTouchCallbacks && t.emit("touchEnd", c),
            s.allowTouchCallbacks = !1,
            !s.isTouched)
                return s.isMoved && n.grabCursor && t.setGrabCursor(!1),
                s.isMoved = !1,
                void (s.startMoving = !1);
            n.grabCursor && s.isMoved && s.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
            const d = yt()
              , u = d - s.touchStartTime;
            if (t.allowClick) {
                const e = c.path || c.composedPath && c.composedPath();
                t.updateClickedSlide(e && e[0] || c.target, e),
                t.emit("tap click", c),
                u < 300 && d - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", c)
            }
            if (s.lastClickTime = yt(),
            vt(( () => {
                t.destroyed || (t.allowClick = !0)
            }
            )),
            !s.isTouched || !s.isMoved || !t.swipeDirection || 0 === a.diff || s.currentTranslate === s.startTranslate)
                return s.isTouched = !1,
                s.isMoved = !1,
                void (s.startMoving = !1);
            let p;
            if (s.isTouched = !1,
            s.isMoved = !1,
            s.startMoving = !1,
            p = n.followFinger ? r ? t.translate : -t.translate : -s.currentTranslate,
            n.cssMode)
                return;
            if (n.freeMode && n.freeMode.enabled)
                return void t.freeMode.onTouchEnd({
                    currentPos: p
                });
            let h = 0
              , m = t.slidesSizesGrid[0];
            for (let e = 0; e < o.length; e += e < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup) {
                const t = e < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
                void 0 !== o[e + t] ? p >= o[e] && p < o[e + t] && (h = e,
                m = o[e + t] - o[e]) : p >= o[e] && (h = e,
                m = o[o.length - 1] - o[o.length - 2])
            }
            let f = null
              , g = null;
            n.rewind && (t.isBeginning ? g = n.virtual && n.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (f = 0));
            const v = (p - o[h]) / m
              , y = h < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
            if (u > n.longSwipesMs) {
                if (!n.longSwipes)
                    return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (v >= n.longSwipesRatio ? t.slideTo(n.rewind && t.isEnd ? f : h + y) : t.slideTo(h)),
                "prev" === t.swipeDirection && (v > 1 - n.longSwipesRatio ? t.slideTo(h + y) : null !== g && v < 0 && Math.abs(v) > n.longSwipesRatio ? t.slideTo(g) : t.slideTo(h))
            } else {
                if (!n.shortSwipes)
                    return void t.slideTo(t.activeIndex);
                t.navigation && (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl) ? c.target === t.navigation.nextEl ? t.slideTo(h + y) : t.slideTo(h) : ("next" === t.swipeDirection && t.slideTo(null !== f ? f : h + y),
                "prev" === t.swipeDirection && t.slideTo(null !== g ? g : h))
            }
        }
        function Kt() {
            const e = this
              , {params: t, el: s} = e;
            if (s && 0 === s.offsetWidth)
                return;
            t.breakpoints && e.setBreakpoint();
            const {allowSlideNext: i, allowSlidePrev: n, snapGrid: a} = e
              , r = e.virtual && e.params.virtual.enabled;
            e.allowSlideNext = !0,
            e.allowSlidePrev = !0,
            e.updateSize(),
            e.updateSlides(),
            e.updateSlidesClasses();
            const o = r && t.loop;
            !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || o ? e.params.loop && !r ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0),
            e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout),
            e.autoplay.resizeTimeout = setTimeout(( () => {
                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
            }
            ), 500)),
            e.allowSlidePrev = n,
            e.allowSlideNext = i,
            e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow()
        }
        function Jt(e) {
            const t = this;
            t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation && t.animating && (e.stopPropagation(),
            e.stopImmediatePropagation())))
        }
        function Qt() {
            const e = this
              , {wrapperEl: t, rtlTranslate: s, enabled: i} = e;
            if (!i)
                return;
            let n;
            e.previousTranslate = e.translate,
            e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop,
            0 === e.translate && (e.translate = 0),
            e.updateActiveIndex(),
            e.updateSlidesClasses();
            const a = e.maxTranslate() - e.minTranslate();
            n = 0 === a ? 0 : (e.translate - e.minTranslate()) / a,
            n !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
            e.emit("setTranslate", e.translate, !1)
        }
        function Zt(e) {
            const t = this;
            zt(t, e.target),
            t.params.cssMode || "auto" !== t.params.slidesPerView && !t.params.autoHeight || t.update()
        }
        let es = !1;
        function ts() {}
        const ss = (e, t) => {
            const s = mt()
              , {params: i, el: n, wrapperEl: a, device: r} = e
              , o = !!i.nested
              , l = "on" === t ? "addEventListener" : "removeEventListener"
              , c = t;
            n[l]("pointerdown", e.onTouchStart, {
                passive: !1
            }),
            s[l]("pointermove", e.onTouchMove, {
                passive: !1,
                capture: o
            }),
            s[l]("pointerup", e.onTouchEnd, {
                passive: !0
            }),
            s[l]("pointercancel", e.onTouchEnd, {
                passive: !0
            }),
            s[l]("pointerout", e.onTouchEnd, {
                passive: !0
            }),
            s[l]("pointerleave", e.onTouchEnd, {
                passive: !0
            }),
            s[l]("contextmenu", e.onTouchEnd, {
                passive: !0
            }),
            (i.preventClicks || i.preventClicksPropagation) && n[l]("click", e.onClick, !0),
            i.cssMode && a[l]("scroll", e.onScroll),
            i.updateOnWindowResize ? e[c](r.ios || r.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Kt, !0) : e[c]("observerUpdate", Kt, !0),
            n[l]("load", e.onLoad, {
                capture: !0
            })
        }
        ;
        const is = (e, t) => e.grid && t.grid && t.grid.rows > 1;
        var ns = {
            setBreakpoint: function() {
                const e = this
                  , {realIndex: t, initialized: s, params: i, el: n} = e
                  , a = i.breakpoints;
                if (!a || a && 0 === Object.keys(a).length)
                    return;
                const r = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
                if (!r || e.currentBreakpoint === r)
                    return;
                const o = (r in a ? a[r] : void 0) || e.originalParams
                  , l = is(e, i)
                  , c = is(e, o)
                  , d = i.enabled;
                l && !c ? (n.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`),
                e.emitContainerClasses()) : !l && c && (n.classList.add(`${i.containerModifierClass}grid`),
                (o.grid.fill && "column" === o.grid.fill || !o.grid.fill && "column" === i.grid.fill) && n.classList.add(`${i.containerModifierClass}grid-column`),
                e.emitContainerClasses()),
                ["navigation", "pagination", "scrollbar"].forEach((t => {
                    if (void 0 === o[t])
                        return;
                    const s = i[t] && i[t].enabled
                      , n = o[t] && o[t].enabled;
                    s && !n && e[t].disable(),
                    !s && n && e[t].enable()
                }
                ));
                const u = o.direction && o.direction !== i.direction
                  , p = i.loop && (o.slidesPerView !== i.slidesPerView || u)
                  , h = i.loop;
                u && s && e.changeDirection(),
                St(e.params, o);
                const m = e.params.enabled
                  , f = e.params.loop;
                Object.assign(e, {
                    allowTouchMove: e.params.allowTouchMove,
                    allowSlideNext: e.params.allowSlideNext,
                    allowSlidePrev: e.params.allowSlidePrev
                }),
                d && !m ? e.disable() : !d && m && e.enable(),
                e.currentBreakpoint = r,
                e.emit("_beforeBreakpoint", o),
                s && (p ? (e.loopDestroy(),
                e.loopCreate(t),
                e.updateSlides()) : !h && f ? (e.loopCreate(t),
                e.updateSlides()) : h && !f && e.loopDestroy()),
                e.emit("breakpoint", o)
            },
            getBreakpoint: function(e, t, s) {
                if (void 0 === t && (t = "window"),
                !e || "container" === t && !s)
                    return;
                let i = !1;
                const n = gt()
                  , a = "window" === t ? n.innerHeight : s.clientHeight
                  , r = Object.keys(e).map((e => {
                    if ("string" == typeof e && 0 === e.indexOf("@")) {
                        const t = parseFloat(e.substr(1));
                        return {
                            value: a * t,
                            point: e
                        }
                    }
                    return {
                        value: e,
                        point: e
                    }
                }
                ));
                r.sort(( (e, t) => parseInt(e.value, 10) - parseInt(t.value, 10)));
                for (let e = 0; e < r.length; e += 1) {
                    const {point: a, value: o} = r[e];
                    "window" === t ? n.matchMedia(`(min-width: ${o}px)`).matches && (i = a) : o <= s.clientWidth && (i = a)
                }
                return i || "max"
            }
        };
        var as = {
            init: !0,
            direction: "horizontal",
            oneWayMovement: !1,
            touchEventsTarget: "wrapper",
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            resizeObserver: !0,
            nested: !1,
            createElements: !1,
            enabled: !0,
            focusableElements: "input, select, option, textarea, button, video, label",
            width: null,
            height: null,
            preventInteractionOnTransition: !1,
            userAgent: null,
            url: null,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            breakpointsBase: "window",
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            slidesPerGroupAuto: !1,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: .5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 5,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: .85,
            watchSlidesProgress: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            loop: !1,
            loopedSlides: null,
            loopPreventsSliding: !0,
            rewind: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            maxBackfaceHiddenSlides: 10,
            containerModifierClass: "swiper-",
            slideClass: "swiper-slide",
            slideActiveClass: "swiper-slide-active",
            slideVisibleClass: "swiper-slide-visible",
            slideNextClass: "swiper-slide-next",
            slidePrevClass: "swiper-slide-prev",
            wrapperClass: "swiper-wrapper",
            lazyPreloaderClass: "swiper-lazy-preloader",
            lazyPreloadPrevNext: 0,
            runCallbacksOnInit: !0,
            _emitClasses: !1
        };
        function rs(e, t) {
            return function(s) {
                void 0 === s && (s = {});
                const i = Object.keys(s)[0]
                  , n = s[i];
                "object" == typeof n && null !== n ? (!0 === e[i] && (e[i] = {
                    enabled: !0
                }),
                "navigation" === i && e[i] && e[i].enabled && !e[i].prevEl && !e[i].nextEl && (e[i].auto = !0),
                ["pagination", "scrollbar"].indexOf(i) >= 0 && e[i] && e[i].enabled && !e[i].el && (e[i].auto = !0),
                i in e && "enabled"in n ? ("object" != typeof e[i] || "enabled"in e[i] || (e[i].enabled = !0),
                e[i] || (e[i] = {
                    enabled: !1
                }),
                St(t, s)) : St(t, s)) : St(t, s)
            }
        }
        const os = {
            eventsEmitter: Nt,
            update: Rt,
            translate: Gt,
            transition: {
                setTransition: function(e, t) {
                    const s = this;
                    s.params.cssMode || (s.wrapperEl.style.transitionDuration = `${e}ms`,
                    s.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""),
                    s.emit("setTransition", e, t)
                },
                transitionStart: function(e, t) {
                    void 0 === e && (e = !0);
                    const s = this
                      , {params: i} = s;
                    i.cssMode || (i.autoHeight && s.updateAutoHeight(),
                    jt({
                        swiper: s,
                        runCallbacks: e,
                        direction: t,
                        step: "Start"
                    }))
                },
                transitionEnd: function(e, t) {
                    void 0 === e && (e = !0);
                    const s = this
                      , {params: i} = s;
                    s.animating = !1,
                    i.cssMode || (s.setTransition(0),
                    jt({
                        swiper: s,
                        runCallbacks: e,
                        direction: t,
                        step: "End"
                    }))
                }
            },
            slide: Vt,
            loop: Wt,
            grabCursor: {
                setGrabCursor: function(e) {
                    const t = this;
                    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)
                        return;
                    const s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                    t.isElement && (t.__preventObserver__ = !0),
                    s.style.cursor = "move",
                    s.style.cursor = e ? "grabbing" : "grab",
                    t.isElement && requestAnimationFrame(( () => {
                        t.__preventObserver__ = !1
                    }
                    ))
                },
                unsetGrabCursor: function() {
                    const e = this;
                    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0),
                    e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "",
                    e.isElement && requestAnimationFrame(( () => {
                        e.__preventObserver__ = !1
                    }
                    )))
                }
            },
            events: {
                attachEvents: function() {
                    const e = this
                      , t = mt()
                      , {params: s} = e;
                    e.onTouchStart = Yt.bind(e),
                    e.onTouchMove = Xt.bind(e),
                    e.onTouchEnd = Ut.bind(e),
                    s.cssMode && (e.onScroll = Qt.bind(e)),
                    e.onClick = Jt.bind(e),
                    e.onLoad = Zt.bind(e),
                    es || (t.addEventListener("touchstart", ts),
                    es = !0),
                    ss(e, "on")
                },
                detachEvents: function() {
                    ss(this, "off")
                }
            },
            breakpoints: ns,
            checkOverflow: {
                checkOverflow: function() {
                    const e = this
                      , {isLocked: t, params: s} = e
                      , {slidesOffsetBefore: i} = s;
                    if (i) {
                        const t = e.slides.length - 1
                          , s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
                        e.isLocked = e.size > s
                    } else
                        e.isLocked = 1 === e.snapGrid.length;
                    !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                    !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                    t && t !== e.isLocked && (e.isEnd = !1),
                    t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock")
                }
            },
            classes: {
                addClasses: function() {
                    const e = this
                      , {classNames: t, params: s, rtl: i, el: n, device: a} = e
                      , r = function(e, t) {
                        const s = [];
                        return e.forEach((e => {
                            "object" == typeof e ? Object.keys(e).forEach((i => {
                                e[i] && s.push(t + i)
                            }
                            )) : "string" == typeof e && s.push(t + e)
                        }
                        )),
                        s
                    }(["initialized", s.direction, {
                        "free-mode": e.params.freeMode && s.freeMode.enabled
                    }, {
                        autoheight: s.autoHeight
                    }, {
                        rtl: i
                    }, {
                        grid: s.grid && s.grid.rows > 1
                    }, {
                        "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill
                    }, {
                        android: a.android
                    }, {
                        ios: a.ios
                    }, {
                        "css-mode": s.cssMode
                    }, {
                        centered: s.cssMode && s.centeredSlides
                    }, {
                        "watch-progress": s.watchSlidesProgress
                    }], s.containerModifierClass);
                    t.push(...r),
                    n.classList.add(...t),
                    e.emitContainerClasses()
                },
                removeClasses: function() {
                    const {el: e, classNames: t} = this;
                    e.classList.remove(...t),
                    this.emitContainerClasses()
                }
            }
        }
          , ls = {};
        class cs {
            constructor() {
                let e, t;
                for (var s = arguments.length, i = new Array(s), n = 0; n < s; n++)
                    i[n] = arguments[n];
                1 === i.length && i[0].constructor && "Object" === Object.prototype.toString.call(i[0]).slice(8, -1) ? t = i[0] : [e,t] = i,
                t || (t = {}),
                t = St({}, t),
                e && !t.el && (t.el = e);
                const a = mt();
                if (t.el && "string" == typeof t.el && a.querySelectorAll(t.el).length > 1) {
                    const e = [];
                    return a.querySelectorAll(t.el).forEach((s => {
                        const i = St({}, t, {
                            el: s
                        });
                        e.push(new cs(i))
                    }
                    )),
                    e
                }
                const r = this;
                r.__swiper__ = !0,
                r.support = $t(),
                r.device = Bt({
                    userAgent: t.userAgent
                }),
                r.browser = Dt(),
                r.eventsListeners = {},
                r.eventsAnyListeners = [],
                r.modules = [...r.__modules__],
                t.modules && Array.isArray(t.modules) && r.modules.push(...t.modules);
                const o = {};
                r.modules.forEach((e => {
                    e({
                        params: t,
                        swiper: r,
                        extendParams: rs(t, o),
                        on: r.on.bind(r),
                        once: r.once.bind(r),
                        off: r.off.bind(r),
                        emit: r.emit.bind(r)
                    })
                }
                ));
                const l = St({}, as, o);
                return r.params = St({}, l, ls, t),
                r.originalParams = St({}, r.params),
                r.passedParams = St({}, t),
                r.params && r.params.on && Object.keys(r.params.on).forEach((e => {
                    r.on(e, r.params.on[e])
                }
                )),
                r.params && r.params.onAny && r.onAny(r.params.onAny),
                Object.assign(r, {
                    enabled: r.params.enabled,
                    el: e,
                    classNames: [],
                    slides: [],
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: () => "horizontal" === r.params.direction,
                    isVertical: () => "vertical" === r.params.direction,
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    cssOverflowAdjustment() {
                        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
                    },
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        focusableElements: r.params.focusableElements,
                        lastClickTime: 0,
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        startMoving: void 0,
                        evCache: []
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }),
                r.emit("_swiper"),
                r.params.init && r.init(),
                r
            }
            getSlideIndex(e) {
                const {slidesEl: t, params: s} = this
                  , i = kt(Lt(t, `.${s.slideClass}, swiper-slide`)[0]);
                return kt(e) - i
            }
            getSlideIndexByData(e) {
                return this.getSlideIndex(this.slides.filter((t => 1 * t.getAttribute("data-swiper-slide-index") === e))[0])
            }
            recalcSlides() {
                const {slidesEl: e, params: t} = this;
                this.slides = Lt(e, `.${t.slideClass}, swiper-slide`)
            }
            enable() {
                const e = this;
                e.enabled || (e.enabled = !0,
                e.params.grabCursor && e.setGrabCursor(),
                e.emit("enable"))
            }
            disable() {
                const e = this;
                e.enabled && (e.enabled = !1,
                e.params.grabCursor && e.unsetGrabCursor(),
                e.emit("disable"))
            }
            setProgress(e, t) {
                const s = this;
                e = Math.min(Math.max(e, 0), 1);
                const i = s.minTranslate()
                  , n = (s.maxTranslate() - i) * e + i;
                s.translateTo(n, void 0 === t ? 0 : t),
                s.updateActiveIndex(),
                s.updateSlidesClasses()
            }
            emitContainerClasses() {
                const e = this;
                if (!e.params._emitClasses || !e.el)
                    return;
                const t = e.el.className.split(" ").filter((t => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass)));
                e.emit("_containerClasses", t.join(" "))
            }
            getSlideClasses(e) {
                const t = this;
                return t.destroyed ? "" : e.className.split(" ").filter((e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))).join(" ")
            }
            emitSlidesClasses() {
                const e = this;
                if (!e.params._emitClasses || !e.el)
                    return;
                const t = [];
                e.slides.forEach((s => {
                    const i = e.getSlideClasses(s);
                    t.push({
                        slideEl: s,
                        classNames: i
                    }),
                    e.emit("_slideClass", s, i)
                }
                )),
                e.emit("_slideClasses", t)
            }
            slidesPerViewDynamic(e, t) {
                void 0 === e && (e = "current"),
                void 0 === t && (t = !1);
                const {params: s, slides: i, slidesGrid: n, slidesSizesGrid: a, size: r, activeIndex: o} = this;
                let l = 1;
                if ("number" == typeof s.slidesPerView)
                    return s.slidesPerView;
                if (s.centeredSlides) {
                    let e, t = i[o] ? i[o].swiperSlideSize : 0;
                    for (let s = o + 1; s < i.length; s += 1)
                        i[s] && !e && (t += i[s].swiperSlideSize,
                        l += 1,
                        t > r && (e = !0));
                    for (let s = o - 1; s >= 0; s -= 1)
                        i[s] && !e && (t += i[s].swiperSlideSize,
                        l += 1,
                        t > r && (e = !0))
                } else if ("current" === e)
                    for (let e = o + 1; e < i.length; e += 1) {
                        (t ? n[e] + a[e] - n[o] < r : n[e] - n[o] < r) && (l += 1)
                    }
                else
                    for (let e = o - 1; e >= 0; e -= 1) {
                        n[o] - n[e] < r && (l += 1)
                    }
                return l
            }
            update() {
                const e = this;
                if (!e || e.destroyed)
                    return;
                const {snapGrid: t, params: s} = e;
                function i() {
                    const t = e.rtlTranslate ? -1 * e.translate : e.translate
                      , s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(s),
                    e.updateActiveIndex(),
                    e.updateSlidesClasses()
                }
                let n;
                if (s.breakpoints && e.setBreakpoint(),
                [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t => {
                    t.complete && zt(e, t)
                }
                )),
                e.updateSize(),
                e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                s.freeMode && s.freeMode.enabled && !s.cssMode)
                    i(),
                    s.autoHeight && e.updateAutoHeight();
                else {
                    if (("auto" === s.slidesPerView || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
                        const t = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
                        n = e.slideTo(t.length - 1, 0, !1, !0)
                    } else
                        n = e.slideTo(e.activeIndex, 0, !1, !0);
                    n || i()
                }
                s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                e.emit("update")
            }
            changeDirection(e, t) {
                void 0 === t && (t = !0);
                const s = this
                  , i = s.params.direction;
                return e || (e = "horizontal" === i ? "vertical" : "horizontal"),
                e === i || "horizontal" !== e && "vertical" !== e || (s.el.classList.remove(`${s.params.containerModifierClass}${i}`),
                s.el.classList.add(`${s.params.containerModifierClass}${e}`),
                s.emitContainerClasses(),
                s.params.direction = e,
                s.slides.forEach((t => {
                    "vertical" === e ? t.style.width = "" : t.style.height = ""
                }
                )),
                s.emit("changeDirection"),
                t && s.update()),
                s
            }
            changeLanguageDirection(e) {
                const t = this;
                t.rtl && "rtl" === e || !t.rtl && "ltr" === e || (t.rtl = "rtl" === e,
                t.rtlTranslate = "horizontal" === t.params.direction && t.rtl,
                t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
                t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
                t.el.dir = "ltr"),
                t.update())
            }
            mount(e) {
                const t = this;
                if (t.mounted)
                    return !0;
                let s = e || t.params.el;
                if ("string" == typeof s && (s = document.querySelector(s)),
                !s)
                    return !1;
                s.swiper = t,
                s.parentNode && s.parentNode.host && "SWIPER-CONTAINER" === s.parentNode.host.nodeName && (t.isElement = !0);
                const i = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
                let n = ( () => {
                    if (s && s.shadowRoot && s.shadowRoot.querySelector) {
                        return s.shadowRoot.querySelector(i())
                    }
                    return Lt(s, i())[0]
                }
                )();
                return !n && t.params.createElements && (n = At("div", t.params.wrapperClass),
                s.append(n),
                Lt(s, `.${t.params.slideClass}`).forEach((e => {
                    n.append(e)
                }
                ))),
                Object.assign(t, {
                    el: s,
                    wrapperEl: n,
                    slidesEl: t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : n,
                    hostEl: t.isElement ? s.parentNode.host : s,
                    mounted: !0,
                    rtl: "rtl" === s.dir.toLowerCase() || "rtl" === Ct(s, "direction"),
                    rtlTranslate: "horizontal" === t.params.direction && ("rtl" === s.dir.toLowerCase() || "rtl" === Ct(s, "direction")),
                    wrongRTL: "-webkit-box" === Ct(n, "display")
                }),
                !0
            }
            init(e) {
                const t = this;
                if (t.initialized)
                    return t;
                if (!1 === t.mount(e))
                    return t;
                t.emit("beforeInit"),
                t.params.breakpoints && t.setBreakpoint(),
                t.addClasses(),
                t.updateSize(),
                t.updateSlides(),
                t.params.watchOverflow && t.checkOverflow(),
                t.params.grabCursor && t.enabled && t.setGrabCursor(),
                t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                t.params.loop && t.loopCreate(),
                t.attachEvents();
                const s = [...t.el.querySelectorAll('[loading="lazy"]')];
                return t.isElement && s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
                s.forEach((e => {
                    e.complete ? zt(t, e) : e.addEventListener("load", (e => {
                        zt(t, e.target)
                    }
                    ))
                }
                )),
                Ht(t),
                t.initialized = !0,
                Ht(t),
                t.emit("init"),
                t.emit("afterInit"),
                t
            }
            destroy(e, t) {
                void 0 === e && (e = !0),
                void 0 === t && (t = !0);
                const s = this
                  , {params: i, el: n, wrapperEl: a, slides: r} = s;
                return void 0 === s.params || s.destroyed || (s.emit("beforeDestroy"),
                s.initialized = !1,
                s.detachEvents(),
                i.loop && s.loopDestroy(),
                t && (s.removeClasses(),
                n.removeAttribute("style"),
                a.removeAttribute("style"),
                r && r.length && r.forEach((e => {
                    e.classList.remove(i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass),
                    e.removeAttribute("style"),
                    e.removeAttribute("data-swiper-slide-index")
                }
                ))),
                s.emit("destroy"),
                Object.keys(s.eventsListeners).forEach((e => {
                    s.off(e)
                }
                )),
                !1 !== e && (s.el.swiper = null,
                function(e) {
                    const t = e;
                    Object.keys(t).forEach((e => {
                        try {
                            t[e] = null
                        } catch (e) {}
                        try {
                            delete t[e]
                        } catch (e) {}
                    }
                    ))
                }(s)),
                s.destroyed = !0),
                null
            }
            static extendDefaults(e) {
                St(ls, e)
            }
            static get extendedDefaults() {
                return ls
            }
            static get defaults() {
                return as
            }
            static installModule(e) {
                cs.prototype.__modules__ || (cs.prototype.__modules__ = []);
                const t = cs.prototype.__modules__;
                "function" == typeof e && t.indexOf(e) < 0 && t.push(e)
            }
            static use(e) {
                return Array.isArray(e) ? (e.forEach((e => cs.installModule(e))),
                cs) : (cs.installModule(e),
                cs)
            }
        }
        function ds(e) {
            let {swiper: t, extendParams: s, on: i, emit: n} = e;
            const a = gt();
            let r;
            s({
                mousewheel: {
                    enabled: !1,
                    releaseOnEdges: !1,
                    invert: !1,
                    forceToAxis: !1,
                    sensitivity: 1,
                    eventsTarget: "container",
                    thresholdDelta: null,
                    thresholdTime: null,
                    noMousewheelClass: "swiper-no-mousewheel"
                }
            }),
            t.mousewheel = {
                enabled: !1
            };
            let o, l = yt();
            const c = [];
            function d() {
                t.enabled && (t.mouseEntered = !0)
            }
            function u() {
                t.enabled && (t.mouseEntered = !1)
            }
            function p(e) {
                return !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) && (!(t.params.mousewheel.thresholdTime && yt() - l < t.params.mousewheel.thresholdTime) && (e.delta >= 6 && yt() - l < 60 || (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(),
                n("scroll", e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(),
                n("scroll", e.raw)),
                l = (new a.Date).getTime(),
                !1)))
            }
            function h(e) {
                let s = e
                  , i = !0;
                if (!t.enabled)
                    return;
                if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`))
                    return;
                const a = t.params.mousewheel;
                t.params.cssMode && s.preventDefault();
                let l = t.el;
                "container" !== t.params.mousewheel.eventsTarget && (l = document.querySelector(t.params.mousewheel.eventsTarget));
                const d = l && l.contains(s.target);
                if (!t.mouseEntered && !d && !a.releaseOnEdges)
                    return !0;
                s.originalEvent && (s = s.originalEvent);
                let u = 0;
                const h = t.rtlTranslate ? -1 : 1
                  , m = function(e) {
                    let t = 0
                      , s = 0
                      , i = 0
                      , n = 0;
                    return "detail"in e && (s = e.detail),
                    "wheelDelta"in e && (s = -e.wheelDelta / 120),
                    "wheelDeltaY"in e && (s = -e.wheelDeltaY / 120),
                    "wheelDeltaX"in e && (t = -e.wheelDeltaX / 120),
                    "axis"in e && e.axis === e.HORIZONTAL_AXIS && (t = s,
                    s = 0),
                    i = 10 * t,
                    n = 10 * s,
                    "deltaY"in e && (n = e.deltaY),
                    "deltaX"in e && (i = e.deltaX),
                    e.shiftKey && !i && (i = n,
                    n = 0),
                    (i || n) && e.deltaMode && (1 === e.deltaMode ? (i *= 40,
                    n *= 40) : (i *= 800,
                    n *= 800)),
                    i && !t && (t = i < 1 ? -1 : 1),
                    n && !s && (s = n < 1 ? -1 : 1),
                    {
                        spinX: t,
                        spinY: s,
                        pixelX: i,
                        pixelY: n
                    }
                }(s);
                if (a.forceToAxis)
                    if (t.isHorizontal()) {
                        if (!(Math.abs(m.pixelX) > Math.abs(m.pixelY)))
                            return !0;
                        u = -m.pixelX * h
                    } else {
                        if (!(Math.abs(m.pixelY) > Math.abs(m.pixelX)))
                            return !0;
                        u = -m.pixelY
                    }
                else
                    u = Math.abs(m.pixelX) > Math.abs(m.pixelY) ? -m.pixelX * h : -m.pixelY;
                if (0 === u)
                    return !0;
                a.invert && (u = -u);
                let f = t.getTranslate() + u * a.sensitivity;
                if (f >= t.minTranslate() && (f = t.minTranslate()),
                f <= t.maxTranslate() && (f = t.maxTranslate()),
                i = !!t.params.loop || !(f === t.minTranslate() || f === t.maxTranslate()),
                i && t.params.nested && s.stopPropagation(),
                t.params.freeMode && t.params.freeMode.enabled) {
                    const e = {
                        time: yt(),
                        delta: Math.abs(u),
                        direction: Math.sign(u)
                    }
                      , i = o && e.time < o.time + 500 && e.delta <= o.delta && e.direction === o.direction;
                    if (!i) {
                        o = void 0;
                        let l = t.getTranslate() + u * a.sensitivity;
                        const d = t.isBeginning
                          , p = t.isEnd;
                        if (l >= t.minTranslate() && (l = t.minTranslate()),
                        l <= t.maxTranslate() && (l = t.maxTranslate()),
                        t.setTransition(0),
                        t.setTranslate(l),
                        t.updateProgress(),
                        t.updateActiveIndex(),
                        t.updateSlidesClasses(),
                        (!d && t.isBeginning || !p && t.isEnd) && t.updateSlidesClasses(),
                        t.params.loop && t.loopFix({
                            direction: e.direction < 0 ? "next" : "prev",
                            byMousewheel: !0
                        }),
                        t.params.freeMode.sticky) {
                            clearTimeout(r),
                            r = void 0,
                            c.length >= 15 && c.shift();
                            const s = c.length ? c[c.length - 1] : void 0
                              , i = c[0];
                            if (c.push(e),
                            s && (e.delta > s.delta || e.direction !== s.direction))
                                c.splice(0);
                            else if (c.length >= 15 && e.time - i.time < 500 && i.delta - e.delta >= 1 && e.delta <= 6) {
                                const s = u > 0 ? .8 : .2;
                                o = e,
                                c.splice(0),
                                r = vt(( () => {
                                    t.slideToClosest(t.params.speed, !0, void 0, s)
                                }
                                ), 0)
                            }
                            r || (r = vt(( () => {
                                o = e,
                                c.splice(0),
                                t.slideToClosest(t.params.speed, !0, void 0, .5)
                            }
                            ), 500))
                        }
                        if (i || n("scroll", s),
                        t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(),
                        a.releaseOnEdges && (l === t.minTranslate() || l === t.maxTranslate()))
                            return !0
                    }
                } else {
                    const s = {
                        time: yt(),
                        delta: Math.abs(u),
                        direction: Math.sign(u),
                        raw: e
                    };
                    c.length >= 2 && c.shift();
                    const i = c.length ? c[c.length - 1] : void 0;
                    if (c.push(s),
                    i ? (s.direction !== i.direction || s.delta > i.delta || s.time > i.time + 150) && p(s) : p(s),
                    function(e) {
                        const s = t.params.mousewheel;
                        if (e.direction < 0) {
                            if (t.isEnd && !t.params.loop && s.releaseOnEdges)
                                return !0
                        } else if (t.isBeginning && !t.params.loop && s.releaseOnEdges)
                            return !0;
                        return !1
                    }(s))
                        return !0
                }
                return s.preventDefault ? s.preventDefault() : s.returnValue = !1,
                !1
            }
            function m(e) {
                let s = t.el;
                "container" !== t.params.mousewheel.eventsTarget && (s = document.querySelector(t.params.mousewheel.eventsTarget)),
                s[e]("mouseenter", d),
                s[e]("mouseleave", u),
                s[e]("wheel", h)
            }
            function f() {
                return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", h),
                !0) : !t.mousewheel.enabled && (m("addEventListener"),
                t.mousewheel.enabled = !0,
                !0)
            }
            function g() {
                return t.params.cssMode ? (t.wrapperEl.addEventListener(event, h),
                !0) : !!t.mousewheel.enabled && (m("removeEventListener"),
                t.mousewheel.enabled = !1,
                !0)
            }
            i("init", ( () => {
                !t.params.mousewheel.enabled && t.params.cssMode && g(),
                t.params.mousewheel.enabled && f()
            }
            )),
            i("destroy", ( () => {
                t.params.cssMode && f(),
                t.mousewheel.enabled && g()
            }
            )),
            Object.assign(t.mousewheel, {
                enable: f,
                disable: g
            })
        }
        function us(e, t, s, i) {
            return e.params.createElements && Object.keys(i).forEach((n => {
                if (!s[n] && !0 === s.auto) {
                    let a = Lt(e.el, `.${i[n]}`)[0];
                    a || (a = At("div", i[n]),
                    a.className = i[n],
                    e.el.append(a)),
                    s[n] = a,
                    t[n] = a
                }
            }
            )),
            s
        }
        function ps(e) {
            let {swiper: t, extendParams: s, on: i, emit: n} = e;
            s({
                navigation: {
                    nextEl: null,
                    prevEl: null,
                    hideOnClick: !1,
                    disabledClass: "swiper-button-disabled",
                    hiddenClass: "swiper-button-hidden",
                    lockClass: "swiper-button-lock",
                    navigationDisabledClass: "swiper-navigation-disabled"
                }
            }),
            t.navigation = {
                nextEl: null,
                prevEl: null
            };
            const a = e => (Array.isArray(e) ? e : [e]).filter((e => !!e));
            function r(e) {
                let s;
                return e && "string" == typeof e && t.isElement && (s = t.el.querySelector(e),
                s) ? s : (e && ("string" == typeof e && (s = [...document.querySelectorAll(e)]),
                t.params.uniqueNavElements && "string" == typeof e && s.length > 1 && 1 === t.el.querySelectorAll(e).length && (s = t.el.querySelector(e))),
                e && !s ? e : s)
            }
            function o(e, s) {
                const i = t.params.navigation;
                (e = a(e)).forEach((e => {
                    e && (e.classList[s ? "add" : "remove"](...i.disabledClass.split(" ")),
                    "BUTTON" === e.tagName && (e.disabled = s),
                    t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](i.lockClass))
                }
                ))
            }
            function l() {
                const {nextEl: e, prevEl: s} = t.navigation;
                if (t.params.loop)
                    return o(s, !1),
                    void o(e, !1);
                o(s, t.isBeginning && !t.params.rewind),
                o(e, t.isEnd && !t.params.rewind)
            }
            function c(e) {
                e.preventDefault(),
                (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(),
                n("navigationPrev"))
            }
            function d(e) {
                e.preventDefault(),
                (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(),
                n("navigationNext"))
            }
            function u() {
                const e = t.params.navigation;
                if (t.params.navigation = us(t, t.originalParams.navigation, t.params.navigation, {
                    nextEl: "swiper-button-next",
                    prevEl: "swiper-button-prev"
                }),
                !e.nextEl && !e.prevEl)
                    return;
                let s = r(e.nextEl)
                  , i = r(e.prevEl);
                Object.assign(t.navigation, {
                    nextEl: s,
                    prevEl: i
                }),
                s = a(s),
                i = a(i);
                const n = (s, i) => {
                    s && s.addEventListener("click", "next" === i ? d : c),
                    !t.enabled && s && s.classList.add(...e.lockClass.split(" "))
                }
                ;
                s.forEach((e => n(e, "next"))),
                i.forEach((e => n(e, "prev")))
            }
            function p() {
                let {nextEl: e, prevEl: s} = t.navigation;
                e = a(e),
                s = a(s);
                const i = (e, s) => {
                    e.removeEventListener("click", "next" === s ? d : c),
                    e.classList.remove(...t.params.navigation.disabledClass.split(" "))
                }
                ;
                e.forEach((e => i(e, "next"))),
                s.forEach((e => i(e, "prev")))
            }
            i("init", ( () => {
                !1 === t.params.navigation.enabled ? h() : (u(),
                l())
            }
            )),
            i("toEdge fromEdge lock unlock", ( () => {
                l()
            }
            )),
            i("destroy", ( () => {
                p()
            }
            )),
            i("enable disable", ( () => {
                let {nextEl: e, prevEl: s} = t.navigation;
                e = a(e),
                s = a(s),
                t.enabled ? l() : [...e, ...s].filter((e => !!e)).forEach((e => e.classList.add(t.params.navigation.lockClass)))
            }
            )),
            i("click", ( (e, s) => {
                let {nextEl: i, prevEl: r} = t.navigation;
                i = a(i),
                r = a(r);
                const o = s.target;
                if (t.params.navigation.hideOnClick && !r.includes(o) && !i.includes(o)) {
                    if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === o || t.pagination.el.contains(o)))
                        return;
                    let e;
                    i.length ? e = i[0].classList.contains(t.params.navigation.hiddenClass) : r.length && (e = r[0].classList.contains(t.params.navigation.hiddenClass)),
                    n(!0 === e ? "navigationShow" : "navigationHide"),
                    [...i, ...r].filter((e => !!e)).forEach((e => e.classList.toggle(t.params.navigation.hiddenClass)))
                }
            }
            ));
            const h = () => {
                t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")),
                p()
            }
            ;
            Object.assign(t.navigation, {
                enable: () => {
                    t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")),
                    u(),
                    l()
                }
                ,
                disable: h,
                update: l,
                init: u,
                destroy: p
            })
        }
        function hs(e) {
            return void 0 === e && (e = ""),
            `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`
        }
        function ms(e) {
            let {swiper: t, extendParams: s, on: i, emit: n} = e;
            const a = "swiper-pagination";
            let r;
            s({
                pagination: {
                    el: null,
                    bulletElement: "span",
                    clickable: !1,
                    hideOnClick: !1,
                    renderBullet: null,
                    renderProgressbar: null,
                    renderFraction: null,
                    renderCustom: null,
                    progressbarOpposite: !1,
                    type: "bullets",
                    dynamicBullets: !1,
                    dynamicMainBullets: 1,
                    formatFractionCurrent: e => e,
                    formatFractionTotal: e => e,
                    bulletClass: `${a}-bullet`,
                    bulletActiveClass: `${a}-bullet-active`,
                    modifierClass: `${a}-`,
                    currentClass: `${a}-current`,
                    totalClass: `${a}-total`,
                    hiddenClass: `${a}-hidden`,
                    progressbarFillClass: `${a}-progressbar-fill`,
                    progressbarOppositeClass: `${a}-progressbar-opposite`,
                    clickableClass: `${a}-clickable`,
                    lockClass: `${a}-lock`,
                    horizontalClass: `${a}-horizontal`,
                    verticalClass: `${a}-vertical`,
                    paginationDisabledClass: `${a}-disabled`
                }
            }),
            t.pagination = {
                el: null,
                bullets: []
            };
            let o = 0;
            const l = e => (Array.isArray(e) ? e : [e]).filter((e => !!e));
            function c() {
                return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && 0 === t.pagination.el.length
            }
            function d(e, s) {
                const {bulletActiveClass: i} = t.params.pagination;
                e && (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) && (e.classList.add(`${i}-${s}`),
                (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) && e.classList.add(`${i}-${s}-${s}`))
            }
            function u(e) {
                const s = e.target.closest(hs(t.params.pagination.bulletClass));
                if (!s)
                    return;
                e.preventDefault();
                const i = kt(s) * t.params.slidesPerGroup;
                if (t.params.loop) {
                    if (t.realIndex === i)
                        return;
                    const e = t.realIndex
                      , s = t.getSlideIndexByData(i)
                      , n = t.getSlideIndexByData(t.realIndex)
                      , a = i => {
                        const n = t.activeIndex;
                        t.loopFix({
                            direction: i,
                            activeSlideIndex: s,
                            slideTo: !1
                        });
                        n === t.activeIndex && t.slideToLoop(e, 0, !1, !0)
                    }
                    ;
                    if (s > t.slides.length - t.loopedSlides)
                        a(s > n ? "next" : "prev");
                    else if (t.params.centeredSlides) {
                        const e = "auto" === t.params.slidesPerView ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(t.params.slidesPerView, 10));
                        s < Math.floor(e / 2) && a("prev")
                    }
                    t.slideToLoop(i)
                } else
                    t.slideTo(i)
            }
            function p() {
                const e = t.rtl
                  , s = t.params.pagination;
                if (c())
                    return;
                let i, a, u = t.pagination.el;
                u = l(u);
                const p = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length
                  , h = t.params.loop ? Math.ceil(p / t.params.slidesPerGroup) : t.snapGrid.length;
                if (t.params.loop ? (a = t.previousRealIndex || 0,
                i = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : void 0 !== t.snapIndex ? (i = t.snapIndex,
                a = t.previousSnapIndex) : (a = t.previousIndex || 0,
                i = t.activeIndex || 0),
                "bullets" === s.type && t.pagination.bullets && t.pagination.bullets.length > 0) {
                    const n = t.pagination.bullets;
                    let l, c, p;
                    if (s.dynamicBullets && (r = Ot(n[0], t.isHorizontal() ? "width" : "height", !0),
                    u.forEach((e => {
                        e.style[t.isHorizontal() ? "width" : "height"] = r * (s.dynamicMainBullets + 4) + "px"
                    }
                    )),
                    s.dynamicMainBullets > 1 && void 0 !== a && (o += i - (a || 0),
                    o > s.dynamicMainBullets - 1 ? o = s.dynamicMainBullets - 1 : o < 0 && (o = 0)),
                    l = Math.max(i - o, 0),
                    c = l + (Math.min(n.length, s.dynamicMainBullets) - 1),
                    p = (c + l) / 2),
                    n.forEach((e => {
                        const t = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e => `${s.bulletActiveClass}${e}`))].map((e => "string" == typeof e && e.includes(" ") ? e.split(" ") : e)).flat();
                        e.classList.remove(...t)
                    }
                    )),
                    u.length > 1)
                        n.forEach((e => {
                            const n = kt(e);
                            n === i ? e.classList.add(...s.bulletActiveClass.split(" ")) : t.isElement && e.setAttribute("part", "bullet"),
                            s.dynamicBullets && (n >= l && n <= c && e.classList.add(...`${s.bulletActiveClass}-main`.split(" ")),
                            n === l && d(e, "prev"),
                            n === c && d(e, "next"))
                        }
                        ));
                    else {
                        const e = n[i];
                        if (e && e.classList.add(...s.bulletActiveClass.split(" ")),
                        t.isElement && n.forEach(( (e, t) => {
                            e.setAttribute("part", t === i ? "bullet-active" : "bullet")
                        }
                        )),
                        s.dynamicBullets) {
                            const e = n[l]
                              , t = n[c];
                            for (let e = l; e <= c; e += 1)
                                n[e] && n[e].classList.add(...`${s.bulletActiveClass}-main`.split(" "));
                            d(e, "prev"),
                            d(t, "next")
                        }
                    }
                    if (s.dynamicBullets) {
                        const i = Math.min(n.length, s.dynamicMainBullets + 4)
                          , a = (r * i - r) / 2 - p * r
                          , o = e ? "right" : "left";
                        n.forEach((e => {
                            e.style[t.isHorizontal() ? o : "top"] = `${a}px`
                        }
                        ))
                    }
                }
                u.forEach(( (e, a) => {
                    if ("fraction" === s.type && (e.querySelectorAll(hs(s.currentClass)).forEach((e => {
                        e.textContent = s.formatFractionCurrent(i + 1)
                    }
                    )),
                    e.querySelectorAll(hs(s.totalClass)).forEach((e => {
                        e.textContent = s.formatFractionTotal(h)
                    }
                    ))),
                    "progressbar" === s.type) {
                        let n;
                        n = s.progressbarOpposite ? t.isHorizontal() ? "vertical" : "horizontal" : t.isHorizontal() ? "horizontal" : "vertical";
                        const a = (i + 1) / h;
                        let r = 1
                          , o = 1;
                        "horizontal" === n ? r = a : o = a,
                        e.querySelectorAll(hs(s.progressbarFillClass)).forEach((e => {
                            e.style.transform = `translate3d(0,0,0) scaleX(${r}) scaleY(${o})`,
                            e.style.transitionDuration = `${t.params.speed}ms`
                        }
                        ))
                    }
                    "custom" === s.type && s.renderCustom ? (e.innerHTML = s.renderCustom(t, i + 1, h),
                    0 === a && n("paginationRender", e)) : (0 === a && n("paginationRender", e),
                    n("paginationUpdate", e)),
                    t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](s.lockClass)
                }
                ))
            }
            function h() {
                const e = t.params.pagination;
                if (c())
                    return;
                const s = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length;
                let i = t.pagination.el;
                i = l(i);
                let a = "";
                if ("bullets" === e.type) {
                    let i = t.params.loop ? Math.ceil(s / t.params.slidesPerGroup) : t.snapGrid.length;
                    t.params.freeMode && t.params.freeMode.enabled && i > s && (i = s);
                    for (let s = 0; s < i; s += 1)
                        e.renderBullet ? a += e.renderBullet.call(t, s, e.bulletClass) : a += `<${e.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`
                }
                "fraction" === e.type && (a = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
                "progressbar" === e.type && (a = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`),
                t.pagination.bullets = [],
                i.forEach((s => {
                    "custom" !== e.type && (s.innerHTML = a || ""),
                    "bullets" === e.type && t.pagination.bullets.push(...s.querySelectorAll(hs(e.bulletClass)))
                }
                )),
                "custom" !== e.type && n("paginationRender", i[0])
            }
            function m() {
                t.params.pagination = us(t, t.originalParams.pagination, t.params.pagination, {
                    el: "swiper-pagination"
                });
                const e = t.params.pagination;
                if (!e.el)
                    return;
                let s;
                "string" == typeof e.el && t.isElement && (s = t.el.querySelector(e.el)),
                s || "string" != typeof e.el || (s = [...document.querySelectorAll(e.el)]),
                s || (s = e.el),
                s && 0 !== s.length && (t.params.uniqueNavElements && "string" == typeof e.el && Array.isArray(s) && s.length > 1 && (s = [...t.el.querySelectorAll(e.el)],
                s.length > 1 && (s = s.filter((e => qt(e, ".swiper")[0] === t.el))[0])),
                Array.isArray(s) && 1 === s.length && (s = s[0]),
                Object.assign(t.pagination, {
                    el: s
                }),
                s = l(s),
                s.forEach((s => {
                    "bullets" === e.type && e.clickable && s.classList.add(...(e.clickableClass || "").split(" ")),
                    s.classList.add(e.modifierClass + e.type),
                    s.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                    "bullets" === e.type && e.dynamicBullets && (s.classList.add(`${e.modifierClass}${e.type}-dynamic`),
                    o = 0,
                    e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                    "progressbar" === e.type && e.progressbarOpposite && s.classList.add(e.progressbarOppositeClass),
                    e.clickable && s.addEventListener("click", u),
                    t.enabled || s.classList.add(e.lockClass)
                }
                )))
            }
            function f() {
                const e = t.params.pagination;
                if (c())
                    return;
                let s = t.pagination.el;
                s && (s = l(s),
                s.forEach((s => {
                    s.classList.remove(e.hiddenClass),
                    s.classList.remove(e.modifierClass + e.type),
                    s.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                    e.clickable && (s.classList.remove(...(e.clickableClass || "").split(" ")),
                    s.removeEventListener("click", u))
                }
                ))),
                t.pagination.bullets && t.pagination.bullets.forEach((t => t.classList.remove(...e.bulletActiveClass.split(" "))))
            }
            i("changeDirection", ( () => {
                if (!t.pagination || !t.pagination.el)
                    return;
                const e = t.params.pagination;
                let {el: s} = t.pagination;
                s = l(s),
                s.forEach((s => {
                    s.classList.remove(e.horizontalClass, e.verticalClass),
                    s.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass)
                }
                ))
            }
            )),
            i("init", ( () => {
                !1 === t.params.pagination.enabled ? g() : (m(),
                h(),
                p())
            }
            )),
            i("activeIndexChange", ( () => {
                void 0 === t.snapIndex && p()
            }
            )),
            i("snapIndexChange", ( () => {
                p()
            }
            )),
            i("snapGridLengthChange", ( () => {
                h(),
                p()
            }
            )),
            i("destroy", ( () => {
                f()
            }
            )),
            i("enable disable", ( () => {
                let {el: e} = t.pagination;
                e && (e = l(e),
                e.forEach((e => e.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass))))
            }
            )),
            i("lock unlock", ( () => {
                p()
            }
            )),
            i("click", ( (e, s) => {
                const i = s.target
                  , a = l(t.pagination.el);
                if (t.params.pagination.el && t.params.pagination.hideOnClick && a && a.length > 0 && !i.classList.contains(t.params.pagination.bulletClass)) {
                    if (t.navigation && (t.navigation.nextEl && i === t.navigation.nextEl || t.navigation.prevEl && i === t.navigation.prevEl))
                        return;
                    const e = a[0].classList.contains(t.params.pagination.hiddenClass);
                    n(!0 === e ? "paginationShow" : "paginationHide"),
                    a.forEach((e => e.classList.toggle(t.params.pagination.hiddenClass)))
                }
            }
            ));
            const g = () => {
                t.el.classList.add(t.params.pagination.paginationDisabledClass);
                let {el: e} = t.pagination;
                e && (e = l(e),
                e.forEach((e => e.classList.add(t.params.pagination.paginationDisabledClass)))),
                f()
            }
            ;
            Object.assign(t.pagination, {
                enable: () => {
                    t.el.classList.remove(t.params.pagination.paginationDisabledClass);
                    let {el: e} = t.pagination;
                    e && (e = l(e),
                    e.forEach((e => e.classList.remove(t.params.pagination.paginationDisabledClass)))),
                    m(),
                    h(),
                    p()
                }
                ,
                disable: g,
                render: h,
                update: p,
                init: m,
                destroy: f
            })
        }
        function fs(e) {
            let {swiper: t, extendParams: s, on: i} = e;
            function n(e, t) {
                const s = function() {
                    let e, t, s;
                    return (i, n) => {
                        for (t = -1,
                        e = i.length; e - t > 1; )
                            s = e + t >> 1,
                            i[s] <= n ? t = s : e = s;
                        return e
                    }
                }();
                let i, n;
                return this.x = e,
                this.y = t,
                this.lastIndex = e.length - 1,
                this.interpolate = function(e) {
                    return e ? (n = s(this.x, e),
                    i = n - 1,
                    (e - this.x[i]) * (this.y[n] - this.y[i]) / (this.x[n] - this.x[i]) + this.y[i]) : 0
                }
                ,
                this
            }
            function a() {
                t.controller.control && t.controller.spline && (t.controller.spline = void 0,
                delete t.controller.spline)
            }
            s({
                controller: {
                    control: void 0,
                    inverse: !1,
                    by: "slide"
                }
            }),
            t.controller = {
                control: void 0
            },
            i("beforeInit", ( () => {
                if ("undefined" != typeof window && ("string" == typeof t.params.controller.control || t.params.controller.control instanceof HTMLElement)) {
                    const e = document.querySelector(t.params.controller.control);
                    if (e && e.swiper)
                        t.controller.control = e.swiper;
                    else if (e) {
                        const s = i => {
                            t.controller.control = i.detail[0],
                            t.update(),
                            e.removeEventListener("init", s)
                        }
                        ;
                        e.addEventListener("init", s)
                    }
                } else
                    t.controller.control = t.params.controller.control
            }
            )),
            i("update", ( () => {
                a()
            }
            )),
            i("resize", ( () => {
                a()
            }
            )),
            i("observerUpdate", ( () => {
                a()
            }
            )),
            i("setTranslate", ( (e, s, i) => {
                t.controller.control && !t.controller.control.destroyed && t.controller.setTranslate(s, i)
            }
            )),
            i("setTransition", ( (e, s, i) => {
                t.controller.control && !t.controller.control.destroyed && t.controller.setTransition(s, i)
            }
            )),
            Object.assign(t.controller, {
                setTranslate: function(e, s) {
                    const i = t.controller.control;
                    let a, r;
                    const o = t.constructor;
                    function l(e) {
                        if (e.destroyed)
                            return;
                        const s = t.rtlTranslate ? -t.translate : t.translate;
                        "slide" === t.params.controller.by && (!function(e) {
                            t.controller.spline = t.params.loop ? new n(t.slidesGrid,e.slidesGrid) : new n(t.snapGrid,e.snapGrid)
                        }(e),
                        r = -t.controller.spline.interpolate(-s)),
                        r && "container" !== t.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate()),
                        !Number.isNaN(a) && Number.isFinite(a) || (a = 1),
                        r = (s - t.minTranslate()) * a + e.minTranslate()),
                        t.params.controller.inverse && (r = e.maxTranslate() - r),
                        e.updateProgress(r),
                        e.setTranslate(r, t),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses()
                    }
                    if (Array.isArray(i))
                        for (let e = 0; e < i.length; e += 1)
                            i[e] !== s && i[e]instanceof o && l(i[e]);
                    else
                        i instanceof o && s !== i && l(i)
                },
                setTransition: function(e, s) {
                    const i = t.constructor
                      , n = t.controller.control;
                    let a;
                    function r(s) {
                        s.destroyed || (s.setTransition(e, t),
                        0 !== e && (s.transitionStart(),
                        s.params.autoHeight && vt(( () => {
                            s.updateAutoHeight()
                        }
                        )),
                        Mt(s.wrapperEl, ( () => {
                            n && s.transitionEnd()
                        }
                        ))))
                    }
                    if (Array.isArray(n))
                        for (a = 0; a < n.length; a += 1)
                            n[a] !== s && n[a]instanceof i && r(n[a]);
                    else
                        n instanceof i && s !== n && r(n)
                }
            })
        }
        function gs(e) {
            let {swiper: t, extendParams: s, on: i} = e;
            s({
                a11y: {
                    enabled: !0,
                    notificationClass: "swiper-notification",
                    prevSlideMessage: "Previous slide",
                    nextSlideMessage: "Next slide",
                    firstSlideMessage: "This is the first slide",
                    lastSlideMessage: "This is the last slide",
                    paginationBulletMessage: "Go to slide {{index}}",
                    slideLabelMessage: "{{index}} / {{slidesLength}}",
                    containerMessage: null,
                    containerRoleDescriptionMessage: null,
                    itemRoleDescriptionMessage: null,
                    slideRole: "group",
                    id: null
                }
            }),
            t.a11y = {
                clicked: !1
            };
            let n = null;
            function a(e) {
                const t = n;
                0 !== t.length && (t.innerHTML = "",
                t.innerHTML = e)
            }
            const r = e => (Array.isArray(e) ? e : [e]).filter((e => !!e));
            function o(e) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("tabIndex", "0")
                }
                ))
            }
            function l(e) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("tabIndex", "-1")
                }
                ))
            }
            function c(e, t) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("role", t)
                }
                ))
            }
            function d(e, t) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("aria-roledescription", t)
                }
                ))
            }
            function u(e, t) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("aria-label", t)
                }
                ))
            }
            function p(e) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("aria-disabled", !0)
                }
                ))
            }
            function h(e) {
                (e = r(e)).forEach((e => {
                    e.setAttribute("aria-disabled", !1)
                }
                ))
            }
            function m(e) {
                if (13 !== e.keyCode && 32 !== e.keyCode)
                    return;
                const s = t.params.a11y
                  , i = e.target;
                t.pagination && t.pagination.el && (i === t.pagination.el || t.pagination.el.contains(e.target)) && !e.target.matches(hs(t.params.pagination.bulletClass)) || (t.navigation && t.navigation.nextEl && i === t.navigation.nextEl && (t.isEnd && !t.params.loop || t.slideNext(),
                t.isEnd ? a(s.lastSlideMessage) : a(s.nextSlideMessage)),
                t.navigation && t.navigation.prevEl && i === t.navigation.prevEl && (t.isBeginning && !t.params.loop || t.slidePrev(),
                t.isBeginning ? a(s.firstSlideMessage) : a(s.prevSlideMessage)),
                t.pagination && i.matches(hs(t.params.pagination.bulletClass)) && i.click())
            }
            function f() {
                return t.pagination && t.pagination.bullets && t.pagination.bullets.length
            }
            function g() {
                return f() && t.params.pagination.clickable
            }
            const v = (e, t, s) => {
                o(e),
                "BUTTON" !== e.tagName && (c(e, "button"),
                e.addEventListener("keydown", m)),
                u(e, s),
                function(e, t) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("aria-controls", t)
                    }
                    ))
                }(e, t)
            }
              , y = () => {
                t.a11y.clicked = !0
            }
              , b = () => {
                requestAnimationFrame(( () => {
                    requestAnimationFrame(( () => {
                        t.destroyed || (t.a11y.clicked = !1)
                    }
                    ))
                }
                ))
            }
              , w = e => {
                if (t.a11y.clicked)
                    return;
                const s = e.target.closest(`.${t.params.slideClass}, swiper-slide`);
                if (!s || !t.slides.includes(s))
                    return;
                const i = t.slides.indexOf(s) === t.activeIndex
                  , n = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(s);
                i || n || e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0,
                t.slideTo(t.slides.indexOf(s), 0))
            }
              , S = () => {
                const e = t.params.a11y;
                e.itemRoleDescriptionMessage && d(t.slides, e.itemRoleDescriptionMessage),
                e.slideRole && c(t.slides, e.slideRole);
                const s = t.slides.length;
                e.slideLabelMessage && t.slides.forEach(( (i, n) => {
                    const a = t.params.loop ? parseInt(i.getAttribute("data-swiper-slide-index"), 10) : n;
                    u(i, e.slideLabelMessage.replace(/\{\{index\}\}/, a + 1).replace(/\{\{slidesLength\}\}/, s))
                }
                ))
            }
              , E = () => {
                const e = t.params.a11y;
                t.el.append(n);
                const s = t.el;
                e.containerRoleDescriptionMessage && d(s, e.containerRoleDescriptionMessage),
                e.containerMessage && u(s, e.containerMessage);
                const i = t.wrapperEl
                  , a = e.id || i.getAttribute("id") || `swiper-wrapper-${o = 16,
                void 0 === o && (o = 16),
                "x".repeat(o).replace(/x/g, ( () => Math.round(16 * Math.random()).toString(16)))}`;
                var o;
                const l = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
                var c;
                c = a,
                r(i).forEach((e => {
                    e.setAttribute("id", c)
                }
                )),
                function(e, t) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("aria-live", t)
                    }
                    ))
                }(i, l),
                S();
                let {nextEl: p, prevEl: h} = t.navigation ? t.navigation : {};
                if (p = r(p),
                h = r(h),
                p && p.forEach((t => v(t, a, e.nextSlideMessage))),
                h && h.forEach((t => v(t, a, e.prevSlideMessage))),
                g()) {
                    (Array.isArray(t.pagination.el) ? t.pagination.el : [t.pagination.el]).forEach((e => {
                        e.addEventListener("keydown", m)
                    }
                    ))
                }
                t.el.addEventListener("focus", w, !0),
                t.el.addEventListener("pointerdown", y, !0),
                t.el.addEventListener("pointerup", b, !0)
            }
            ;
            i("beforeInit", ( () => {
                n = At("span", t.params.a11y.notificationClass),
                n.setAttribute("aria-live", "assertive"),
                n.setAttribute("aria-atomic", "true")
            }
            )),
            i("afterInit", ( () => {
                t.params.a11y.enabled && E()
            }
            )),
            i("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ( () => {
                t.params.a11y.enabled && S()
            }
            )),
            i("fromEdge toEdge afterInit lock unlock", ( () => {
                t.params.a11y.enabled && function() {
                    if (t.params.loop || t.params.rewind || !t.navigation)
                        return;
                    const {nextEl: e, prevEl: s} = t.navigation;
                    s && (t.isBeginning ? (p(s),
                    l(s)) : (h(s),
                    o(s))),
                    e && (t.isEnd ? (p(e),
                    l(e)) : (h(e),
                    o(e)))
                }()
            }
            )),
            i("paginationUpdate", ( () => {
                t.params.a11y.enabled && function() {
                    const e = t.params.a11y;
                    f() && t.pagination.bullets.forEach((s => {
                        t.params.pagination.clickable && (o(s),
                        t.params.pagination.renderBullet || (c(s, "button"),
                        u(s, e.paginationBulletMessage.replace(/\{\{index\}\}/, kt(s) + 1)))),
                        s.matches(hs(t.params.pagination.bulletActiveClass)) ? s.setAttribute("aria-current", "true") : s.removeAttribute("aria-current")
                    }
                    ))
                }()
            }
            )),
            i("destroy", ( () => {
                t.params.a11y.enabled && function() {
                    n && n.remove();
                    let {nextEl: e, prevEl: s} = t.navigation ? t.navigation : {};
                    e = r(e),
                    s = r(s),
                    e && e.forEach((e => e.removeEventListener("keydown", m))),
                    s && s.forEach((e => e.removeEventListener("keydown", m))),
                    g() && (Array.isArray(t.pagination.el) ? t.pagination.el : [t.pagination.el]).forEach((e => {
                        e.removeEventListener("keydown", m)
                    }
                    ));
                    t.el.removeEventListener("focus", w, !0),
                    t.el.removeEventListener("pointerdown", y, !0),
                    t.el.removeEventListener("pointerup", b, !0)
                }()
            }
            ))
        }
        function vs(e) {
            let t, s, {swiper: i, extendParams: n, on: a, emit: r, params: o} = e;
            i.autoplay = {
                running: !1,
                paused: !1,
                timeLeft: 0
            },
            n({
                autoplay: {
                    enabled: !1,
                    delay: 3e3,
                    waitForTransition: !0,
                    disableOnInteraction: !0,
                    stopOnLastSlide: !1,
                    reverseDirection: !1,
                    pauseOnMouseEnter: !1
                }
            });
            let l, c, d, u, p, h, m, f = o && o.autoplay ? o.autoplay.delay : 3e3, g = o && o.autoplay ? o.autoplay.delay : 3e3, v = (new Date).getTime;
            function y(e) {
                i && !i.destroyed && i.wrapperEl && e.target === i.wrapperEl && (i.wrapperEl.removeEventListener("transitionend", y),
                T())
            }
            const b = () => {
                if (i.destroyed || !i.autoplay.running)
                    return;
                i.autoplay.paused ? c = !0 : c && (g = l,
                c = !1);
                const e = i.autoplay.paused ? l : v + g - (new Date).getTime();
                i.autoplay.timeLeft = e,
                r("autoplayTimeLeft", e, e / f),
                s = requestAnimationFrame(( () => {
                    b()
                }
                ))
            }
              , w = e => {
                if (i.destroyed || !i.autoplay.running)
                    return;
                cancelAnimationFrame(s),
                b();
                let n = void 0 === e ? i.params.autoplay.delay : e;
                f = i.params.autoplay.delay,
                g = i.params.autoplay.delay;
                const a = ( () => {
                    let e;
                    if (e = i.virtual && i.params.virtual.enabled ? i.slides.filter((e => e.classList.contains("swiper-slide-active")))[0] : i.slides[i.activeIndex],
                    !e)
                        return;
                    return parseInt(e.getAttribute("data-swiper-autoplay"), 10)
                }
                )();
                !Number.isNaN(a) && a > 0 && void 0 === e && (n = a,
                f = a,
                g = a),
                l = n;
                const o = i.params.speed
                  , c = () => {
                    i && !i.destroyed && (i.params.autoplay.reverseDirection ? !i.isBeginning || i.params.loop || i.params.rewind ? (i.slidePrev(o, !0, !0),
                    r("autoplay")) : i.params.autoplay.stopOnLastSlide || (i.slideTo(i.slides.length - 1, o, !0, !0),
                    r("autoplay")) : !i.isEnd || i.params.loop || i.params.rewind ? (i.slideNext(o, !0, !0),
                    r("autoplay")) : i.params.autoplay.stopOnLastSlide || (i.slideTo(0, o, !0, !0),
                    r("autoplay")),
                    i.params.cssMode && (v = (new Date).getTime(),
                    requestAnimationFrame(( () => {
                        w()
                    }
                    ))))
                }
                ;
                return n > 0 ? (clearTimeout(t),
                t = setTimeout(( () => {
                    c()
                }
                ), n)) : requestAnimationFrame(( () => {
                    c()
                }
                )),
                n
            }
              , S = () => {
                i.autoplay.running = !0,
                w(),
                r("autoplayStart")
            }
              , E = () => {
                i.autoplay.running = !1,
                clearTimeout(t),
                cancelAnimationFrame(s),
                r("autoplayStop")
            }
              , x = (e, s) => {
                if (i.destroyed || !i.autoplay.running)
                    return;
                clearTimeout(t),
                e || (m = !0);
                const n = () => {
                    r("autoplayPause"),
                    i.params.autoplay.waitForTransition ? i.wrapperEl.addEventListener("transitionend", y) : T()
                }
                ;
                if (i.autoplay.paused = !0,
                s)
                    return h && (l = i.params.autoplay.delay),
                    h = !1,
                    void n();
                const a = l || i.params.autoplay.delay;
                l = a - ((new Date).getTime() - v),
                i.isEnd && l < 0 && !i.params.loop || (l < 0 && (l = 0),
                n())
            }
              , T = () => {
                i.isEnd && l < 0 && !i.params.loop || i.destroyed || !i.autoplay.running || (v = (new Date).getTime(),
                m ? (m = !1,
                w(l)) : w(),
                i.autoplay.paused = !1,
                r("autoplayResume"))
            }
              , L = () => {
                if (i.destroyed || !i.autoplay.running)
                    return;
                const e = mt();
                "hidden" === e.visibilityState && (m = !0,
                x(!0)),
                "visible" === e.visibilityState && T()
            }
              , A = e => {
                "mouse" === e.pointerType && (m = !0,
                i.animating || i.autoplay.paused || x(!0))
            }
              , C = e => {
                "mouse" === e.pointerType && i.autoplay.paused && T()
            }
            ;
            a("init", ( () => {
                i.params.autoplay.enabled && (i.params.autoplay.pauseOnMouseEnter && (i.el.addEventListener("pointerenter", A),
                i.el.addEventListener("pointerleave", C)),
                mt().addEventListener("visibilitychange", L),
                v = (new Date).getTime(),
                S())
            }
            )),
            a("destroy", ( () => {
                i.el.removeEventListener("pointerenter", A),
                i.el.removeEventListener("pointerleave", C),
                mt().removeEventListener("visibilitychange", L),
                i.autoplay.running && E()
            }
            )),
            a("beforeTransitionStart", ( (e, t, s) => {
                !i.destroyed && i.autoplay.running && (s || !i.params.autoplay.disableOnInteraction ? x(!0, !0) : E())
            }
            )),
            a("sliderFirstMove", ( () => {
                !i.destroyed && i.autoplay.running && (i.params.autoplay.disableOnInteraction ? E() : (d = !0,
                u = !1,
                m = !1,
                p = setTimeout(( () => {
                    m = !0,
                    u = !0,
                    x(!0)
                }
                ), 200)))
            }
            )),
            a("touchEnd", ( () => {
                if (!i.destroyed && i.autoplay.running && d) {
                    if (clearTimeout(p),
                    clearTimeout(t),
                    i.params.autoplay.disableOnInteraction)
                        return u = !1,
                        void (d = !1);
                    u && i.params.cssMode && T(),
                    u = !1,
                    d = !1
                }
            }
            )),
            a("slideChange", ( () => {
                !i.destroyed && i.autoplay.running && (h = !0)
            }
            )),
            Object.assign(i.autoplay, {
                start: S,
                stop: E,
                pause: x,
                resume: T
            })
        }
        function ys(e) {
            let {swiper: t, extendParams: s, on: i} = e;
            s({
                thumbs: {
                    swiper: null,
                    multipleActiveThumbs: !0,
                    autoScrollOffset: 0,
                    slideThumbActiveClass: "swiper-slide-thumb-active",
                    thumbsContainerClass: "swiper-thumbs"
                }
            });
            let n = !1
              , a = !1;
            function r() {
                const e = t.thumbs.swiper;
                if (!e || e.destroyed)
                    return;
                const s = e.clickedIndex
                  , i = e.clickedSlide;
                if (i && i.classList.contains(t.params.thumbs.slideThumbActiveClass))
                    return;
                if (null == s)
                    return;
                let n;
                n = e.params.loop ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : s,
                t.params.loop ? t.slideToLoop(n) : t.slideTo(n)
            }
            function o() {
                const {thumbs: e} = t.params;
                if (n)
                    return !1;
                n = !0;
                const s = t.constructor;
                if (e.swiper instanceof s)
                    t.thumbs.swiper = e.swiper,
                    Object.assign(t.thumbs.swiper.originalParams, {
                        watchSlidesProgress: !0,
                        slideToClickedSlide: !1
                    }),
                    Object.assign(t.thumbs.swiper.params, {
                        watchSlidesProgress: !0,
                        slideToClickedSlide: !1
                    }),
                    t.thumbs.swiper.update();
                else if (wt(e.swiper)) {
                    const i = Object.assign({}, e.swiper);
                    Object.assign(i, {
                        watchSlidesProgress: !0,
                        slideToClickedSlide: !1
                    }),
                    t.thumbs.swiper = new s(i),
                    a = !0
                }
                return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),
                t.thumbs.swiper.on("tap", r),
                !0
            }
            function l(e) {
                const s = t.thumbs.swiper;
                if (!s || s.destroyed)
                    return;
                const i = "auto" === s.params.slidesPerView ? s.slidesPerViewDynamic() : s.params.slidesPerView;
                let n = 1;
                const a = t.params.thumbs.slideThumbActiveClass;
                if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (n = t.params.slidesPerView),
                t.params.thumbs.multipleActiveThumbs || (n = 1),
                n = Math.floor(n),
                s.slides.forEach((e => e.classList.remove(a))),
                s.params.loop || s.params.virtual && s.params.virtual.enabled)
                    for (let e = 0; e < n; e += 1)
                        Lt(s.slidesEl, `[data-swiper-slide-index="${t.realIndex + e}"]`).forEach((e => {
                            e.classList.add(a)
                        }
                        ));
                else
                    for (let e = 0; e < n; e += 1)
                        s.slides[t.realIndex + e] && s.slides[t.realIndex + e].classList.add(a);
                const r = t.params.thumbs.autoScrollOffset
                  , o = r && !s.params.loop;
                if (t.realIndex !== s.realIndex || o) {
                    const n = s.activeIndex;
                    let a, l;
                    if (s.params.loop) {
                        const e = s.slides.filter((e => e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`))[0];
                        a = s.slides.indexOf(e),
                        l = t.activeIndex > t.previousIndex ? "next" : "prev"
                    } else
                        a = t.realIndex,
                        l = a > t.previousIndex ? "next" : "prev";
                    o && (a += "next" === l ? r : -1 * r),
                    s.visibleSlidesIndexes && s.visibleSlidesIndexes.indexOf(a) < 0 && (s.params.centeredSlides ? a = a > n ? a - Math.floor(i / 2) + 1 : a + Math.floor(i / 2) - 1 : a > n && s.params.slidesPerGroup,
                    s.slideTo(a, e ? 0 : void 0))
                }
            }
            t.thumbs = {
                swiper: null
            },
            i("beforeInit", ( () => {
                const {thumbs: e} = t.params;
                if (e && e.swiper)
                    if ("string" == typeof e.swiper || e.swiper instanceof HTMLElement) {
                        const s = mt()
                          , i = () => {
                            const i = "string" == typeof e.swiper ? s.querySelector(e.swiper) : e.swiper;
                            if (i && i.swiper)
                                e.swiper = i.swiper,
                                o(),
                                l(!0);
                            else if (i) {
                                const s = n => {
                                    e.swiper = n.detail[0],
                                    i.removeEventListener("init", s),
                                    o(),
                                    l(!0),
                                    e.swiper.update(),
                                    t.update()
                                }
                                ;
                                i.addEventListener("init", s)
                            }
                            return i
                        }
                          , n = () => {
                            if (t.destroyed)
                                return;
                            i() || requestAnimationFrame(n)
                        }
                        ;
                        requestAnimationFrame(n)
                    } else
                        o(),
                        l(!0)
            }
            )),
            i("slideChange update resize observerUpdate", ( () => {
                l()
            }
            )),
            i("setTransition", ( (e, s) => {
                const i = t.thumbs.swiper;
                i && !i.destroyed && i.setTransition(s)
            }
            )),
            i("beforeDestroy", ( () => {
                const e = t.thumbs.swiper;
                e && !e.destroyed && a && e.destroy()
            }
            )),
            Object.assign(t.thumbs, {
                init: o,
                update: l
            })
        }
        function bs(e) {
            let {swiper: t, extendParams: s, emit: i, once: n} = e;
            s({
                freeMode: {
                    enabled: !1,
                    momentum: !0,
                    momentumRatio: 1,
                    momentumBounce: !0,
                    momentumBounceRatio: 1,
                    momentumVelocityRatio: 1,
                    sticky: !1,
                    minimumVelocity: .02
                }
            }),
            Object.assign(t, {
                freeMode: {
                    onTouchStart: function() {
                        if (t.params.cssMode)
                            return;
                        const e = t.getTranslate();
                        t.setTranslate(e),
                        t.setTransition(0),
                        t.touchEventsData.velocities.length = 0,
                        t.freeMode.onTouchEnd({
                            currentPos: t.rtl ? t.translate : -t.translate
                        })
                    },
                    onTouchMove: function() {
                        if (t.params.cssMode)
                            return;
                        const {touchEventsData: e, touches: s} = t;
                        0 === e.velocities.length && e.velocities.push({
                            position: s[t.isHorizontal() ? "startX" : "startY"],
                            time: e.touchStartTime
                        }),
                        e.velocities.push({
                            position: s[t.isHorizontal() ? "currentX" : "currentY"],
                            time: yt()
                        })
                    },
                    onTouchEnd: function(e) {
                        let {currentPos: s} = e;
                        if (t.params.cssMode)
                            return;
                        const {params: a, wrapperEl: r, rtlTranslate: o, snapGrid: l, touchEventsData: c} = t
                          , d = yt() - c.touchStartTime;
                        if (s < -t.minTranslate())
                            t.slideTo(t.activeIndex);
                        else if (s > -t.maxTranslate())
                            t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1);
                        else {
                            if (a.freeMode.momentum) {
                                if (c.velocities.length > 1) {
                                    const e = c.velocities.pop()
                                      , s = c.velocities.pop()
                                      , i = e.position - s.position
                                      , n = e.time - s.time;
                                    t.velocity = i / n,
                                    t.velocity /= 2,
                                    Math.abs(t.velocity) < a.freeMode.minimumVelocity && (t.velocity = 0),
                                    (n > 150 || yt() - e.time > 300) && (t.velocity = 0)
                                } else
                                    t.velocity = 0;
                                t.velocity *= a.freeMode.momentumVelocityRatio,
                                c.velocities.length = 0;
                                let e = 1e3 * a.freeMode.momentumRatio;
                                const s = t.velocity * e;
                                let d = t.translate + s;
                                o && (d = -d);
                                let u, p = !1;
                                const h = 20 * Math.abs(t.velocity) * a.freeMode.momentumBounceRatio;
                                let m;
                                if (d < t.maxTranslate())
                                    a.freeMode.momentumBounce ? (d + t.maxTranslate() < -h && (d = t.maxTranslate() - h),
                                    u = t.maxTranslate(),
                                    p = !0,
                                    c.allowMomentumBounce = !0) : d = t.maxTranslate(),
                                    a.loop && a.centeredSlides && (m = !0);
                                else if (d > t.minTranslate())
                                    a.freeMode.momentumBounce ? (d - t.minTranslate() > h && (d = t.minTranslate() + h),
                                    u = t.minTranslate(),
                                    p = !0,
                                    c.allowMomentumBounce = !0) : d = t.minTranslate(),
                                    a.loop && a.centeredSlides && (m = !0);
                                else if (a.freeMode.sticky) {
                                    let e;
                                    for (let t = 0; t < l.length; t += 1)
                                        if (l[t] > -d) {
                                            e = t;
                                            break
                                        }
                                    d = Math.abs(l[e] - d) < Math.abs(l[e - 1] - d) || "next" === t.swipeDirection ? l[e] : l[e - 1],
                                    d = -d
                                }
                                if (m && n("transitionEnd", ( () => {
                                    t.loopFix()
                                }
                                )),
                                0 !== t.velocity) {
                                    if (e = o ? Math.abs((-d - t.translate) / t.velocity) : Math.abs((d - t.translate) / t.velocity),
                                    a.freeMode.sticky) {
                                        const s = Math.abs((o ? -d : d) - t.translate)
                                          , i = t.slidesSizesGrid[t.activeIndex];
                                        e = s < i ? a.speed : s < 2 * i ? 1.5 * a.speed : 2.5 * a.speed
                                    }
                                } else if (a.freeMode.sticky)
                                    return void t.slideToClosest();
                                a.freeMode.momentumBounce && p ? (t.updateProgress(u),
                                t.setTransition(e),
                                t.setTranslate(d),
                                t.transitionStart(!0, t.swipeDirection),
                                t.animating = !0,
                                Mt(r, ( () => {
                                    t && !t.destroyed && c.allowMomentumBounce && (i("momentumBounce"),
                                    t.setTransition(a.speed),
                                    setTimeout(( () => {
                                        t.setTranslate(u),
                                        Mt(r, ( () => {
                                            t && !t.destroyed && t.transitionEnd()
                                        }
                                        ))
                                    }
                                    ), 0))
                                }
                                ))) : t.velocity ? (i("_freeModeNoMomentumRelease"),
                                t.updateProgress(d),
                                t.setTransition(e),
                                t.setTranslate(d),
                                t.transitionStart(!0, t.swipeDirection),
                                t.animating || (t.animating = !0,
                                Mt(r, ( () => {
                                    t && !t.destroyed && t.transitionEnd()
                                }
                                )))) : t.updateProgress(d),
                                t.updateActiveIndex(),
                                t.updateSlidesClasses()
                            } else {
                                if (a.freeMode.sticky)
                                    return void t.slideToClosest();
                                a.freeMode && i("_freeModeNoMomentumRelease")
                            }
                            (!a.freeMode.momentum || d >= a.longSwipesMs) && (t.updateProgress(),
                            t.updateActiveIndex(),
                            t.updateSlidesClasses())
                        }
                    }
                }
            })
        }
        function ws(e, t) {
            const s = Tt(t);
            return s !== t && (s.style.backfaceVisibility = "hidden",
            s.style["-webkit-backface-visibility"] = "hidden"),
            s
        }
        function Ss(e) {
            let {swiper: t, duration: s, transformElements: i, allSlides: n} = e;
            const {activeIndex: a} = t;
            if (t.params.virtualTranslate && 0 !== s) {
                let e, s = !1;
                e = n ? i : i.filter((e => {
                    const s = e.classList.contains("swiper-slide-transform") ? (e => {
                        if (!e.parentElement)
                            return t.slides.filter((t => t.shadowRoot && t.shadowRoot === e.parentNode))[0];
                        return e.parentElement
                    }
                    )(e) : e;
                    return t.getSlideIndex(s) === a
                }
                )),
                e.forEach((e => {
                    Mt(e, ( () => {
                        if (s)
                            return;
                        if (!t || t.destroyed)
                            return;
                        s = !0,
                        t.animating = !1;
                        const e = new window.CustomEvent("transitionend",{
                            bubbles: !0,
                            cancelable: !0
                        });
                        t.wrapperEl.dispatchEvent(e)
                    }
                    ))
                }
                ))
            }
        }
        function Es(e) {
            let {swiper: t, extendParams: s, on: i} = e;
            s({
                fadeEffect: {
                    crossFade: !1
                }
            });
            !function(e) {
                const {effect: t, swiper: s, on: i, setTranslate: n, setTransition: a, overwriteParams: r, perspective: o, recreateShadows: l, getEffectParams: c} = e;
                let d;
                i("beforeInit", ( () => {
                    if (s.params.effect !== t)
                        return;
                    s.classNames.push(`${s.params.containerModifierClass}${t}`),
                    o && o() && s.classNames.push(`${s.params.containerModifierClass}3d`);
                    const e = r ? r() : {};
                    Object.assign(s.params, e),
                    Object.assign(s.originalParams, e)
                }
                )),
                i("setTranslate", ( () => {
                    s.params.effect === t && n()
                }
                )),
                i("setTransition", ( (e, i) => {
                    s.params.effect === t && a(i)
                }
                )),
                i("transitionEnd", ( () => {
                    if (s.params.effect === t && l) {
                        if (!c || !c().slideShadows)
                            return;
                        s.slides.forEach((e => {
                            e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e => e.remove()))
                        }
                        )),
                        l()
                    }
                }
                )),
                i("virtualUpdate", ( () => {
                    s.params.effect === t && (s.slides.length || (d = !0),
                    requestAnimationFrame(( () => {
                        d && s.slides && s.slides.length && (n(),
                        d = !1)
                    }
                    )))
                }
                ))
            }({
                effect: "fade",
                swiper: t,
                on: i,
                setTranslate: () => {
                    const {slides: e} = t;
                    t.params.fadeEffect;
                    for (let s = 0; s < e.length; s += 1) {
                        const e = t.slides[s];
                        let i = -e.swiperSlideOffset;
                        t.params.virtualTranslate || (i -= t.translate);
                        let n = 0;
                        t.isHorizontal() || (n = i,
                        i = 0);
                        const a = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e.progress), 0) : 1 + Math.min(Math.max(e.progress, -1), 0)
                          , r = ws(0, e);
                        r.style.opacity = a,
                        r.style.transform = `translate3d(${i}px, ${n}px, 0px)`
                    }
                }
                ,
                setTransition: e => {
                    const s = t.slides.map((e => Tt(e)));
                    s.forEach((t => {
                        t.style.transitionDuration = `${e}ms`
                    }
                    )),
                    Ss({
                        swiper: t,
                        duration: e,
                        transformElements: s,
                        allSlides: !0
                    })
                }
                ,
                overwriteParams: () => ({
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    spaceBetween: 0,
                    virtualTranslate: !t.params.cssMode
                })
            })
        }
        Object.keys(os).forEach((e => {
            Object.keys(os[e]).forEach((t => {
                cs.prototype[t] = os[e][t]
            }
            ))
        }
        )),
        cs.use([function(e) {
            let {swiper: t, on: s, emit: i} = e;
            const n = gt();
            let a = null
              , r = null;
            const o = () => {
                t && !t.destroyed && t.initialized && (i("beforeResize"),
                i("resize"))
            }
              , l = () => {
                t && !t.destroyed && t.initialized && i("orientationchange")
            }
            ;
            s("init", ( () => {
                t.params.resizeObserver && void 0 !== n.ResizeObserver ? t && !t.destroyed && t.initialized && (a = new ResizeObserver((e => {
                    r = n.requestAnimationFrame(( () => {
                        const {width: s, height: i} = t;
                        let n = s
                          , a = i;
                        e.forEach((e => {
                            let {contentBoxSize: s, contentRect: i, target: r} = e;
                            r && r !== t.el || (n = i ? i.width : (s[0] || s).inlineSize,
                            a = i ? i.height : (s[0] || s).blockSize)
                        }
                        )),
                        n === s && a === i || o()
                    }
                    ))
                }
                )),
                a.observe(t.el)) : (n.addEventListener("resize", o),
                n.addEventListener("orientationchange", l))
            }
            )),
            s("destroy", ( () => {
                r && n.cancelAnimationFrame(r),
                a && a.unobserve && t.el && (a.unobserve(t.el),
                a = null),
                n.removeEventListener("resize", o),
                n.removeEventListener("orientationchange", l)
            }
            ))
        }
        , function(e) {
            let {swiper: t, extendParams: s, on: i, emit: n} = e;
            const a = []
              , r = gt()
              , o = function(e, s) {
                void 0 === s && (s = {});
                const i = new (r.MutationObserver || r.WebkitMutationObserver)((e => {
                    if (t.__preventObserver__)
                        return;
                    if (1 === e.length)
                        return void n("observerUpdate", e[0]);
                    const s = function() {
                        n("observerUpdate", e[0])
                    };
                    r.requestAnimationFrame ? r.requestAnimationFrame(s) : r.setTimeout(s, 0)
                }
                ));
                i.observe(e, {
                    attributes: void 0 === s.attributes || s.attributes,
                    childList: void 0 === s.childList || s.childList,
                    characterData: void 0 === s.characterData || s.characterData
                }),
                a.push(i)
            };
            s({
                observer: !1,
                observeParents: !1,
                observeSlideChildren: !1
            }),
            i("init", ( () => {
                if (t.params.observer) {
                    if (t.params.observeParents) {
                        const e = qt(t.hostEl);
                        for (let t = 0; t < e.length; t += 1)
                            o(e[t])
                    }
                    o(t.hostEl, {
                        childList: t.params.observeSlideChildren
                    }),
                    o(t.wrapperEl, {
                        attributes: !1
                    })
                }
            }
            )),
            i("destroy", ( () => {
                a.forEach((e => {
                    e.disconnect()
                }
                )),
                a.splice(0, a.length)
            }
            ))
        }
        ]);
        var xs = s(311)
          , Ts = s.n(xs);
        if (null !== document.querySelector(".announcement-bar")) {
            new cs(".announcement-bar .swiper",{
                effect: "fade",
                loop: !0,
                autoplay: {
                    delay: 3500
                },
                fadeEffect: {
                    crossFade: !0
                },
                pauseOnMouseEnter: !1,
                modules: [Es, vs]
            }).on("slideChange", (function(e) {
                const t = document.querySelector("header").offsetHeight;
                document.documentElement.style.setProperty("--header-height", t + "px"),
                document.documentElement.style.setProperty("--mobile-header-height", t + "px")
            }
            ))
        }
        if (null !== document.querySelector(".hero .swiper") && document.querySelectorAll(".hero .swiper").forEach((e => {
            const t = {
                slidesPerView: 1,
                effect: "fade",
                speed: 600,
                autoplay: {
                    delay: 4500
                },
                fadeEffect: {
                    crossFade: !0
                },
                allowTouchMove: !0,
                pauseOnMouseEnter: !1,
                preventClicks: !1,
                preventClicksPropagation: !1,
                pagination: {
                    el: e.querySelector(".swiper-pagination"),
                    type: "bullets",
                    clickable: !0
                },
                A11y: {
                    enabled: !0
                },
                breakpoints: {
                    991: {
                        allowTouchMove: !1
                    }
                },
                modules: [Es, vs, ms, gs]
            };
            new cs(e,t)
        }
        )),
        null !== document.querySelector(".featured-products-details") && document.querySelectorAll(".featured-products-details").forEach((e => {
            const t = new cs(e.querySelector(".featured-products-details__content"),{
                effect: "fade",
                fadeEffect: {
                    crossFade: !0
                },
                allowTouchMove: !1,
                modules: [Es]
            });
            new cs(e.querySelector(".featured-products-details__prods"),{
                slidesPerView: 3,
                loop: !0,
                speed: 500,
                centeredSlides: !0,
                watchSlidesProgress: !0,
                allowTouchMove: !1,
                navigation: {
                    nextEl: e.querySelector(".swiper-next"),
                    prevEl: e.querySelector(".swiper-prev")
                },
                thumbs: {
                    swiper: t
                },
                modules: [ps, ys],
                breakpoints: {
                    991: {
                        allowTouchMove: !1
                    }
                },
                on: {
                    init: function(t) {
                        e.querySelectorAll(".featured-products-details__prods form").forEach((e => {
                            const t = e.querySelector(".featured-products-details__prods select");
                            let s = Math.floor(100 * Math.random())
                              , i = `${e.getAttribute("id")}${s}`;
                            if (e.setAttribute("id", i),
                            null !== t && t.id) {
                                let i = t.hasAttribute("data-position") ? t.getAttribute("data-position") : "auto";
                                t.id += s,
                                new (Ts())({
                                    select: `#${t.id}`,
                                    settings: {
                                        showSearch: !1,
                                        openPosition: i
                                    },
                                    events: {
                                        beforeOpen: () => {
                                            let s = e.querySelector(".card__content-form [aria-expanded='true']");
                                            if (null !== s) {
                                                let t = s.id;
                                                const i = e.querySelector(`[data-id="${t}"]`).id;
                                                document.querySelector(`.ss-content[data-id="${t}"]`).setAttribute("data-dropdown-id", i)
                                            }
                                            if (null !== document.querySelector(".card__content-form")) {
                                                document.getElementById(t.id).nextElementSibling.getAttribute("data-id");
                                                document.getElementById(t.id).closest(".card__content-form").classList.add("dropdown-open")
                                            }
                                        }
                                        ,
                                        afterChange: e => {
                                            const s = e[0];
                                            if (null !== document.querySelector(".card__content-form")) {
                                                "false" === (new DOMParser).parseFromString(s.html, "text/html").body.querySelector("[data-available]").getAttribute("data-available") ? (document.getElementById(t.id).closest(".card__content-form").querySelector(".button span").textContent = "Join the waitlist",
                                                document.getElementById(t.id).closest(".card__content-form").querySelector(".button span").style.marginRight = "20px",
                                                document.getElementById(t.id).closest(".card__content-form").querySelector(".button").onclick = e => {
                                                    e.preventDefault(),
                                                    window.openKlaviyoBISPopup(s.value, `${s.text}`)
                                                }
                                                ) : (document.getElementById(t.id).closest(".card__content-form").querySelector(".button span").textContent = "Add to cart",
                                                document.getElementById(t.id).closest(".card__content-form").querySelector(".button span").style.marginRight = "0px"

                                                ),
                                                document.querySelectorAll(".card__content-form").forEach((e => {
                                                    e.classList.remove("dropdown-open")
                                                }
                                                ))
                                            }
                                        }
                                        ,
                                        beforeClose: () => {
                                            null !== document.querySelector(".card__content-form") && document.querySelectorAll(".card__content-form").forEach((e => {
                                                e.classList.remove("dropdown-open")
                                            }
                                            ))
                                        }
                                    }
                                })
                            }
                        }
                        ))
                    }
                }
            })
        }
        )),
        null !== document.querySelector(".testimonials") && document.querySelectorAll(".testimonials").forEach((e => {
            new cs(e.querySelector(".swiper"),{
                slidesPerView: "auto",
                spaceBetween: 28,
                allowTouchMove: !0,
                navigation: {
                    nextEl: e.querySelector(".swiper-next")
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                modules: [ps, ms],
                breakpoints: {
                    991: {
                        allowTouchMove: !1
                    }
                }
            });
            const t = () => {
                let t = 0;
                e.querySelectorAll(".card__content").forEach((e => {
                    e.clientHeight > t && (t = e.clientHeight)
                }
                )),
                e.querySelectorAll(".card__content").forEach((e => {
                    e.style.minHeight = t + "px"
                }
                ))
            }
            ;
            t(),
            window.addEventListener("resize", t, {
                passive: !0
            })
        }
        )),
        null !== document.querySelector(".scroller-section")) {
            const Ti = {
                freeMode: !0,
                touchReleaseOnEdges: !0,
                mousewheel: {
                    forceToAxis: !0
                },
                scrollbar: {
                    el: document.querySelector(".scroller-section-list .swiper-scrollbar"),
                    draggable: !0
                },
                modules: [ds, bs, function(e) {
                    let {swiper: t, extendParams: s, on: i, emit: n} = e;
                    const a = mt();
                    let r, o, l, c, d = !1, u = null, p = null;
                    function h() {
                        if (!t.params.scrollbar.el || !t.scrollbar.el)
                            return;
                        const {scrollbar: e, rtlTranslate: s} = t
                          , {dragEl: i, el: n} = e
                          , a = t.params.scrollbar
                          , r = t.params.loop ? t.progressLoop : t.progress;
                        let c = o
                          , d = (l - o) * r;
                        s ? (d = -d,
                        d > 0 ? (c = o - d,
                        d = 0) : -d + o > l && (c = l + d)) : d < 0 ? (c = o + d,
                        d = 0) : d + o > l && (c = l - d),
                        t.isHorizontal() ? (i.style.transform = `translate3d(${d}px, 0, 0)`,
                        i.style.width = `${c}px`) : (i.style.transform = `translate3d(0px, ${d}px, 0)`,
                        i.style.height = `${c}px`),
                        a.hide && (clearTimeout(u),
                        n.style.opacity = 1,
                        u = setTimeout(( () => {
                            n.style.opacity = 0,
                            n.style.transitionDuration = "400ms"
                        }
                        ), 1e3))
                    }
                    function m() {
                        if (!t.params.scrollbar.el || !t.scrollbar.el)
                            return;
                        const {scrollbar: e} = t
                          , {dragEl: s, el: i} = e;
                        s.style.width = "",
                        s.style.height = "",
                        l = t.isHorizontal() ? i.offsetWidth : i.offsetHeight,
                        c = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0)),
                        o = "auto" === t.params.scrollbar.dragSize ? l * c : parseInt(t.params.scrollbar.dragSize, 10),
                        t.isHorizontal() ? s.style.width = `${o}px` : s.style.height = `${o}px`,
                        i.style.display = c >= 1 ? "none" : "",
                        t.params.scrollbar.hide && (i.style.opacity = 0),
                        t.params.watchOverflow && t.enabled && e.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass)
                    }
                    function f(e) {
                        return t.isHorizontal() ? e.clientX : e.clientY
                    }
                    function g(e) {
                        const {scrollbar: s, rtlTranslate: i} = t
                          , {el: n} = s;
                        let a;
                        a = (f(e) - function(e) {
                            const t = gt()
                              , s = mt()
                              , i = e.getBoundingClientRect()
                              , n = s.body
                              , a = e.clientTop || n.clientTop || 0
                              , r = e.clientLeft || n.clientLeft || 0
                              , o = e === t ? t.scrollY : e.scrollTop
                              , l = e === t ? t.scrollX : e.scrollLeft;
                            return {
                                top: i.top + o - a,
                                left: i.left + l - r
                            }
                        }(n)[t.isHorizontal() ? "left" : "top"] - (null !== r ? r : o / 2)) / (l - o),
                        a = Math.max(Math.min(a, 1), 0),
                        i && (a = 1 - a);
                        const c = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * a;
                        t.updateProgress(c),
                        t.setTranslate(c),
                        t.updateActiveIndex(),
                        t.updateSlidesClasses()
                    }
                    function v(e) {
                        const s = t.params.scrollbar
                          , {scrollbar: i, wrapperEl: a} = t
                          , {el: o, dragEl: l} = i;
                        d = !0,
                        r = e.target === l ? f(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null,
                        e.preventDefault(),
                        e.stopPropagation(),
                        a.style.transitionDuration = "100ms",
                        l.style.transitionDuration = "100ms",
                        g(e),
                        clearTimeout(p),
                        o.style.transitionDuration = "0ms",
                        s.hide && (o.style.opacity = 1),
                        t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
                        n("scrollbarDragStart", e)
                    }
                    function y(e) {
                        const {scrollbar: s, wrapperEl: i} = t
                          , {el: a, dragEl: r} = s;
                        d && (e.preventDefault ? e.preventDefault() : e.returnValue = !1,
                        g(e),
                        i.style.transitionDuration = "0ms",
                        a.style.transitionDuration = "0ms",
                        r.style.transitionDuration = "0ms",
                        n("scrollbarDragMove", e))
                    }
                    function b(e) {
                        const s = t.params.scrollbar
                          , {scrollbar: i, wrapperEl: a} = t
                          , {el: r} = i;
                        d && (d = !1,
                        t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "",
                        a.style.transitionDuration = ""),
                        s.hide && (clearTimeout(p),
                        p = vt(( () => {
                            r.style.opacity = 0,
                            r.style.transitionDuration = "400ms"
                        }
                        ), 1e3)),
                        n("scrollbarDragEnd", e),
                        s.snapOnRelease && t.slideToClosest())
                    }
                    function w(e) {
                        const {scrollbar: s, params: i} = t
                          , n = s.el;
                        if (!n)
                            return;
                        const r = n
                          , o = !!i.passiveListeners && {
                            passive: !1,
                            capture: !1
                        }
                          , l = !!i.passiveListeners && {
                            passive: !0,
                            capture: !1
                        };
                        if (!r)
                            return;
                        const c = "on" === e ? "addEventListener" : "removeEventListener";
                        r[c]("pointerdown", v, o),
                        a[c]("pointermove", y, o),
                        a[c]("pointerup", b, l)
                    }
                    function S() {
                        const {scrollbar: e, el: s} = t;
                        t.params.scrollbar = us(t, t.originalParams.scrollbar, t.params.scrollbar, {
                            el: "swiper-scrollbar"
                        });
                        const i = t.params.scrollbar;
                        if (!i.el)
                            return;
                        let n, r;
                        "string" == typeof i.el && t.isElement && (n = t.el.querySelector(i.el)),
                        n || "string" != typeof i.el ? n || (n = i.el) : n = a.querySelectorAll(i.el),
                        t.params.uniqueNavElements && "string" == typeof i.el && n.length > 1 && 1 === s.querySelectorAll(i.el).length && (n = s.querySelector(i.el)),
                        n.length > 0 && (n = n[0]),
                        n.classList.add(t.isHorizontal() ? i.horizontalClass : i.verticalClass),
                        n && (r = n.querySelector(`.${t.params.scrollbar.dragClass}`),
                        r || (r = At("div", t.params.scrollbar.dragClass),
                        n.append(r))),
                        Object.assign(e, {
                            el: n,
                            dragEl: r
                        }),
                        i.draggable && t.params.scrollbar.el && t.scrollbar.el && w("on"),
                        n && n.classList[t.enabled ? "remove" : "add"](t.params.scrollbar.lockClass)
                    }
                    function E() {
                        const e = t.params.scrollbar
                          , s = t.scrollbar.el;
                        s && s.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                        t.params.scrollbar.el && t.scrollbar.el && w("off")
                    }
                    s({
                        scrollbar: {
                            el: null,
                            dragSize: "auto",
                            hide: !1,
                            draggable: !1,
                            snapOnRelease: !0,
                            lockClass: "swiper-scrollbar-lock",
                            dragClass: "swiper-scrollbar-drag",
                            scrollbarDisabledClass: "swiper-scrollbar-disabled",
                            horizontalClass: "swiper-scrollbar-horizontal",
                            verticalClass: "swiper-scrollbar-vertical"
                        }
                    }),
                    t.scrollbar = {
                        el: null,
                        dragEl: null
                    },
                    i("init", ( () => {
                        !1 === t.params.scrollbar.enabled ? x() : (S(),
                        m(),
                        h())
                    }
                    )),
                    i("update resize observerUpdate lock unlock", ( () => {
                        m()
                    }
                    )),
                    i("setTranslate", ( () => {
                        h()
                    }
                    )),
                    i("setTransition", ( (e, s) => {
                        !function(e) {
                            t.params.scrollbar.el && t.scrollbar.el && (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`)
                        }(s)
                    }
                    )),
                    i("enable disable", ( () => {
                        const {el: e} = t.scrollbar;
                        e && e.classList[t.enabled ? "remove" : "add"](t.params.scrollbar.lockClass)
                    }
                    )),
                    i("destroy", ( () => {
                        E()
                    }
                    ));
                    const x = () => {
                        t.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),
                        t.scrollbar.el && t.scrollbar.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),
                        E()
                    }
                    ;
                    Object.assign(t.scrollbar, {
                        enable: () => {
                            t.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),
                            t.scrollbar.el && t.scrollbar.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),
                            S(),
                            m(),
                            h()
                        }
                        ,
                        disable: x,
                        updateSize: m,
                        setTranslate: h,
                        init: S,
                        destroy: E
                    })
                }
                ]
            }
              , Li = new cs(".scroller-section-list",Ti);
            Li.on("touchStart", (function(e) {
                document.body.classList.add("md:overflow-hidden")
            }
            )),
            Li.on("touchEnd", (function(e) {
                document.body.classList.remove("md:overflow-hidden")
            }
            )),
            Li.on("slideChange", (function(e) {
                const {slides: t, realIndex: s, activeIndex: i} = e;
                const n = document.querySelectorAll(".scroller .swiper-slide")[s];
                if (void 0 !== n) {
                    let e = n.hasAttribute("data-mobile-image") ? n.getAttribute("data-mobile-image") : n.hasAttribute("data-image") ? n.getAttribute("data-image") : ""
                      , t = n.getAttribute("data-cat");
                    if (console.log(e.length),
                    document.querySelectorAll(".scroller-image").forEach(( (t, s) => {
                        t.id !== e && Ne(t.querySelector(".scroller-image-media"), {
                            visibility: "hidden",
                            opacity: 0
                        })
                    }
                    )),
                    0 !== s)
                        null !== document.getElementById(e) && Ne(document.getElementById(e).querySelector(".scroller-image-media"), {
                            visibility: "visible",
                            opacity: 1
                        });
                    else {
                        let e;
                        e = null !== document.querySelector(".scroller-image.scroller-image--mobile[data-index='1']") ? document.querySelector(".scroller-image.scroller-image--mobile[data-index='1']") : document.querySelectorAll(".scroller-image[data-index='1']")[0]
                    }
                    document.querySelectorAll("#swiper-cats > div").forEach(( (e, s) => {
                        e !== document.getElementById(`swiper-cat-${t}`) && Ne(e.children[0], {
                            opacity: .3
                        })
                    }
                    )),
                    null !== document.getElementById(`swiper-cat-${t}`) && Ne(document.getElementById(`swiper-cat-${t}`).children[0], {
                        opacity: 1
                    })
                }
            }
            )),
            document.querySelectorAll("#swiper-cats > div").forEach(( (e, t) => {
                e.addEventListener("click", (t => {
                    t.preventDefault();
                    let s = e.id.split("cat-")[1];
                    if (null !== document.querySelector(`.swiper-slide[data-cat="${s}"]`)) {
                        let e = (e => {
                            for (var t = e.parentNode.childNodes, s = 0, i = 0; i < t.length; i++) {
                                if (t[i] == e)
                                    return s;
                                1 == t[i].nodeType && s++
                            }
                            return -1
                        }
                        )(document.querySelectorAll(`.swiper-slide[data-cat="${s}"]`)[0]);
                        Li.slideTo(e)
                    }
                }
                ))
            }
            ))
        }
        const Ls = document.getElementById("search-trigger")
          , As = document.getElementById("search-bar");
        if (window.searchBarActive = !1,
        null !== As && null !== Ls) {
            const Ai = document.querySelector("header")
              , Ci = document.getElementById("search-bar-form")
              , ki = As.querySelector("input");
            Ls.addEventListener("click", ( () => {
                Ai.offsetHeight;
                if (window.searchBarActive = !window.searchBarActive,
                Ls.querySelectorAll("svg").forEach((e => {
                    e.classList.toggle("invisible")
                }
                )),
                window.searchBarActive) {
                    As.classList.remove("hidden"),
                    Ai.querySelector(".header__bar").classList.add("backdrop-blur-md"),
                    Ne(As, {
                        y: ["-100%", "0"],
                        opacity: ["0", "1"]
                    }, {
                        duration: .3
                    }),
                    Ne(Ci, {
                        opacity: ["0", "1"]
                    }, {
                        duration: .75,
                        delay: .45,
                        easing: [.25, 1, .5, 1]
                    });
                    const e = document.createElement("input");
                    e.setAttribute("type", "text"),
                    e.style.display = "none",
                    e.style.position = "absolute",
                    e.style.opacity = 0,
                    e.style.height = 0,
                    e.style.fontSize = "16px",
                    document.querySelector("main").append(e),
                    e.focus(),
                    setTimeout(( () => {
                        As.classList.add("!z-20"),
                        ki.focus(),
                        e.remove()
                    }
                    ), 300)
                } else
                    Ai.querySelector(".header__bar").classList.remove("backdrop-blur-md"),
                    As.classList.remove("!z-20"),
                    Ne(As, {
                        y: ["0", "-100%"],
                        opacity: ["1", "0"]
                    }, {
                        duration: .3
                    }),
                    Ne(Ci, {
                        opacity: ["1", "0"]
                    }, {
                        duration: .75,
                        delay: .45,
                        easing: [.25, 1, .5, 1]
                    }),
                    setTimeout(( () => {
                        As.classList.add("hidden")
                    }
                    ), 300)
            }
            ))
        }
        s(372);
        var Cs = s(130);
        const ks = document.querySelector(".header")
          , qs = ks.querySelector("nav")
          , Ms = document.querySelector(".header__bar")
          , Os = Ms.querySelector("a[data-child-menu]")
          , _s = document.querySelector(".header__ecom-menus")
          , Ps = document.getElementById("hamburger")
          , Is = document.getElementById("mobile-ecom-menu")
          , $s = document.getElementById("mobile-ecom-search-trigger")
          , Bs = document.getElementById("mobile-ecom-search-menu")
          , Ds = document.querySelector(".hamburger-close")
          , Ns = document.querySelector(".announcement-bar")
          , zs = document.getElementById("search-bar")
          , Fs = document.getElementById("search-bar-form")
          , Hs = document.getElementById("search-trigger");
        let Rs, Gs = Ms.offsetHeight;
        window.navOpen = !1,
        Ps.addEventListener("click", ( () => {
            window.navOpen = !window.navOpen,
            window.navOpen ? ((0,
            Cs.disablePageScroll)(),
            null !== Is && (Is.style.display = "block"),
            null !== Bs && (Bs.style.display = "none"),
            null !== Ds && (Ds.style.left = "1.5rem",
            Ds.style.top = "3rem"),
            null !== zs && null !== Hs && (location.pathname.includes("search") || (window.searchBarActive = !1,
            Hs.querySelectorAll("svg")[0].classList.remove("invisible"),
            Hs.querySelectorAll("svg")[1].classList.add("invisible"),
            ks.querySelector(".header__bar").classList.remove("backdrop-blur-md"),
            Ne(zs, {
                y: ["0", "-100%"],
                opacity: ["1", "0"]
            }, {
                duration: .3
            }),
            Ne(Fs, {
                opacity: ["1", "0"]
            }, {
                duration: .75,
                delay: .45,
                easing: [.25, 1, .5, 1]
            }),
            setTimeout(( () => {
                zs.classList.add("hidden")
            }
            ), 300))),
            null !== Is ? Ne(Is.children, {
                y: ["24px", "0%"],
                opacity: ["0", "1"]
            }, {
                duration: .75,
                easing: [.25, 1, .5, 1],
                delay: Pe(.1)
            }) : setTimeout(( () => {
                Ne("nav li", {
                    y: ["24px", "0"],
                    opacity: ["0", "1"]
                }, {
                    duration: .75,
                    easing: [.25, 1, .5, 1],
                    delay: Pe(.1)
                }),
                Ps.style.pointerEvents = "auto"
            }
            ), 200),
            setTimeout(( () => {
                Ps.style.pointerEvents = "auto"
            }
            ), 200),
            Ps.classList.add("active"),
            qs.classList.remove("opacity-0"),
            qs.classList.remove("translate-y-full"),
            qs.style.pointerEvents = "auto",
            Ps.style.pointerEvents = "none",
            ks.classList.add("nav-open")) : (ks.classList.remove("nav-open"),
            Ps.classList.remove("active"),
            qs.classList.add("translate-y-full"),
            (0,
            Cs.enablePageScroll)(),
            setTimeout(( () => {
                Ps.style.pointerEvents = "auto",
                qs.style.pointerEvents = "none",
                qs.classList.add("opacity-0")
            }
            ), 200))
        }
        )),
        null !== $s && $s.addEventListener("click", (e => {
            if (e.preventDefault(),
            window.navOpen = !1,
            (0,
            Cs.disablePageScroll)(),
            Is.style.display = "none",
            Bs.style.display = "block",
            Ds.style.left = "calc(100% - 2rem)",
            Ds.style.top = "2.25rem",
            qs.classList.remove("opacity-0"),
            qs.classList.remove("translate-y-full"),
            qs.style.pointerEvents = "auto",
            Ps.style.pointerEvents = "none",
            ks.classList.add("nav-open"),
            Ne(Bs.children, {
                y: ["100%", "0%"],
                opacity: ["0", "1"]
            }, {
                duration: .75,
                easing: [.25, 1, .5, 1],
                delay: Pe(.1)
            }),
            null !== Bs.querySelector("[type='search']")) {
                const e = document.createElement("input");
                e.setAttribute("type", "text"),
                e.style.display = "none",
                e.style.position = "absolute",
                e.style.opacity = 0,
                e.style.height = 0,
                e.style.fontSize = "16px",
                document.querySelector("main").append(e),
                e.focus(),
                setTimeout(( () => {
                    Bs.querySelector("[type='search']").focus(),
                    e.remove()
                }
                ), 300)
            }
        }
        )),
        null !== Ds && Ds.addEventListener("click", ( () => {
            window.navOpen = !1,
            ks.classList.remove("nav-open"),
            Ps.classList.remove("active"),
            qs.classList.add("translate-y-full"),
            (0,
            Cs.enablePageScroll)(),
            setTimeout(( () => {
                Ps.style.pointerEvents = "auto",
                qs.style.pointerEvents = "none",
                qs.classList.add("opacity-0")
            }
            ), 200)
        }
        )),
        null !== Os && Ms.querySelectorAll("a[data-child-menu]").forEach((e => {
            e.addEventListener("mouseenter", (t => {
                t.preventDefault(),
                null !== document.getElementById("newsletter-popup") && document.getElementById("newsletter-popup").classList.remove("active");
                const s = e.getAttribute("data-child-menu");
                document.querySelectorAll("ul[data-child-menu]").forEach((e => {
                    e.getAttribute("data-child-menu") !== s && e.classList.add("invisible")
                }
                )),
                document.querySelector(`ul[data-child-menu="${s}"]`).classList.remove("invisible"),
                ks.classList.add("child-nav-open"),
                document.body.classList.add("child-nav-open"),
                Ms.querySelectorAll("a[data-child-menu]").forEach((t => {
                    t !== e && t.classList.remove("after:bg-navy")
                }
                )),
                e.classList.add("after:bg-navy");
                let i = document.querySelector(`ul[data-child-menu="${s}"]`).clientHeight;
                if (document.querySelector(".header__ecom-menus").style.pointerEvents = "auto",
                document.querySelector(".header__ecom-menus").classList.remove("opacity-0"),
                document.querySelector(".header__ecom-menus").style.minHeight = i + "px",
                document.querySelector(".header__ecom-menus-wrapper").style.minHeight = i + "px",
                document.querySelector(`ul[data-child-menu="${s}"]`).classList.contains("active") || setTimeout(( () => {
                    Ne(`ul[data-child-menu="${s}"] li`, {
                        y: ["24px", "0"],
                        opacity: ["0", "1"]
                    }, {
                        duration: .75,
                        easing: [.25, 1, .5, 1],
                        delay: Pe(.1)
                    }),
                    document.querySelector(`ul[data-child-menu="${s}"]`).classList.add("active")
                }
                ), 150),
                null !== document.querySelector(`ul[data-child-menu="${s}"] [type='search']`)) {
                    const e = document.createElement("input");
                    e.setAttribute("type", "text"),
                    e.style.display = "none",
                    e.style.position = "absolute",
                    e.style.opacity = 0,
                    e.style.height = 0,
                    e.style.fontSize = "16px",
                    document.querySelector("main").append(e),
                    e.focus(),
                    setTimeout(( () => {
                        document.querySelector(`ul[data-child-menu="${s}"] [type='search']`).focus(),
                        e.remove()
                    }
                    ), 300)
                }
            }
            ))
        }
        )),
        null !== _s && document.querySelector("main").addEventListener("mouseenter", ( () => {
            null !== document.getElementById("newsletter-popup") && document.getElementById("newsletter-popup").classList.remove("active"),
            ks.classList.contains("child-nav-open") && (Ne("ul[data-child-menu] li", {
                y: ["0%", "100%"],
                opacity: ["1", "0"]
            }, {
                duration: .75,
                easing: [.25, 1, .5, 1],
                delay: Pe(.1)
            }),
            Ms.querySelectorAll("a[data-child-menu]").forEach((e => {
                e.classList.remove("after:bg-navy")
            }
            )),
            setTimeout(( () => {
                document.querySelectorAll("ul[data-child-menu]").forEach((e => {
                    e.classList.add("invisible"),
                    e.classList.remove("active")
                }
                )),
                ks.classList.remove("child-nav-open"),
                document.body.classList.remove("child-nav-open"),
                document.querySelector(".header__ecom-menus").style.pointerEvents = "none",
                document.querySelector(".header__ecom-menus").classList.add("opacity-0")
            }
            ), 150))
        }
        ));
        const js = () => {
            Gs = ks.offsetHeight,
            document.querySelectorAll(".header__menu .toggle-trigger").forEach((e => {
                e.classList.remove("active")
            }
            )),
            document.documentElement.style.setProperty("--header-height", Gs + "px"),
            document.documentElement.style.setProperty("--mobile-header-height", Gs + "px"),
            null !== Ns ? (Rs = Ns.offsetHeight,
            document.documentElement.style.setProperty("--announcement-bar-height", Rs + "px")) : (Rs = 0,
            document.documentElement.style.setProperty("--announcement-bar-height", "0px")),
            (0,
            Cs.enablePageScroll)(),
            window.navOpen = !1,
            ks.classList.remove("nav-open"),
            Ps.classList.remove("active"),
            Ps.style.pointerEvents = "auto",
            qs.style.pointerEvents = "none",
            Ms.querySelectorAll("a[data-child-menu]").forEach((e => {
                e.classList.remove("after:bg-navy")
            }
            ))
        }
          , Vs = () => {
            scrollY < Gs ? Rs > 0 ? scrollY < Rs ? (ks.classList.remove("swiped-down"),
            document.body.classList.remove("swiped-down"),
            document.documentElement.style.setProperty("--announcement-bar-offset", Rs - scrollY + "px")) : (ks.classList.add("swiped-down"),
            document.body.classList.add("swiped-down"),
            document.documentElement.style.setProperty("--announcement-bar-offset", "0px")) : (ks.classList.remove("swiped-down"),
            document.body.classList.remove("swiped-down"),
            document.documentElement.style.setProperty("--announcement-bar-offset", "0px")) : (ks.classList.add("swiped-down"),
            document.body.classList.add("swiped-down"),
            document.documentElement.style.setProperty("--announcement-bar-offset", "0px")),
            null !== _s && ks.classList.contains("child-nav-open") && (Ne("ul[data-child-menu] li", {
                y: ["0%", "24px"],
                opacity: ["1", "0"]
            }, {
                duration: .75,
                easing: [.25, 1, .5, 1],
                delay: Pe(.1)
            }),
            setTimeout(( () => {
                document.querySelectorAll("ul[data-child-menu]").forEach((e => {
                    e.classList.add("invisible"),
                    e.classList.remove("active")
                }
                )),
                ks.classList.remove("child-nav-open"),
                document.body.classList.remove("child-nav-open"),
                document.querySelector(".header__ecom-menus").style.pointerEvents = "none",
                document.querySelector(".header__ecom-menus").classList.add("opacity-0")
            }
            ), 200),
            Ms.querySelectorAll("a[data-child-menu]").forEach((e => {
                e.classList.remove("after:bg-navy")
            }
            )))
        }
        ;
        js(),
        Vs(),
        window.addEventListener("resize", ( () => {
            js(),
            Vs()
        }
        ), {
            passive: !0
        }),
        window.addEventListener("scroll", Vs, {
            passive: !0
        }),
        window.enablePageScroll = Cs.enablePageScroll,
        window.disablePageScroll = Cs.disablePageScroll;
        s(232);
        const Ws = (e, t) => {
            var s;
            "createEvent"in document ? ((s = document.createEvent("HTMLEvents")).initEvent(t, !1, !0),
            e.dispatchEvent(s)) : ((s = document.createEventObject()).eventType = t,
            e.fireEvent("on" + s.eventType, s))
        }
          , Ys = document.getElementById("add-to-cart")
          , Xs = document.getElementById("add")
          , Us = document.getElementById("sticky-add")
          , Ks = document.getElementById("minus")
          , Js = document.getElementById("quantity")
          , Qs = document.getElementById("plus");
        if (null !== Ys) {
            const qi = Ys.getAttribute("data-product-handle");
            let Mi;
            Ks.addEventListener("click", ( () => {
                let e, t = parseInt(Js.value);
                t > 1 && (e = t - 1,
                Js.value = e)
            }
            )),
            Qs.addEventListener("click", ( () => {
                let e;
                e = parseInt(Js.value) + 1,
                Js.value = e
            }
            )),
            fetch(`/products/${qi}.json`, {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "xmlhttprequest"
                }
            }).then((e => e.json())).then((e => {
                Mi = e.product,
                fetch(`https://api.okendo.io/v1/stores/6893103e-ea5d-4384-bae3-f7e5316b9206/products/shopify-${Mi.id}/review_aggregate`).then((e => e.json())).then((e => {
                    const {reviewAggregate: t} = e;
                    console.log(t);
                    const s = document.getElementById("reviews")
                      , i = document.getElementById("stars-fg")
                      , n = document.getElementById("reviews-content");
                    t.ratingAndReviewCount > 0 && (s.style.opacity = 1);
                    const a = ( (e, t) => {
                        if (void 0 === e || 0 === t)
                            return console.log("No reviews to calculate recommended percent."),
                            0;
                        return e / t * 100
                    }
                    )(t.recommendationCount, t.reviewCount)
                      , r = (e => {
                        const t = Object.keys(e).reduce(( (t, s) => t + e[s]), 0);
                        if (0 === Object.keys(e).length)
                            return console.log("No reviews to calculate average star rating."),
                            0;
                        return Object.keys(e).reduce(( (t, s) => t + parseInt(s.replace("level", ""), 10) * e[s]), 0) / t
                    }
                    )(t.ratingAndReviewCountByLevel)
                      , o = (e => {
                        const t = Object.keys(e).reduce(( (t, s) => t + e[s]), 0);
                        if (0 === t)
                            return console.log("No reviews to calculate rating percentage."),
                            0;
                        return Object.keys(e).reduce(( (t, s) => t + parseInt(s.replace("level", ""), 10) * e[s]), 0) / (5 * t) * 100
                    }
                    )(t.ratingAndReviewCountByLevel, t.reviewCount);
                    console.log(`Recommended Percent: ${a}%`),
                    console.log(`Average Star Rating: ${r}`),
                    console.log(`Average Star Rating Percent: ${o}%`),
                    i.style.clipPath = `polygon(0 0, ${o}% 0, ${o}% 100%, 0% 100%)`,
                    n.innerHTML = `\n\t\t\t\t<span class="xl:hidden">(${r.toFixed(1)})</span>\n\t\t\t\t<span>${t.ratingAndReviewCount > 1 ? `${t.ratingAndReviewCount} Reviews` : `${t.ratingAndReviewCount} Review`}</span>\n\t\t\t`;
                }
                ));
                const t = new cs(".product-main .swiper-thumbs",{
                    spaceBetween: 16,
                    slidesPerView: "auto",
                    mousewheel: {
                        forceToAxis: !0
                    },
                    freeMode: !0,
                    loop: !1,
                    direction: "vertical",
                    watchSlidesProgress: !0,
                    modules: [fs, ds, bs]
                })
                  , s = new cs(".product-main .swiper-main",{
                    loop: !1,
                    effect: !1,
                    fadeEffect: !1,
                    slidesPerView: 1.03,
                    slidesPerGroup: 1.03,
                    freeMode: !0,
                    thumbs: {
                        swiper: t
                    },
                    mousewheel: {
                        forceToAxis: !0
                    },
                    modules: [ds, Es, ys, bs],
                    breakpoints: {
                        1025: {
                            effect: "fade",
                            fadeEffect: {
                                crossFade: !0
                            },
                            freeMode: !1,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                        }
                    }
                })
                  , sMobile = new cs(".product-main .swiper-main-mobile",{
                    loop: !1,
                    effect: !1,
                    fadeEffect: !1,
                    slidesPerView: 1.03,
                    slidesPerGroup: 1,
                    freeMode: !0,
                    mousewheel: {
                        forceToAxis: !0
                    },
                    modules: [ds, Es, bs]
                })
                  , i = document.getElementById("product-select");
                i && i.addEventListener("change", (function() {
                    const e = this.value
                      , i = document.getElementById("variant-slide-" + e)
                      , mobileVariantSlide = document.getElementById("mobile-variant-slide-" + e);
                    if (i) {
                        const e = Array.from(i.parentNode.children).indexOf(i);
                        s.slideTo(e),
                        t.slideTo(e)
                    } else {
                        s.slideTo(0),
                        t.slideTo(0)
                    }
                    if (mobileVariantSlide) {
                        const e = Array.from(mobileVariantSlide.parentNode.children).indexOf(mobileVariantSlide);
                        sMobile.slideTo(e)
                    } else {
                        sMobile.slideTo(0)
                    }
                }
                ));
                new Shopify.OptionSelectors("product-select",{
                    product: Mi,
                    onVariantSelected: function (e, t) {
                        console.log('onVariantSelected');
                        if (window.Shopify.variant = e,
                        e) {
                                const body = document.querySelector("body");
                                if (!body) return; 

                                const s = body.getAttribute("data-currency-symbol") || "$";
                                const variantEl = document.getElementById(`variant-${e.id}`);
                                if (!variantEl) return; 

                                const qtyAttr = variantEl.getAttribute("data-qty");
                                const qty = Number(qtyAttr) || 0;

                                if (!Xs || !Xs.querySelectorAll) return; 

                                const XsSpans = Xs.querySelectorAll("span");
                                const UsSpans = Us && Us.querySelectorAll ? Us.querySelectorAll("span") : null;

                                if (qty > 0) {

                                    if (Xs) Xs.onclick = null;
                                    if (Us) Us.onclick = null;

                                    if (XsSpans[0]) XsSpans[0].textContent = "Add to cart";
                                    if (XsSpans[1]) {
                                    XsSpans[1].textContent = `- ${Shopify.formatMoney(e.price).replace("$", s).split(".")[0]}`;
                                    XsSpans[1].style.display = "inline-block";
                                    }

                                    if (UsSpans && UsSpans[0] && UsSpans[1]) {
                                    UsSpans[0].textContent = "Add to cart -";
                                    UsSpans[1].textContent = `${Shopify.formatMoney(e.price).replace("$", s).replace(".00", "")}`;
                                    UsSpans[1].style.display = "inline-block";
                                    }
                                } else {
                                    if (XsSpans[0]) XsSpans[0].textContent = "Join the waitlist";
                                    if (XsSpans[1]) XsSpans[1].style.display = "none";

                                    Xs.onclick = s => {
                                    s.preventDefault();
                                    if (window.openKlaviyoBISPopup)
                                        window.openKlaviyoBISPopup(e.id, `${t.product.title}${e.title.includes("Default Title") ? "" : ` - ${e.title}`}`);
                                    Xs.blur();
                                    };

                                    if (UsSpans && UsSpans[0] && UsSpans[1]) {
                                    UsSpans[0].textContent = "Join the waitlist";
                                    UsSpans[1].style.display = "none";
                                    Us.onclick = s => {
                                        s.preventDefault();
                                        if (window.openKlaviyoBISPopup)
                                        window.openKlaviyoBISPopup(e.id, `${t.product.title}${e.title.includes("Default Title") ? "" : ` - ${e.title}`}`);
                                        Us.blur();
                                    };
                                    }
                                }
                            }
                    },
                    enableHistoryState: !0
                }),
                null !== document.querySelector(".option-selector__group") && document.querySelectorAll(".option-selector__group").forEach((e => {
                    const t = e.getAttribute("data-group-option");
                    e.querySelectorAll(".option-selector__radio").forEach((s => {
                        s.addEventListener("click", ( () => {
                            const {value: i} = s;
                            e.querySelectorAll(".option-selector__button").forEach((e => {
                                e.classList.remove("active");
                            }
                            ));
                            s.parentElement.classList.add("active");
                            document.getElementById(`product-select-option-${t}`).value = i;
                            Ws(document.getElementById(`product-select-option-${t}`), "change");
                            document.getElementById("product-select").value = window.Shopify.variant.id;
                            Ws(document.getElementById("product-select"), "change");
                        }
                        ))
                    }
                    ))
                }
                ))
            }
            ))
        }

        var Zs = s(76)
          , ei = s.n(Zs);

        const si = document.querySelectorAll("select.custom-select");
        null !== document.querySelector(".product-card__details") && document.body.classList.add("has-product-cards"),
        si.forEach((e => {
            if (e.id) {
                let t = e.hasAttribute("data-position") ? e.getAttribute("data-position") : "auto"
                  , s = null !== document.querySelector(".product-card__details") ? {
                    showSearch: !1,
                    openPosition: t,
                    contentLocation: document.getElementById(e.id).closest(".product-card__details"),
                    closeOnSelect: !1
                } : {
                    showSearch: !1,
                    openPosition: t
                };
                new (Ts())({
                    select: `#${e.id}`,
                    settings: s,
                    events: {
                        beforeOpen: () => {
                            let t = document.querySelector(".custom-select[aria-expanded='true']");
                            if (null !== t) {
                                let e = t.id;
                                const s = document.querySelector(`[data-id="${e}"]`).id;
                                document.querySelector(`.ss-content.custom-select[data-id="${e}"]`).setAttribute("data-dropdown-id", s)
                            }
                            if (null !== document.querySelector(".product-card__details")) {
                                document.getElementById(e.id).nextElementSibling.getAttribute("data-id");
                                document.getElementById(e.id).closest(".product-card__details").classList.add("dropdown-open")
                            }
                        }
                        ,
                        afterChange: t => {
                            const s = t[0];
                            if (s.html.includes("href")) {
                                const e = (new DOMParser).parseFromString(s.html, "text/html")
                                  , {href: t} = e.querySelector("a");
                                t.length > 1 && location.replace(t)
                            }
                            if (null !== document.querySelector(".product-card__details")) {
                                const t = (new DOMParser).parseFromString(s.html, "text/html").body;
                                null !== t && (null !== t.querySelector("[data-available]") && "false" === t.querySelector("[data-available]").getAttribute("data-available") ? (document.getElementById(e.id).closest(".product-card__details").querySelector(".button span").textContent = "Join the waitlist",
                                document.getElementById(e.id).closest(".product-card__details").querySelector(".button span").style.marginRight = "20px",
                                document.getElementById(e.id).closest(".product-card__details").querySelector(".button").onclick = e => {
                                    e.preventDefault(),
                                    window.openKlaviyoBISPopup(s.value, `${s.text}`)
                                }
                                ) : null !== document.getElementById(e.id) && null !== document.getElementById(e.id).closest(".product-card__details") && (document.getElementById(e.id).closest(".product-card__details").querySelector(".button span").textContent = "Add to cart",
                                document.getElementById(e.id).closest(".product-card__details").querySelector(".button span").style.marginRight = "0px"
                                ))
                            }
                        }
                        ,
                        beforeClose: () => {
                            null !== document.querySelector(".product-card__details") && document.querySelectorAll(".product-card__details").forEach((e => {
                                e.classList.remove("dropdown-open")
                            }
                            ))
                        }
                    }
                });
                if (null !== document.querySelector(".product-card__details") && null !== document.getElementById(e.id)) {
                    const t = document.getElementById(e.id).closest(".product-card");
                    null !== t && (t.onmouseleave = () => {
                        t.querySelector(".ss-main").setAttribute("aria-expanded", !1),
                        t.querySelector(".ss-main").classList.add("ss-locked-closed")
                    }
                    ,
                    t.onmouseenter = () => {
                        t.querySelector(".ss-main").classList.remove("ss-locked-closed"),
                        t.querySelector(".ss-content").classList.contains("ss-open-below") ? t.querySelector(".product-card__details").classList.add("dropdown-open") : t.querySelector(".product-card__details").classList.remove("!dropdown-open")
                    }
                    ,
                    t.querySelector(".ss-main").addEventListener("click", ( () => {
                        t.querySelector(".product-card__details").classList.add("!dropdown-open")
                    }
                    )))
                }
            }
        }
        ));
        s(66)
    }
    )()
}
)();


// Custom Js 
function updateGalleryOffset() {
  const gallery = document.querySelector('.product-gallery-main');
  if (!gallery) return;

  const isDesktop = window.innerWidth > 1024;

    //   Desktop Condition
  if (!isDesktop) {
    gallery.style.top = '';
    gallery.style.height = '';
    gallery._lastTop = null;
    return;
  }

  const banner = document.querySelector('.announcement-bar');
  const header = document.querySelector('.header__bar');

  const headerHeight = header ? header.offsetHeight : 0;
  const bannerHeight = banner ? banner.offsetHeight : 0;

  let bannerVisible = false;
  if (banner) {
    const rect = banner.getBoundingClientRect();
    bannerVisible = rect.bottom > headerHeight;
  }

  const totalHeight = headerHeight + (bannerVisible ? bannerHeight : 0);

  if (gallery._lastTop !== totalHeight) {
    gallery._lastTop = totalHeight;

    gallery.style.top = totalHeight + 'px';
    gallery.style.height = `calc(100vh - ${totalHeight}px)`;
  }
}

// Run once
document.addEventListener('DOMContentLoaded', updateGalleryOffset);

// Scroll
window.addEventListener('scroll', updateGalleryOffset, { passive: true });

// Resize
window.addEventListener('resize', updateGalleryOffset);